var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
function src_default$1(Alpine2) {
  let persist = () => {
    let alias;
    let storage;
    try {
      storage = localStorage;
    } catch (e) {
      console.error(e);
      console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
      let dummy = /* @__PURE__ */ new Map();
      storage = {
        getItem: dummy.get.bind(dummy),
        setItem: dummy.set.bind(dummy)
      };
    }
    return Alpine2.interceptor((initialValue, getter, setter, path, key) => {
      let lookup = alias || `_x_${path}`;
      let initial = storageHas(lookup, storage) ? storageGet(lookup, storage) : initialValue;
      setter(initial);
      Alpine2.effect(() => {
        let value = getter();
        storageSet(lookup, value, storage);
        setter(value);
      });
      return initial;
    }, (func) => {
      func.as = (key) => {
        alias = key;
        return func;
      }, func.using = (target) => {
        storage = target;
        return func;
      };
    });
  };
  Object.defineProperty(Alpine2, "$persist", { get: () => persist() });
  Alpine2.magic("persist", persist);
  Alpine2.persist = (key, { get, set }, storage = localStorage) => {
    let initial = storageHas(key, storage) ? storageGet(key, storage) : get();
    set(initial);
    Alpine2.effect(() => {
      let value = get();
      storageSet(key, value, storage);
      set(value);
    });
  };
}
function storageHas(key, storage) {
  return storage.getItem(key) !== null;
}
function storageGet(key, storage) {
  let value = storage.getItem(key, storage);
  if (value === void 0)
    return;
  return JSON.parse(value);
}
function storageSet(key, value, storage) {
  storage.setItem(key, JSON.stringify(value));
}
var module_default$1 = src_default$1;
function morph(from, toHtml, options) {
  monkeyPatchDomSetAttributeToAllowAtSymbols();
  let toEl;
  let key, lookahead, updating, updated, removing, removed, adding, added;
  function assignOptions(options2 = {}) {
    let defaultGetKey = (el) => el.getAttribute("key");
    let noop = () => {
    };
    updating = options2.updating || noop;
    updated = options2.updated || noop;
    removing = options2.removing || noop;
    removed = options2.removed || noop;
    adding = options2.adding || noop;
    added = options2.added || noop;
    key = options2.key || defaultGetKey;
    lookahead = options2.lookahead || false;
  }
  function patch(from2, to) {
    if (differentElementNamesTypesOrKeys(from2, to)) {
      return swapElements(from2, to);
    }
    let updateChildrenOnly = false;
    if (shouldSkip(updating, from2, to, () => updateChildrenOnly = true))
      return;
    if (from2.nodeType === 1 && window.Alpine) {
      window.Alpine.cloneNode(from2, to);
      if (from2._x_teleport && to._x_teleport) {
        patch(from2._x_teleport, to._x_teleport);
      }
    }
    if (textOrComment(to)) {
      patchNodeValue(from2, to);
      updated(from2, to);
      return;
    }
    if (!updateChildrenOnly) {
      patchAttributes(from2, to);
    }
    updated(from2, to);
    patchChildren(from2, to);
  }
  function differentElementNamesTypesOrKeys(from2, to) {
    return from2.nodeType != to.nodeType || from2.nodeName != to.nodeName || getKey(from2) != getKey(to);
  }
  function swapElements(from2, to) {
    if (shouldSkip(removing, from2))
      return;
    let toCloned = to.cloneNode(true);
    if (shouldSkip(adding, toCloned))
      return;
    from2.replaceWith(toCloned);
    removed(from2);
    added(toCloned);
  }
  function patchNodeValue(from2, to) {
    let value = to.nodeValue;
    if (from2.nodeValue !== value) {
      from2.nodeValue = value;
    }
  }
  function patchAttributes(from2, to) {
    if (from2._x_transitioning)
      return;
    if (from2._x_isShown && !to._x_isShown) {
      return;
    }
    if (!from2._x_isShown && to._x_isShown) {
      return;
    }
    let domAttributes = Array.from(from2.attributes);
    let toAttributes = Array.from(to.attributes);
    for (let i = domAttributes.length - 1; i >= 0; i--) {
      let name = domAttributes[i].name;
      if (!to.hasAttribute(name)) {
        from2.removeAttribute(name);
      }
    }
    for (let i = toAttributes.length - 1; i >= 0; i--) {
      let name = toAttributes[i].name;
      let value = toAttributes[i].value;
      if (from2.getAttribute(name) !== value) {
        from2.setAttribute(name, value);
      }
    }
  }
  function patchChildren(from2, to) {
    let fromKeys = keyToMap(from2.children);
    let fromKeyHoldovers = {};
    let currentTo = getFirstNode(to);
    let currentFrom = getFirstNode(from2);
    while (currentTo) {
      seedingMatchingId(currentTo, currentFrom);
      let toKey = getKey(currentTo);
      let fromKey = getKey(currentFrom);
      if (!currentFrom) {
        if (toKey && fromKeyHoldovers[toKey]) {
          let holdover = fromKeyHoldovers[toKey];
          from2.appendChild(holdover);
          currentFrom = holdover;
          fromKey = getKey(currentFrom);
        } else {
          if (!shouldSkip(adding, currentTo)) {
            let clone = currentTo.cloneNode(true);
            from2.appendChild(clone);
            added(clone);
          }
          currentTo = getNextSibling(to, currentTo);
          continue;
        }
      }
      let isIf = (node) => node && node.nodeType === 8 && node.textContent === "[if BLOCK]><![endif]";
      let isEnd = (node) => node && node.nodeType === 8 && node.textContent === "[if ENDBLOCK]><![endif]";
      if (isIf(currentTo) && isIf(currentFrom)) {
        let nestedIfCount = 0;
        let fromBlockStart = currentFrom;
        while (currentFrom) {
          let next = getNextSibling(from2, currentFrom);
          if (isIf(next)) {
            nestedIfCount++;
          } else if (isEnd(next) && nestedIfCount > 0) {
            nestedIfCount--;
          } else if (isEnd(next) && nestedIfCount === 0) {
            currentFrom = next;
            break;
          }
          currentFrom = next;
        }
        let fromBlockEnd = currentFrom;
        nestedIfCount = 0;
        let toBlockStart = currentTo;
        while (currentTo) {
          let next = getNextSibling(to, currentTo);
          if (isIf(next)) {
            nestedIfCount++;
          } else if (isEnd(next) && nestedIfCount > 0) {
            nestedIfCount--;
          } else if (isEnd(next) && nestedIfCount === 0) {
            currentTo = next;
            break;
          }
          currentTo = next;
        }
        let toBlockEnd = currentTo;
        let fromBlock = new Block(fromBlockStart, fromBlockEnd);
        let toBlock = new Block(toBlockStart, toBlockEnd);
        patchChildren(fromBlock, toBlock);
        continue;
      }
      if (currentFrom.nodeType === 1 && lookahead && !currentFrom.isEqualNode(currentTo)) {
        let nextToElementSibling = getNextSibling(to, currentTo);
        let found = false;
        while (!found && nextToElementSibling) {
          if (nextToElementSibling.nodeType === 1 && currentFrom.isEqualNode(nextToElementSibling)) {
            found = true;
            currentFrom = addNodeBefore(from2, currentTo, currentFrom);
            fromKey = getKey(currentFrom);
          }
          nextToElementSibling = getNextSibling(to, nextToElementSibling);
        }
      }
      if (toKey !== fromKey) {
        if (!toKey && fromKey) {
          fromKeyHoldovers[fromKey] = currentFrom;
          currentFrom = addNodeBefore(from2, currentTo, currentFrom);
          fromKeyHoldovers[fromKey].remove();
          currentFrom = getNextSibling(from2, currentFrom);
          currentTo = getNextSibling(to, currentTo);
          continue;
        }
        if (toKey && !fromKey) {
          if (fromKeys[toKey]) {
            currentFrom.replaceWith(fromKeys[toKey]);
            currentFrom = fromKeys[toKey];
            fromKey = getKey(currentFrom);
          }
        }
        if (toKey && fromKey) {
          let fromKeyNode = fromKeys[toKey];
          if (fromKeyNode) {
            fromKeyHoldovers[fromKey] = currentFrom;
            currentFrom.replaceWith(fromKeyNode);
            currentFrom = fromKeyNode;
            fromKey = getKey(currentFrom);
          } else {
            fromKeyHoldovers[fromKey] = currentFrom;
            currentFrom = addNodeBefore(from2, currentTo, currentFrom);
            fromKeyHoldovers[fromKey].remove();
            currentFrom = getNextSibling(from2, currentFrom);
            currentTo = getNextSibling(to, currentTo);
            continue;
          }
        }
      }
      let currentFromNext = currentFrom && getNextSibling(from2, currentFrom);
      patch(currentFrom, currentTo);
      currentTo = currentTo && getNextSibling(to, currentTo);
      currentFrom = currentFromNext;
    }
    let removals = [];
    while (currentFrom) {
      if (!shouldSkip(removing, currentFrom))
        removals.push(currentFrom);
      currentFrom = getNextSibling(from2, currentFrom);
    }
    while (removals.length) {
      let domForRemoval = removals.shift();
      domForRemoval.remove();
      removed(domForRemoval);
    }
  }
  function getKey(el) {
    return el && el.nodeType === 1 && key(el);
  }
  function keyToMap(els) {
    let map = {};
    for (let el of els) {
      let theKey = getKey(el);
      if (theKey) {
        map[theKey] = el;
      }
    }
    return map;
  }
  function addNodeBefore(parent, node, beforeMe) {
    if (!shouldSkip(adding, node)) {
      let clone = node.cloneNode(true);
      parent.insertBefore(clone, beforeMe);
      added(clone);
      return clone;
    }
    return node;
  }
  assignOptions(options);
  toEl = typeof toHtml === "string" ? createElement(toHtml) : toHtml;
  if (window.Alpine && window.Alpine.closestDataStack && !from._x_dataStack) {
    toEl._x_dataStack = window.Alpine.closestDataStack(from);
    toEl._x_dataStack && window.Alpine.cloneNode(from, toEl);
  }
  patch(from, toEl);
  toEl = void 0;
  return from;
}
morph.step = () => {
};
morph.log = () => {
};
function shouldSkip(hook, ...args) {
  let skip = false;
  hook(...args, () => skip = true);
  return skip;
}
var patched = false;
function createElement(html) {
  const template = document.createElement("template");
  template.innerHTML = html;
  return template.content.firstElementChild;
}
function textOrComment(el) {
  return el.nodeType === 3 || el.nodeType === 8;
}
var Block = class {
  constructor(start, end) {
    this.startComment = start;
    this.endComment = end;
  }
  get children() {
    let children = [];
    let currentNode = this.startComment.nextSibling;
    while (currentNode && currentNode !== this.endComment) {
      children.push(currentNode);
      currentNode = currentNode.nextSibling;
    }
    return children;
  }
  appendChild(child) {
    this.endComment.before(child);
  }
  get firstChild() {
    let first = this.startComment.nextSibling;
    if (first === this.endComment)
      return;
    return first;
  }
  nextNode(reference) {
    let next = reference.nextSibling;
    if (next === this.endComment)
      return;
    return next;
  }
  insertBefore(newNode, reference) {
    reference.before(newNode);
    return newNode;
  }
};
function getFirstNode(parent) {
  return parent.firstChild;
}
function getNextSibling(parent, reference) {
  let next;
  if (parent instanceof Block) {
    next = parent.nextNode(reference);
  } else {
    next = reference.nextSibling;
  }
  return next;
}
function monkeyPatchDomSetAttributeToAllowAtSymbols() {
  if (patched)
    return;
  patched = true;
  let original = Element.prototype.setAttribute;
  let hostDiv = document.createElement("div");
  Element.prototype.setAttribute = function newSetAttribute(name, value) {
    if (!name.includes("@")) {
      return original.call(this, name, value);
    }
    hostDiv.innerHTML = `<span ${name}="${value}"></span>`;
    let attr = hostDiv.firstElementChild.getAttributeNode(name);
    hostDiv.firstElementChild.removeAttributeNode(attr);
    this.setAttributeNode(attr);
  };
}
function seedingMatchingId(to, from) {
  let fromId = from && from._x_bindings && from._x_bindings.id;
  if (!fromId)
    return;
  if (!to.setAttribute)
    return;
  to.setAttribute("id", fromId);
  to.id = fromId;
}
function src_default(Alpine2) {
  Alpine2.morph = morph;
}
var module_default = src_default;
function initTransitionView() {
  window.addEventListener("beforeunload", (_event) => {
    sessionStorage.setItem("scrollPosition", `${window.scrollY}`);
  });
  let persisted;
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      persisted = true;
      const scrollPosition = sessionStorage.getItem("scrollPosition");
      if (scrollPosition && parseInt(scrollPosition) > 0) {
        window.scrollTo(0, parseInt(scrollPosition));
      }
    }
  });
  window.addEventListener("pagereveal", (event) => {
    const isReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!persisted && event.viewTransition && !isReducedMotion) {
      const elementRect = sessionStorage.getItem("elementRect");
      const elementHtml = sessionStorage.getItem("elementHtml");
      const destKey = sessionStorage.getItem("destKey");
      const isMobile2 = window.matchMedia("(max-width: 767px)").matches;
      if (!elementRect || !elementHtml || !destKey) {
        if (isMobile2) {
          document.body.classList.add("transition-view");
        }
        return;
      }
      if (isMobile2) {
        document.body.style.overflow = "hidden";
        const wrapper = document.createElement("div");
        wrapper.style.cssText = "position: absolute; inset: 0; background: var(--color-background-500); z-index: 30; transition: opacity .3s; pointer-events: none;";
        const rect = JSON.parse(elementRect);
        const child = document.createElement("div");
        child.innerHTML = elementHtml;
        child.style.cssText = `position: absolute; top: ${rect.top}px; left: ${rect.left}px; width: ${rect.width}px; height: ${rect.height}px; transition: transform .3s; transform-origin: top left`;
        wrapper.appendChild(child);
        document.body.appendChild(wrapper);
        const interval = setInterval(() => {
          const destEl = document.querySelector(`[x-element-transition-dest="${isMobile2 ? "mobile" : "desktop"}-${destKey}"]`) || document.querySelector(`[x-element-transition-dest="${destKey}"]`);
          if (!destEl) {
            return;
          }
          const { top: tt, left: tl, width: tw, height: th } = destEl.getBoundingClientRect();
          child.style.transform = `translate3d(${tl - rect.left}px, ${tt - rect.top}px, 0) scale(${tw / rect.width}, ${th / rect.height})`;
          child.ontransitionend = () => {
            wrapper.style.opacity = "0";
          };
          clearInterval(interval);
        }, 100);
      }
    }
    sessionStorage.removeItem("elementRect");
    sessionStorage.removeItem("elementHtml");
    sessionStorage.removeItem("destKey");
    document.body.style.overflow = "";
    document.body.classList.remove("transition-view");
  });
}
const ESC_KEY = "Escape";
const TAB_KEY = "Tab";
const ARROW_UP_KEY = "ArrowUp";
const ARROW_DOWN_KEY = "ArrowDown";
const ARROW_RIGHT_KEY = "ArrowRight";
const ARROW_LEFT_KEY = "ArrowLeft";
const isMobile = () => {
  return window.matchMedia("(max-width: 767px)").matches;
};
const isTablet = () => {
  return window.matchMedia("(min-width: 768px) and (max-width: 1023px)").matches;
};
let globalTargetElement = null;
let isDocumentFreezed = false;
function onDocumentTouchMove(e) {
  if (e.target instanceof HTMLInputElement && e.target.type === "range") {
    return;
  }
  e.preventDefault();
}
function onElementTouchMove(e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
}
function onDocumentArrowKeys(e) {
  if (e.key === ARROW_DOWN_KEY || e.key === ARROW_UP_KEY) {
    e.preventDefault();
  }
}
function onElementArrowKeys(e) {
  if (e.key === ARROW_DOWN_KEY || e.key === ARROW_UP_KEY) {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}
const freezeScroll = () => {
  if (!isDocumentFreezed) {
    document.addEventListener("touchmove", onDocumentTouchMove, {
      passive: false
    });
    document.addEventListener("wheel", onDocumentTouchMove, {
      passive: false
    });
    document.addEventListener("keydown", onDocumentArrowKeys, {
      passive: false
    });
    document.body.style.overflow = "hidden";
    isDocumentFreezed = true;
  }
};
const makeElementScrollable = (targetElement) => {
  if (targetElement && targetElement !== globalTargetElement) {
    globalTargetElement = targetElement;
    globalTargetElement.addEventListener("keydown", onElementArrowKeys);
    globalTargetElement.addEventListener("touchmove", onElementTouchMove);
    globalTargetElement.addEventListener("wheel", onElementTouchMove);
    globalTargetElement.style.setProperty(
      "-webkit-overflow-scrolling",
      "touch"
    );
  }
};
const makeElementNotScrollable = () => {
  if (globalTargetElement) {
    globalTargetElement.removeEventListener("keydown", onElementArrowKeys);
    globalTargetElement.removeEventListener("touchmove", onElementTouchMove);
    globalTargetElement.removeEventListener("wheel", onElementTouchMove);
    globalTargetElement.style.removeProperty("-webkit-overflow-scrolling");
    globalTargetElement = null;
  }
};
const unfreezeScroll = () => {
  if (isDocumentFreezed) {
    document.removeEventListener("keydown", onDocumentArrowKeys);
    document.removeEventListener("touchmove", onDocumentTouchMove);
    document.removeEventListener("wheel", onDocumentTouchMove);
    isDocumentFreezed = false;
    document.body.style.overflow = "";
  }
  makeElementNotScrollable();
};
const doElementTransitionFromSrcToDest = async ({
  srcElem,
  destElementCallback,
  transitionContainer,
  isCopyCssProperties = false
}) => {
  var _a;
  if (!srcElem || !destElementCallback) {
    return;
  }
  const {
    top: st,
    left: sl,
    width: sw,
    height: sh
  } = srcElem.getBoundingClientRect();
  const clonedElement = srcElem.cloneNode(true);
  const skipEl = clonedElement.querySelector(
    "[x-element-transition-skip]"
  );
  if (isCopyCssProperties) {
    const styles = window.getComputedStyle(srcElem);
    [
      "font-family",
      "font-size",
      "font-weight",
      "background",
      "outline",
      "border",
      "color"
    ].forEach((key) => {
      clonedElement.style.setProperty(key, styles.getPropertyValue(key));
    });
  }
  (_a = clonedElement.querySelector('[loading="lazy"]')) == null ? void 0 : _a.setAttribute("loading", "eager");
  clonedElement.style.top = `${st}px`;
  clonedElement.style.left = `${sl}px`;
  clonedElement.style.width = `${sw}px`;
  clonedElement.style.height = `${sh}px`;
  clonedElement.setAttribute("x-ignore", "");
  transitionContainer.appendChild(clonedElement);
  await new Promise((resolve, reject) => {
    let maxTries = 100;
    const interval = setInterval(() => {
      if (maxTries <= 0) {
        clearInterval(interval);
        reject();
      }
      const condition = destElementCallback();
      if (condition) {
        clearInterval(interval);
        resolve();
      }
      maxTries -= 1;
    }, 100);
  });
  const destEl = destElementCallback();
  const {
    top: tt,
    left: tl,
    width: tw,
    height: th
  } = destEl.getBoundingClientRect();
  if (skipEl) {
    skipEl.style.transform = `scale(${sw / tw}, ${sh / th})`;
    skipEl.style.bottom = `${8 / (th / sh)}px`;
    const styles = skipEl.getAttribute("x-element-transition-skip");
    if (styles) {
      const styleRules = JSON.parse(styles);
      Object.keys(styleRules).forEach((key) => {
        skipEl.style[key] = styleRules[key];
      });
    }
  }
  clonedElement.style.transform = `translate3d(${tl - sl}px, ${tt - st}px, 0) scale(${tw / sw}, ${th / sh})`;
  clonedElement.style.borderRadius = window.getComputedStyle(
    destEl
  ).borderRadius;
  await new Promise((resolve) => {
    clonedElement.addEventListener(
      "transitionend",
      () => {
        resolve();
      },
      { once: true }
    );
  });
};
const _handleInputValue = (from, to) => {
  if (!(from instanceof HTMLInputElement) || !(to instanceof HTMLInputElement)) {
    return;
  }
  if ((from.type === "checkbox" || from.type === "radio") && from.checked !== to.checked) {
    from.checked = to.checked;
  }
};
const _handleTemplates = (from, to) => {
  if (!(from instanceof HTMLTemplateElement) || !(to instanceof HTMLTemplateElement)) {
    return;
  }
  const newNodes = Array.from(to.content.children);
  from.content.replaceChildren(...newNodes);
};
const replaceElement = (from, to, resetInputValues) => {
  if (!from || !to) {
    return;
  }
  Alpine.morph(from, to, {
    updating(from2, to2, _childrenOnly, skip) {
      if (from2 instanceof Element && from2.hasAttribute("x-morph-ignore")) {
        skip();
        return;
      }
      if (from2 instanceof HTMLImageElement && to2 instanceof HTMLImageElement) {
        const fromSrc = from2.src.replace(/^https?:\/\//, "//");
        const toSrc = to2.src.replace(/^https?:\/\//, "//");
        if (fromSrc === toSrc && from2.complete) {
          skip();
          return;
        }
      }
    },
    updated(from2, to2) {
      _handleTemplates(from2, to2);
      if (resetInputValues) {
        _handleInputValue(from2, to2);
      }
    }
  });
};
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var nprogress = { exports: {} };
/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */
(function(module, exports) {
  (function(root, factory) {
    {
      module.exports = factory();
    }
  })(commonjsGlobal, function() {
    var NProgress = {};
    NProgress.version = "0.2.0";
    var Settings = NProgress.settings = {
      minimum: 0.08,
      easing: "ease",
      positionUsing: "",
      speed: 200,
      trickle: true,
      trickleRate: 0.02,
      trickleSpeed: 800,
      showSpinner: true,
      barSelector: '[role="bar"]',
      spinnerSelector: '[role="spinner"]',
      parent: "body",
      template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
    };
    NProgress.configure = function(options) {
      var key, value;
      for (key in options) {
        value = options[key];
        if (value !== void 0 && options.hasOwnProperty(key)) Settings[key] = value;
      }
      return this;
    };
    NProgress.status = null;
    NProgress.set = function(n) {
      var started = NProgress.isStarted();
      n = clamp(n, Settings.minimum, 1);
      NProgress.status = n === 1 ? null : n;
      var progress = NProgress.render(!started), bar = progress.querySelector(Settings.barSelector), speed = Settings.speed, ease = Settings.easing;
      progress.offsetWidth;
      queue(function(next) {
        if (Settings.positionUsing === "") Settings.positionUsing = NProgress.getPositioningCSS();
        css(bar, barPositionCSS(n, speed, ease));
        if (n === 1) {
          css(progress, {
            transition: "none",
            opacity: 1
          });
          progress.offsetWidth;
          setTimeout(function() {
            css(progress, {
              transition: "all " + speed + "ms linear",
              opacity: 0
            });
            setTimeout(function() {
              NProgress.remove();
              next();
            }, speed);
          }, speed);
        } else {
          setTimeout(next, speed);
        }
      });
      return this;
    };
    NProgress.isStarted = function() {
      return typeof NProgress.status === "number";
    };
    NProgress.start = function() {
      if (!NProgress.status) NProgress.set(0);
      var work = function() {
        setTimeout(function() {
          if (!NProgress.status) return;
          NProgress.trickle();
          work();
        }, Settings.trickleSpeed);
      };
      if (Settings.trickle) work();
      return this;
    };
    NProgress.done = function(force) {
      if (!force && !NProgress.status) return this;
      return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
    };
    NProgress.inc = function(amount) {
      var n = NProgress.status;
      if (!n) {
        return NProgress.start();
      } else {
        if (typeof amount !== "number") {
          amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
        }
        n = clamp(n + amount, 0, 0.994);
        return NProgress.set(n);
      }
    };
    NProgress.trickle = function() {
      return NProgress.inc(Math.random() * Settings.trickleRate);
    };
    (function() {
      var initial = 0, current = 0;
      NProgress.promise = function($promise) {
        if (!$promise || $promise.state() === "resolved") {
          return this;
        }
        if (current === 0) {
          NProgress.start();
        }
        initial++;
        current++;
        $promise.always(function() {
          current--;
          if (current === 0) {
            initial = 0;
            NProgress.done();
          } else {
            NProgress.set((initial - current) / initial);
          }
        });
        return this;
      };
    })();
    NProgress.render = function(fromStart) {
      if (NProgress.isRendered()) return document.getElementById("nprogress");
      addClass(document.documentElement, "nprogress-busy");
      var progress = document.createElement("div");
      progress.id = "nprogress";
      progress.innerHTML = Settings.template;
      var bar = progress.querySelector(Settings.barSelector), perc = fromStart ? "-100" : toBarPerc(NProgress.status || 0), parent = document.querySelector(Settings.parent), spinner;
      css(bar, {
        transition: "all 0 linear",
        transform: "translate3d(" + perc + "%,0,0)"
      });
      if (!Settings.showSpinner) {
        spinner = progress.querySelector(Settings.spinnerSelector);
        spinner && removeElement(spinner);
      }
      if (parent != document.body) {
        addClass(parent, "nprogress-custom-parent");
      }
      parent.appendChild(progress);
      return progress;
    };
    NProgress.remove = function() {
      removeClass(document.documentElement, "nprogress-busy");
      removeClass(document.querySelector(Settings.parent), "nprogress-custom-parent");
      var progress = document.getElementById("nprogress");
      progress && removeElement(progress);
    };
    NProgress.isRendered = function() {
      return !!document.getElementById("nprogress");
    };
    NProgress.getPositioningCSS = function() {
      var bodyStyle = document.body.style;
      var vendorPrefix = "WebkitTransform" in bodyStyle ? "Webkit" : "MozTransform" in bodyStyle ? "Moz" : "msTransform" in bodyStyle ? "ms" : "OTransform" in bodyStyle ? "O" : "";
      if (vendorPrefix + "Perspective" in bodyStyle) {
        return "translate3d";
      } else if (vendorPrefix + "Transform" in bodyStyle) {
        return "translate";
      } else {
        return "margin";
      }
    };
    function clamp(n, min, max) {
      if (n < min) return min;
      if (n > max) return max;
      return n;
    }
    function toBarPerc(n) {
      return (-1 + n) * 100;
    }
    function barPositionCSS(n, speed, ease) {
      var barCSS;
      if (Settings.positionUsing === "translate3d") {
        barCSS = { transform: "translate3d(" + toBarPerc(n) + "%,0,0)" };
      } else if (Settings.positionUsing === "translate") {
        barCSS = { transform: "translate(" + toBarPerc(n) + "%,0)" };
      } else {
        barCSS = { "margin-left": toBarPerc(n) + "%" };
      }
      barCSS.transition = "all " + speed + "ms " + ease;
      return barCSS;
    }
    var queue = /* @__PURE__ */ function() {
      var pending = [];
      function next() {
        var fn = pending.shift();
        if (fn) {
          fn(next);
        }
      }
      return function(fn) {
        pending.push(fn);
        if (pending.length == 1) next();
      };
    }();
    var css = /* @__PURE__ */ function() {
      var cssPrefixes = ["Webkit", "O", "Moz", "ms"], cssProps = {};
      function camelCase(string) {
        return string.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function(match, letter) {
          return letter.toUpperCase();
        });
      }
      function getVendorProp(name) {
        var style = document.body.style;
        if (name in style) return name;
        var i = cssPrefixes.length, capName = name.charAt(0).toUpperCase() + name.slice(1), vendorName;
        while (i--) {
          vendorName = cssPrefixes[i] + capName;
          if (vendorName in style) return vendorName;
        }
        return name;
      }
      function getStyleProp(name) {
        name = camelCase(name);
        return cssProps[name] || (cssProps[name] = getVendorProp(name));
      }
      function applyCss(element, prop, value) {
        prop = getStyleProp(prop);
        element.style[prop] = value;
      }
      return function(element, properties) {
        var args = arguments, prop, value;
        if (args.length == 2) {
          for (prop in properties) {
            value = properties[prop];
            if (value !== void 0 && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
          }
        } else {
          applyCss(element, args[1], args[2]);
        }
      };
    }();
    function hasClass(element, name) {
      var list = typeof element == "string" ? element : classList(element);
      return list.indexOf(" " + name + " ") >= 0;
    }
    function addClass(element, name) {
      var oldList = classList(element), newList = oldList + name;
      if (hasClass(oldList, name)) return;
      element.className = newList.substring(1);
    }
    function removeClass(element, name) {
      var oldList = classList(element), newList;
      if (!hasClass(element, name)) return;
      newList = oldList.replace(" " + name + " ", " ");
      element.className = newList.substring(1, newList.length - 1);
    }
    function classList(element) {
      return (" " + (element.className || "") + " ").replace(/\s+/gi, " ");
    }
    function removeElement(element) {
      element && element.parentNode && element.parentNode.removeChild(element);
    }
    return NProgress;
  });
})(nprogress);
var nprogressExports = nprogress.exports;
const nProgress = /* @__PURE__ */ getDefaultExportFromCjs(nprogressExports);
nProgress.configure({ showSpinner: false });
let lastMainContentUpdateUrl = window.location.href;
const cachedResponses = {};
const isExternalURL = (url) => {
  if (url.startsWith("//")) {
    return new URL(location.protocol + url).origin !== location.origin;
  }
  if (url.includes("://")) {
    return new URL(url).origin !== location.origin;
  }
  return false;
};
const TransitionStore = {
  isTransitioning: false,
  pageData: void 0,
  pageType: void 0,
  isAnimating: false,
  isPreviewAnimating: false,
  originalFocusableEl: null,
  __activeTransitionAreaRef: null,
  isPreviewActive: false,
  async _doTransition(areaId, callback) {
    if (!Alpine.store("main").isMobile || Alpine.store("main").isReducedMotion) {
      callback();
      return;
    }
    const transitionContainerRef = document.querySelector(
      "[x-element-transition-wrapper]"
    );
    if (!transitionContainerRef) {
      return;
    }
    freezeScroll();
    this.__activeTransitionAreaRef = areaId;
    const areaElement = document.querySelector(
      `[x-element-transition-area="${areaId}"]`
    );
    if (!areaElement) {
      return;
    }
    const srcElements = Object.fromEntries(
      [
        ...areaElement.querySelectorAll(
          "[x-element-transition-src]"
        )
      ].map((srcElement) => [
        srcElement.getAttribute("x-element-transition-src"),
        srcElement
      ])
    );
    if (!srcElements || Object.entries(srcElements).length === 0) {
      return;
    }
    this.isTransitioning = true;
    await new Promise((resolve) => {
      transitionContainerRef.addEventListener(
        "transitionstart",
        () => {
          resolve();
        },
        { once: true }
      );
    });
    const currentPage = window.location.href;
    const animationPromise = Promise.all(
      Object.entries(srcElements).map(
        ([key, srcElem]) => doElementTransitionFromSrcToDest({
          srcElem,
          destElementCallback: () => {
            if (currentPage === window.location.href) {
              return null;
            }
            const destEl = document.querySelector(
              `[x-element-transition-dest="${key}"]`
            );
            if (!destEl) {
              return null;
            }
            return destEl;
          },
          transitionContainer: transitionContainerRef,
          isCopyCssProperties: true
        })
      )
    );
    await new Promise((resolve) => {
      transitionContainerRef.addEventListener(
        "transitionend",
        () => {
          resolve();
        },
        { once: true }
      );
    });
    callback();
    await animationPromise;
    this.isTransitioning = false;
    await new Promise((resolve) => {
      transitionContainerRef.addEventListener(
        "transitionstart",
        () => {
          resolve();
        },
        { once: true }
      );
    });
    await new Promise((resolve) => {
      transitionContainerRef.addEventListener(
        "transitionend",
        () => {
          resolve();
        },
        { once: true }
      );
    });
    while (transitionContainerRef.firstChild) {
      transitionContainerRef.removeChild(transitionContainerRef.firstChild);
    }
    this.__activeTransitionAreaRef = null;
    unfreezeScroll();
  },
  _showTransitionFallback(isPreview) {
    const target = isPreview ? document.getElementById("PreviewContent") : document.getElementById("MainContent");
    const template = document.querySelector(
      `[x-fallback-template-type="${this.pageType}"]`
    );
    if (!template) {
      return;
    }
    const content = template.innerHTML;
    if (target) {
      target.innerHTML = content;
    }
    if (!isPreview) {
      window.scrollTo(0, 0);
    }
  },
  _clearFallback() {
    this.pageType = void 0;
  }
};
const replaceMeta = (rawContent) => {
  const regex = /<!-- page-meta -->([\s\S]*?)<!-- end-page-meta -->/;
  const content = rawContent.match(regex);
  const newContent = content ? content[0] : "";
  if (!newContent) {
    return;
  }
  const metaNodes = [];
  let foundStart = false;
  let foundEnd = false;
  let endComment = null;
  for (let i = 0; i < document.head.childNodes.length; i++) {
    const node = document.head.childNodes[i];
    if (node.nodeType === 8) {
      if (node.nodeValue === " page-meta ") {
        foundStart = true;
        continue;
      }
      if (node.nodeValue === " end-page-meta ") {
        endComment = node;
        foundEnd = true;
        break;
      }
    }
    if (foundStart && !foundEnd) {
      metaNodes.push(node);
    }
  }
  if (!endComment) {
    return;
  }
  metaNodes.forEach((node) => node.remove());
  const newMetaContent = newContent.replace("<!-- page-meta -->", "<head>").replace("<!-- end-page-meta -->", "</head>");
  const parser = new DOMParser();
  const newMetaNodes = parser.parseFromString(newMetaContent, "text/html");
  [...newMetaNodes.head.childNodes].forEach((node) => {
    document.head.insertBefore(node, endComment);
  });
};
const morphContent = (rawContent, lookup, target) => {
  const regex = new RegExp(
    `<!-- ${lookup} -->([\\s\\S]*?)<!-- end-${lookup} -->`,
    "g"
  );
  const content = rawContent.match(regex);
  const newContent = content ? content[0] : "";
  replaceElement(target, newContent);
};
const replaceContent = (rawContent, lookup, target) => {
  const regex = new RegExp(
    `<!-- ${lookup} -->([\\s\\S]*?)<!-- end-${lookup} -->`,
    "g"
  );
  const content = rawContent.match(regex);
  const newContent = content ? content[0] : "";
  target.innerHTML = newContent;
};
const replaceMainContent = (rawContent) => {
  lastMainContentUpdateUrl = window.location.href;
  replaceMeta(rawContent);
  return morphContent(
    rawContent,
    "main-content",
    document.getElementById("MainContent")
  );
};
const replacePreviewContent = (rawContent) => {
  replaceMeta(rawContent);
  return replaceContent(
    rawContent,
    "preview-content",
    document.getElementById("PreviewContent")
  );
};
const pushStateAndNotify = (...args) => {
  if (window.Shopify.designMode) {
    window.location.replace(args[2]);
  } else {
    history.pushState(...args);
    const pushStateEvent = new CustomEvent("pushstate", {
      detail: {
        state: args[0],
        url: args[2]
      }
    });
    window.dispatchEvent(pushStateEvent);
  }
};
const fetchPage = (url) => {
  enableFadeInImages();
  return fetch(url).then((res) => {
    if (res.ok || res.status === 404) {
      return res.text();
    }
    throw new Error("Failed to get page for transition");
  });
};
const enableFadeInImages = () => {
  document.body.classList.remove("[&_.no-fade]:opacity-100");
  document.body.classList.remove(
    "max-md:[&_.card-product:nth-child(-n+2)_.no-fade]:opacity-100"
  );
  document.body.classList.remove("md:[&_.card-product_.no-fade]:opacity-100");
};
const cachePage = (url, html) => {
  cachedResponses[url] = html;
};
const fetchAndCachePage = async (url) => {
  const html = await fetchPage(url);
  cachePage(url, html);
  return html;
};
const navigateWithTransition = (nextUrl, options = {}) => {
  Alpine.store("transition").isAnimating = false;
  Alpine.store("transition").isPreviewAnimating = false;
  const currentUrl = window.location.pathname + window.location.search;
  const scrollPosition = window.scrollY;
  if (currentUrl === nextUrl) {
    Alpine.store("popup").hideAllPopups();
    Alpine.store("resizable").hideAll();
    window.scrollTo(0, 0);
    return;
  }
  nProgress.start();
  const isPreview = !!options.preview && !Alpine.store("main").isMobile;
  const isAnimating = !!options.animate;
  const navigate = async () => {
    if (options.type && options.data) {
      if (isPreview) {
        Alpine.store("transition").isPreviewAnimating = isAnimating;
        Alpine.store("transition").originalFocusableEl = options.target;
      } else {
        Alpine.store("transition").isAnimating = isAnimating;
      }
      Alpine.store("transition").pageType = options.type;
      Alpine.store("transition").pageData = options.data;
      Alpine.store("transition")._showTransitionFallback(isPreview);
    }
    Alpine.nextTick(async () => {
      Alpine.store("popup").hideAllPopups();
      Alpine.store("resizable").hideAll();
      history.replaceState({ ...history.state, scrollPosition }, "");
      pushStateAndNotify({ isPreview }, "", nextUrl);
      const html = await fetchAndCachePage(nextUrl);
      if (isPreview) {
        replacePreviewContent(html);
      } else {
        replaceMainContent(html);
        window.scrollTo(0, 0);
      }
      Alpine.store("transition")._clearFallback();
      nProgress.done();
    });
  };
  if (options.areaId) {
    Alpine.store("transition")._doTransition(options.areaId, navigate);
  } else {
    navigate();
  }
};
const prefetchedLinks = /* @__PURE__ */ new Set();
const prefetchLink = (link) => {
  const prefetchLink2 = document.createElement("link");
  prefetchLink2.rel = "prefetch";
  prefetchLink2.href = link;
  prefetchLink2.as = "document";
  document.head.appendChild(prefetchLink2);
  prefetchedLinks.add(link);
};
const prefetchObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const element = entry.target;
      const href = element.getAttribute("href");
      if (!href) return;
      let timeoutId = element.timeoutId;
      if (entry.isIntersecting && !timeoutId) {
        element.timeoutId = setTimeout(() => {
          if (prefetchedLinks.has(href)) return;
          prefetchLink(href);
          prefetchObserver.unobserve(element);
        }, 200);
      } else if (!entry.isIntersecting && timeoutId) {
        clearTimeout(timeoutId);
        element.timeoutId = null;
      }
    });
  },
  { threshold: 0.1 }
);
function TransitionPlugin(Alpine2) {
  Alpine2.store("transition", TransitionStore);
  Alpine2.directive(
    "element-transition-trigger",
    (el, { value, modifiers, expression }, { evaluate, cleanup }) => {
      if (modifiers.includes("desktop") && Alpine2.store("main").isMobile) {
        return;
      }
      const transitionAreaEl = el.closest("[x-element-transition-area]");
      const areaId = transitionAreaEl ? transitionAreaEl.getAttribute("x-element-transition-area") : null;
      const link = el.getAttribute("href");
      const isTargetBlank = el.getAttribute("target") === "_blank";
      const isMobile2 = Alpine2.store("main").isMobile;
      if (!link || isExternalURL(link) || isTargetBlank) {
        return;
      }
      const onHover = () => {
        if (prefetchedLinks.has(link)) return;
        prefetchLink(link);
      };
      const onClick = (e) => {
        if (window.navigationType === "MPA") {
          const areaElement = document.querySelector(
            `[x-element-transition-area="${areaId}"]`
          );
          if (!areaElement || !isMobile2) {
            return;
          }
          const srcElement = areaElement.querySelector(
            "[x-element-transition-src]"
          );
          const key = srcElement == null ? void 0 : srcElement.getAttribute("x-element-transition-src");
          if (srcElement) {
            sessionStorage.setItem(
              "elementRect",
              JSON.stringify(srcElement.getBoundingClientRect())
            );
            sessionStorage.setItem(
              "elementHtml",
              srcElement.innerHTML.replace('loading="lazy"', 'loading="eager"')
            );
            sessionStorage.setItem("destKey", key || "");
          }
        } else {
          e.preventDefault();
          e.stopPropagation();
          navigateWithTransition(link || "", {
            preview: modifiers.includes("preview"),
            animate: modifiers.includes("animate"),
            type: value,
            data: expression ? evaluate(expression) : void 0,
            areaId: areaId || void 0,
            target: e.target
          });
        }
      };
      el.addEventListener("click", onClick);
      if (window.navigationType === "MPA") {
        if (isMobile2) {
          prefetchObserver.observe(el);
        } else {
          el.addEventListener("mouseover", onHover);
        }
      }
      cleanup(() => {
        el.removeEventListener("click", onClick);
        if (window.navigationType === "MPA") {
          if (isMobile2) {
            prefetchObserver.unobserve(el);
          } else {
            el.removeEventListener("mouseover", onHover);
          }
        }
      });
    }
  );
  if (window.navigationType === "MPA") {
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        prefetchedLinks.forEach((link) => prefetchLink(link));
      }
    });
  } else {
    let lastPopStateUrl = window.location.href;
    window.addEventListener("popstate", async (event) => {
      var _a, _b, _c, _d;
      Alpine2.store("transition").isAnimating = false;
      Alpine2.store("transition").isPreviewAnimating = false;
      history.scrollRestoration = "manual";
      if (window.location.href === lastMainContentUpdateUrl) {
        return;
      }
      const currentPopStateUrl = window.location.href;
      lastPopStateUrl = window.location.href;
      Alpine2.store("popup").hideAllPopups();
      Alpine2.store("resizable").hideAll();
      nProgress.start();
      const { pathname, search } = new URL(window.location.href);
      const cachedHtml = cachedResponses[pathname + search];
      if (cachedHtml) {
        if ((_a = event.state) == null ? void 0 : _a.isPreview) {
          replacePreviewContent(cachedHtml);
        } else {
          replaceMainContent(cachedHtml);
          if ((_b = event.state) == null ? void 0 : _b.scrollPosition) {
            window.scrollTo({
              top: event.state.scrollPosition,
              behavior: "instant"
            });
          }
        }
        nProgress.done();
        return;
      }
      if (lastPopStateUrl !== currentPopStateUrl) {
        return;
      }
      const html = await fetchAndCachePage(
        window.location.pathname + window.location.search
      );
      if (lastPopStateUrl !== currentPopStateUrl) {
        return;
      }
      if ((_c = event.state) == null ? void 0 : _c.isPreview) {
        replacePreviewContent(html);
      } else {
        replaceMainContent(html);
        if ((_d = event.state) == null ? void 0 : _d.scrollPosition) {
          window.scrollTo({
            top: event.state.scrollPosition,
            behavior: "instant"
          });
        }
      }
      nProgress.done();
    });
  }
}
function ElementIntersection(Alpine2) {
  Alpine2.directive(
    "intersect",
    Alpine2.skipDuringClone(
      (element, { value, expression, modifiers }, { evaluateLater, cleanup, effect }) => {
        const evaluate = evaluateLater(expression);
        const observerOptions = {
          rootMargin: getRootMargin(modifiers),
          threshold: getThreshold(modifiers) || 1e-6
        };
        let isVisibleRef = null;
        let observerTimeoutRef = null;
        let observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const newIsVisible = entry.isIntersecting;
            if (isVisibleRef === newIsVisible) {
              return;
            }
            if (observerTimeoutRef) {
              clearTimeout(observerTimeoutRef);
            }
            isVisibleRef = newIsVisible;
            element._x_visible = newIsVisible;
            if (newIsVisible === (value === "leave")) {
              return;
            }
            observerTimeoutRef = setTimeout(() => {
              isVisibleRef = newIsVisible;
              evaluate();
            }, getDelay(modifiers));
            modifiers.includes("once") && observer.disconnect();
          });
        }, observerOptions);
        let prevIsFocused = Alpine2.store("popup").isCurrentPopupFocused;
        effect(() => {
          const isFocused = Alpine2.store("popup").isCurrentPopupFocused;
          if (prevIsFocused !== isFocused) {
            prevIsFocused = isFocused;
            observer.unobserve(element);
            if (observerTimeoutRef) {
              clearTimeout(observerTimeoutRef);
            }
            observerTimeoutRef = setTimeout(() => {
              observerTimeoutRef = null;
              observer.observe(element);
            }, getDelay(modifiers));
          }
        });
        observer.observe(element);
        cleanup(() => {
          observer.disconnect();
        });
      }
    )
  );
}
function getThreshold(modifiers) {
  if (modifiers.includes("full")) return 0.99;
  if (modifiers.includes("half")) return 0.5;
  if (!modifiers.includes("threshold")) return 0;
  let threshold = modifiers[modifiers.indexOf("threshold") + 1];
  if (threshold === "100") return 1;
  if (threshold === "0") return 0;
  return Number(`.${threshold}`);
}
function getLengthValue(rawValue) {
  let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
  return match ? match[1] + (match[2] || "px") : void 0;
}
function getRootMargin(modifiers) {
  const key = "margin";
  const fallback = "0px 0px 0px 0px";
  const index = modifiers.indexOf(key);
  if (index === -1) return fallback;
  let values = [];
  for (let i = 1; i < 5; i++) {
    values.push(getLengthValue(String(modifiers[index + i]) || ""));
  }
  values = values.filter((v) => v !== void 0);
  return values.length ? values.join(" ").trim() : fallback;
}
function getDelay(modifiers) {
  if (!modifiers.includes("delay")) return 300;
  let delay = modifiers[modifiers.indexOf("delay") + 1];
  return Number(delay);
}
const SELECTOR_LIST = "a, button, textarea, input, select, [role=radio][aria-checked]";
let trapInitial = null;
let trapStart = null;
let trapEnd = null;
let trapEls = [];
const RESIZABLE_ANIMATION_DURATION = 300;
function Accessibility(Alpine2) {
  Alpine2.directive(
    "a11y-trap",
    (el, { expression }, { evaluateLater, effect, cleanup }) => {
      const getIsTrapped = evaluateLater(expression);
      const onKeyDown = async (e) => {
        const focusEls = Array.from(el.querySelectorAll(SELECTOR_LIST)).filter(
          // Skip hidden elements
          (element) => {
            const computedStyle = window.getComputedStyle(element);
            return computedStyle.display !== "none";
          }
        );
        const allFocusEls = trapEls.concat(focusEls);
        const first = trapStart || allFocusEls[0];
        const last = trapEnd || allFocusEls[allFocusEls.length - 1];
        if (e.key !== TAB_KEY) {
          return;
        }
        if (e.shiftKey) {
          if (e.target === first) {
            last == null ? void 0 : last.focus();
            e.preventDefault();
          }
          return;
        }
        if (e.target === last) {
          first == null ? void 0 : first.focus();
          e.preventDefault();
        }
      };
      const trapFocus = () => {
        document.addEventListener("keydown", onKeyDown);
        el.setAttribute("role", "dialog");
        el.setAttribute("aria-modal", "true");
        const labelRef = el.querySelector("h1, h2, h3, h4, h5, p");
        if (labelRef) {
          labelRef.id = "popup-label";
          el.setAttribute("aria-labelledby", "popup-label");
        }
        const firstVisibleEl = Array.from(
          el.querySelectorAll(SELECTOR_LIST)
        ).find((element) => {
          const computedStyle = window.getComputedStyle(element);
          return computedStyle.display !== "none";
        });
        if (isMobile()) {
          return;
        }
        const first = trapStart || trapInitial || firstVisibleEl;
        first == null ? void 0 : first.focus();
      };
      effect(() => {
        getIsTrapped((trapped) => {
          if (!trapped) {
            return;
          }
          setTimeout(trapFocus, RESIZABLE_ANIMATION_DURATION);
          const observer = new MutationObserver(() => {
            if (el.querySelectorAll(SELECTOR_LIST).length) {
              setTimeout(trapFocus, RESIZABLE_ANIMATION_DURATION);
              observer.disconnect();
            }
          });
          observer.observe(el, { subtree: true, childList: true });
        });
      });
      cleanup(() => {
        document.removeEventListener("keydown", onKeyDown);
        el.removeAttribute("role");
        el.removeAttribute("aria-modal");
        el.removeAttribute("aria-labelledby");
      });
    }
  );
  Alpine2.directive(
    "a11y-trap-target",
    (el, { modifiers, expression }, { evaluateLater, effect, cleanup }) => {
      const getIsTrapped = evaluateLater(expression);
      effect(() => {
        getIsTrapped((trapped) => {
          if (trapped) {
            if (modifiers.includes("start")) {
              trapStart = el;
            } else if (modifiers.includes("end")) {
              trapEnd = el;
            } else if (modifiers.includes("initial")) {
              trapInitial = el;
            }
          } else {
            if (modifiers.includes("start") && trapStart === el) {
              trapStart = null;
            } else if (modifiers.includes("end") && trapEnd === el) {
              trapEnd = null;
            } else if (modifiers.includes("initial") && trapInitial === el) {
              trapInitial = null;
            }
          }
        });
      });
      cleanup(() => {
        if (modifiers.includes("start")) {
          trapStart = null;
        } else if (modifiers.includes("end")) {
          trapEnd = null;
        } else if (modifiers.includes("initial")) {
          trapInitial = null;
        }
      });
    }
  );
  Alpine2.directive(
    "a11y-trap-element",
    (el, { expression }, { evaluateLater, effect, cleanup }) => {
      const getIsActive = evaluateLater(expression);
      effect(() => {
        getIsActive((active) => {
          if (active) {
            if (!trapEls.includes(el)) {
              trapEls.push(el);
            }
          } else {
            if (trapEls.includes(el)) {
              trapEls.splice(trapEls.indexOf(el), 1);
            }
          }
        });
      });
      cleanup(() => {
      });
    }
  );
  Alpine2.directive("a11y-radio", (el, _, { cleanup }) => {
    const onKeyDown = (e) => {
      if (!e.target || !(e.target instanceof HTMLElement) || e.target.role !== "radio") {
        throw "x-a11y-radio can only be used on elements of 'radio' role";
      }
      if (e.key === " ") {
        e.preventDefault();
        return;
      }
      const isNext = e.key === "ArrowDown" || e.key === "ArrowRight";
      const isPrev = e.key === "ArrowUp" || e.key === "ArrowLeft";
      if (!isNext && !isPrev) return;
      e.preventDefault();
      const radioGroup = e.target.closest("[role=radiogroup]");
      if (!radioGroup) {
        throw "x-a11y-radio can only be used inside an element with 'radiogroup' role";
      }
      const radios = [...radioGroup.querySelectorAll("[role=radio]")];
      const currentRadio = e.target;
      const currentIndex = radios.indexOf(currentRadio);
      const nextIndex = currentIndex === radios.length - 1 ? 0 : currentIndex + 1;
      const prevIndex = currentIndex === 0 ? radios.length - 1 : currentIndex - 1;
      const newIndex = isNext ? nextIndex : prevIndex;
      const newRadio = radios[newIndex];
      newRadio.click();
      newRadio.focus();
    };
    el.addEventListener("keydown", onKeyDown);
    cleanup(() => {
      el.removeEventListener("keydown", onKeyDown);
    });
  });
}
const appendPaginationContent = (rawContent) => {
  const regex = /<!-- pagination-content -->([\s\S]*?)<!-- end-pagination-content -->/g;
  const content = rawContent.match(regex);
  const newContent = content ? content[0] : "";
  const el = document.querySelector("[data-content-wrapper]");
  const newElements = document.createElement("div");
  newElements.style.display = "contents";
  newElements.innerHTML = newContent;
  if (el) {
    el.appendChild(newElements);
    const focusEl = newElements.querySelector(SELECTOR_LIST);
    if (focusEl) {
      focusEl.focus();
    }
  }
};
function Pagination(Alpine2) {
  let isPaginating = false;
  let currentPage = parseInt(
    new URLSearchParams(window.location.search).get("page") || "1"
  );
  Alpine2.directive(
    "pagination-trigger",
    (el, { expression }, { evaluate, cleanup }) => {
      const { lastPage } = evaluate(expression);
      const onClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        enableFadeInImages();
        if (isPaginating) {
          return;
        }
        isPaginating = true;
        el.ariaBusy = "1";
        if (currentPage < lastPage) {
          const nextPage = currentPage + 1;
          const nextUrl = `${window.location.pathname}?page=${nextPage}`;
          const fullUrl = window.location.pathname + window.location.search;
          const html = await fetchPage(nextUrl);
          appendPaginationContent(html);
          cachePage(fullUrl, document.documentElement.outerHTML);
          history.replaceState({ page: nextPage }, "", fullUrl);
          currentPage = nextPage;
          if (nextPage === lastPage) {
            el.remove();
          }
        }
        isPaginating = false;
        el.ariaBusy = "0";
      };
      el.addEventListener("click", onClick);
      cleanup(() => {
        el.removeEventListener("click", onClick);
        isPaginating = false;
        currentPage = parseInt(
          new URLSearchParams(window.location.search).get("page") || "1"
        );
      });
    }
  );
}
const _TransitionManager = class _TransitionManager {
  constructor() {
    __publicField(this, "isTransitioning", false);
    __publicField(this, "transitionElements", /* @__PURE__ */ new Set());
    __publicField(this, "configs", [
      { selector: "[data-from-portal]", className: "portal-transition" },
      { selector: ".popup-content, .resizable-content", className: "popup-transition", transform: "scale(0.95)" },
      { selector: ".popup-overlay", className: "overlay-transition" },
      { selector: ".menu-content", className: "menu-transition", transform: "translateX(-100%)" },
      { selector: ".cart-content", className: "cart-transition", transform: "translateX(100%)" },
      { selector: ".search-content", className: "search-transition", transform: "translateY(-20px)" },
      { selector: ".filters-content", className: "filters-transition", transform: "translateX(-100%)" },
      { selector: "[data-popup-content]", className: "popup-transition" },
      { selector: ".resizable:not(.resizable--cart):not(.resizable--search)", className: "resizable-transition" }
    ]);
  }
  static getInstance() {
    if (!_TransitionManager.instance) {
      _TransitionManager.instance = new _TransitionManager();
    }
    return _TransitionManager.instance;
  }
  startTransition() {
    this.isTransitioning = true;
    this.hideElements();
  }
  endTransition() {
    this.isTransitioning = false;
    this.showElements();
  }
  hideElements() {
    this.configs.forEach((config) => {
      const elements = document.querySelectorAll(config.selector);
      elements.forEach((el) => {
        this.transitionElements.add(el);
        el.setAttribute("data-transitioning", "true");
        if (config.className) {
          el.classList.add(config.className);
        }
      });
    });
  }
  showElements() {
    setTimeout(() => {
      this.transitionElements.forEach((el) => {
        el.removeAttribute("data-transitioning");
        this.configs.forEach((config) => {
          if (config.className) {
            el.classList.remove(config.className);
          }
        });
      });
      this.transitionElements.clear();
    }, 150);
  }
  isInTransition() {
    return this.isTransitioning;
  }
  waitForTransition() {
    return new Promise((resolve) => {
      const checkTransition = () => {
        if (!this.isTransitioning) {
          resolve();
        } else {
          setTimeout(checkTransition, 50);
        }
      };
      checkTransition();
    });
  }
  addTransitionState(element, config) {
    if (this.isTransitioning) {
      element.setAttribute("data-transitioning", "true");
      if (config == null ? void 0 : config.className) {
        element.classList.add(config.className);
      }
    }
  }
  removeTransitionState(element, config) {
    setTimeout(() => {
      element.removeAttribute("data-transitioning");
      if (config == null ? void 0 : config.className) {
        element.classList.remove(config.className);
      }
    }, 150);
  }
};
__publicField(_TransitionManager, "instance");
let TransitionManager = _TransitionManager;
const transitionManager = TransitionManager.getInstance();
function Portal(Alpine2) {
  const placeInDom = (clone, target) => {
    target == null ? void 0 : target.appendChild(clone);
  };
  const getAllClones = () => {
    return Array.from(
      document.querySelectorAll("[data-from-portal]")
    );
  };
  const getAllTemplates = () => {
    return Array.from(
      document.querySelectorAll("[data-portal]")
    );
  };
  const getCurrentCloneFromTemplate = (template) => {
    return getAllClones().find((clone) => clone._x_teleportBack === template);
  };
  const getTarget = (template) => {
    const expression = template.getAttribute("x-portal") || "";
    let rawTarget = Alpine2.evaluate(template, expression);
    if (!rawTarget) {
      console.warn(`Portal target not found for expression: "${expression}". This may be normal during viewport transitions.`);
      return null;
    }
    if (!(rawTarget instanceof HTMLElement)) {
      console.warn(`Cannot find x-portal target for selector: "${expression}"`);
      return null;
    }
    return rawTarget;
  };
  const initClone = (clone, targetEl, templateEl) => {
    if (!targetEl) return;
    try {
      templateEl._x_teleport = clone;
      clone._x_teleportBack = templateEl;
      clone._x_teleportTarget = targetEl;
      clone.setAttribute("data-from-portal", "true");
      templateEl.setAttribute("data-portal", "true");
      transitionManager.addTransitionState(clone, { className: "portal-transition" });
      if (templateEl._x_forwardEvents) {
        templateEl._x_forwardEvents.forEach((eventName) => {
          clone.addEventListener(eventName, (e) => {
            e.stopPropagation();
            templateEl.dispatchEvent(new e.constructor(e.type, e));
          });
        });
      }
      Alpine2.addScopeToNode(clone, {}, templateEl);
      Alpine2.mutateDom(() => {
        placeInDom(clone, targetEl);
        Alpine2.initTree(clone);
        clone._x_ignore = true;
        transitionManager.removeTransitionState(clone, { className: "portal-transition" });
      });
    } catch (e) {
    }
  };
  const createPortal = (templateEl) => {
    const targetEl = getTarget(templateEl);
    if (!targetEl) return;
    const oldClone = getCurrentCloneFromTemplate(templateEl);
    if (oldClone) {
      if (oldClone._x_teleportTarget !== targetEl) {
        oldClone.remove();
        const clone2 = templateEl.content.cloneNode(true).firstElementChild;
        initClone(clone2, targetEl, templateEl);
      } else {
        teleportClone(templateEl, oldClone);
      }
      return;
    }
    const clone = templateEl.content.cloneNode(true).firstElementChild;
    initClone(clone, targetEl, templateEl);
  };
  const cleanupPortal = (templateEl) => {
    const clone = getCurrentCloneFromTemplate(templateEl);
    if (clone) {
      clone.remove();
      templateEl._x_teleport = void 0;
      clone._x_teleportBack = void 0;
      clone._x_teleportTarget = void 0;
    }
  };
  function cloneWithCleanup(originalElement) {
    const doCleanup = (source) => {
      const cSource = source;
      if (cSource._x_currentIfEl) {
        cSource._x_currentIfEl.remove();
      }
      if (cSource._x_lookup) {
        Object.values(cSource._x_lookup).forEach((element) => {
          element.remove();
        });
      }
    };
    const recursivelyCloneChildren = (originalParent) => {
      const originalChildren = originalParent.children;
      for (let i = 0; i < originalChildren.length; i++) {
        doCleanup(originalChildren[i]);
        recursivelyCloneChildren(originalChildren[i]);
      }
    };
    recursivelyCloneChildren(originalElement);
    return originalElement.cloneNode(true);
  }
  const teleportClone = (templateEl, oldClone) => {
    const newClone = cloneWithCleanup(oldClone);
    const targetEl = getTarget(templateEl);
    initClone(newClone, targetEl, templateEl);
  };
  const observer = new MutationObserver(() => {
    getAllClones().forEach((clone) => {
      const templateEl = clone._x_teleportBack;
      if (templateEl) {
        const newTeleportTarget = Alpine2.evaluate(
          templateEl,
          templateEl.getAttribute("x-portal") || ""
        );
        if (!document.body.contains(templateEl) || newTeleportTarget !== clone._x_teleportTarget || !document.body.contains(clone)) {
          clone.remove();
          return;
        }
      } else {
        clone.remove();
        return;
      }
    });
    getAllTemplates().forEach((templateEl) => {
      const targetEl = templateEl._x_teleport;
      if (!targetEl || !document.body.contains(targetEl)) {
        createPortal(templateEl);
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  Alpine2.directive("portal", (rawEl, {}, { cleanup, effect }) => {
    if (rawEl.tagName.toLowerCase() !== "template")
      console.warn("x-portal can only be used on a <template> tag", rawEl);
    const templateEl = rawEl;
    createPortal(templateEl);
    effect(() => {
      const newTargetEl = getTarget(templateEl);
      const currentClone = getCurrentCloneFromTemplate(templateEl);
      const currentTarget = currentClone == null ? void 0 : currentClone._x_teleportTarget;
      if (!newTargetEl) {
        cleanupPortal(templateEl);
        return;
      }
      if (newTargetEl !== currentTarget) {
        cleanupPortal(templateEl);
        createPortal(templateEl);
      }
    });
    cleanup(() => {
      cleanupPortal(templateEl);
    });
  });
}
const TOP_VAR = "--scroll-top";
function StickyScroll(Alpine2) {
  Alpine2.directive(
    "sticky-scroll",
    (stickyElement, { expression }, { evaluate, cleanup }) => {
      const {
        container,
        top: topGap,
        bottom: bottomGap
      } = evaluate(expression);
      const scrollTarget = container instanceof HTMLElement ? container : document;
      const propertyTarget = container instanceof HTMLElement ? container : document.getElementById(
        "MainContent"
      );
      const getScrollTargetScrollY = () => {
        if (container instanceof HTMLElement) {
          return container.scrollTop;
        } else {
          return window.scrollY;
        }
      };
      const getHeightOfTarget = () => {
        return window.innerHeight;
      };
      const positionStickySidebar = () => {
        propertyTarget._x_endScroll = propertyTarget._x_screenHeight - stickyElement.offsetHeight - bottomGap;
        let stickyElementTop = parseInt(
          propertyTarget.style.getPropertyValue(TOP_VAR).replace("px", ""),
          10
        );
        if (propertyTarget._x_stickyElementHeight + topGap + bottomGap > propertyTarget._x_screenHeight) {
          if (getScrollTargetScrollY() < propertyTarget._x_currPos) {
            if (stickyElementTop < topGap) {
              propertyTarget.style.setProperty(
                TOP_VAR,
                `${stickyElementTop + propertyTarget._x_currPos - getScrollTargetScrollY()}px`
              );
            } else if (stickyElementTop >= topGap && stickyElementTop != topGap) {
              propertyTarget.style.setProperty(TOP_VAR, `${topGap}px`);
            }
          } else {
            if (stickyElementTop > propertyTarget._x_endScroll) {
              propertyTarget.style.setProperty(
                TOP_VAR,
                `${stickyElementTop + propertyTarget._x_currPos - getScrollTargetScrollY()}px`
              );
            } else if (stickyElementTop < propertyTarget._x_endScroll && stickyElementTop != propertyTarget._x_endScroll) {
              propertyTarget.style.setProperty(
                TOP_VAR,
                `${propertyTarget._x_endScroll}px`
              );
            }
          }
        } else {
          propertyTarget.style.setProperty(TOP_VAR, `${topGap}px`);
        }
        propertyTarget._x_currPos = getScrollTargetScrollY();
      };
      function updateSticky() {
        propertyTarget._x_screenHeight = getHeightOfTarget();
        propertyTarget._x_stickyElementHeight = stickyElement.offsetHeight;
        positionStickySidebar();
      }
      function onResize() {
        propertyTarget._x_currPos = getScrollTargetScrollY();
        updateSticky();
      }
      propertyTarget._x_endScroll = getHeightOfTarget() - stickyElement.offsetHeight - 500;
      propertyTarget._x_currPos = getScrollTargetScrollY();
      propertyTarget._x_screenHeight = getHeightOfTarget();
      propertyTarget._x_stickyElementHeight = stickyElement.offsetHeight;
      propertyTarget.style.setProperty(TOP_VAR, `${topGap.toString()}px`);
      propertyTarget._x_scroll_listener = updateSticky;
      propertyTarget._x_resize_listener = onResize;
      window.addEventListener("resize", propertyTarget._x_resize_listener);
      scrollTarget.addEventListener(
        "scroll",
        propertyTarget._x_scroll_listener,
        {
          capture: true,
          passive: true
        }
      );
      cleanup(() => {
        scrollTarget.removeEventListener(
          "scroll",
          propertyTarget._x_scroll_listener,
          {
            capture: true
          }
        );
        window.removeEventListener("resize", propertyTarget._x_resize_listener);
        propertyTarget._x_endScroll = 0;
        propertyTarget._x_currPos = 0;
        propertyTarget._x_screenHeight = 0;
        propertyTarget._x_stickyElementHeight = 0;
        propertyTarget.style.removeProperty(TOP_VAR);
      });
    }
  );
}
const POPUP_OVERLAY_CLICK_EVENT = "popup-overlay-click";
const POPUP_APPEARANCE_DURATION = 500;
let __popups = [];
const PopupStore = {
  currentPopup: null,
  isCurrentPopupFullScreen: false,
  isCurrentPopupFocused: false,
  originalFocusableEl: null,
  widthOffset: "55px",
  __currentPopupRef: null,
  __nextPopupRef: null,
  __popupHistory: [],
  __isNoRenderWhileHidingRef: false,
  __endOfHeaderHeight: 0,
  __popupContentHeight: 0,
  _nextPopup: null,
  _isPopupVisible: false,
  _isPopupSimple: false,
  _popupContentRatio: 0,
  _isMaxHeightReached: false,
  _isPopupContentHidden: false,
  __isKeyboardVisibleRef: false,
  __prevWindowHeightRef: 0,
  __mutationObserver: null,
  __attachedOverlayCallback: null,
  init() {
    Alpine.effect(() => {
      const currentPopupConfig = __popups.find(
        (popup) => popup.id === this.__currentPopupRef
      );
      const nextPopupConfig = __popups.find(
        (popup) => popup.id === this.__nextPopupRef
      );
      const isPopupContentHidden = this.__nextPopupRef !== null;
      const isPopupVisible = !!this.currentPopup;
      const isPopupFocused = !isPopupContentHidden ? currentPopupConfig == null ? void 0 : currentPopupConfig.isFocused : nextPopupConfig == null ? void 0 : nextPopupConfig.isFocused;
      const isPopupFullScreen = !isPopupContentHidden ? currentPopupConfig == null ? void 0 : currentPopupConfig.isFullScreen : nextPopupConfig == null ? void 0 : nextPopupConfig.isFullScreen;
      const isPopupSimple = !isPopupContentHidden ? currentPopupConfig && !isPopupFocused : nextPopupConfig && !isPopupFocused;
      const overlayCallback = !isPopupContentHidden ? currentPopupConfig == null ? void 0 : currentPopupConfig.overlayCallback : nextPopupConfig == null ? void 0 : nextPopupConfig.overlayCallback;
      const isMaxHeightReached = this.__popupContentHeight > this.__getWindowHeight() - this.__endOfHeaderHeight - 8 * 4;
      this.isCurrentPopupFocused = !!isPopupFocused;
      this.isCurrentPopupFullScreen = !!isPopupFullScreen;
      this.widthOffset = (currentPopupConfig == null ? void 0 : currentPopupConfig.widthOffset) || "55px";
      this._isPopupVisible = !!isPopupVisible;
      this._isPopupSimple = !!isPopupSimple;
      this._isMaxHeightReached = isMaxHeightReached;
      this._isPopupContentHidden = isPopupContentHidden;
      if (isPopupFocused) {
        if (!Alpine.store("main").isPrint) {
          freezeScroll();
        }
        this.__mutationObserver = new MutationObserver(() => {
          this.__updateScrollLockIfNeeded();
        });
        this.__mutationObserver.observe(
          document.getElementById("popup-content-portal"),
          {
            childList: true,
            subtree: true,
            attributeFilter: ["class"]
          }
        );
      } else {
        unfreezeScroll();
        if (this.__mutationObserver) {
          this.__mutationObserver.disconnect();
          this.__mutationObserver = null;
        }
      }
      if (!this._isMaxHeightReached) {
        Alpine.nextTick(() => {
          this.updateContentSize();
        });
      }
      setTimeout(() => {
        const popupContentRatio = (this.__popupContentHeight + 32) / 100;
        this._popupContentRatio = popupContentRatio;
      }, 0);
      if (overlayCallback) {
        this.__addOverlayCallback(overlayCallback);
      } else {
        this.__removeOverlayCallback();
      }
    });
  },
  _registerPopup(popup) {
    __popups.push(popup);
    if (popup.isAlwaysVisible) {
      this.showPopup(popup.id);
    }
  },
  _unregisterPopup(popup) {
    __popups = __popups.filter((p) => p.id !== popup.id);
    if (this.__popupHistory.includes(popup.id)) {
      this.hidePopup(popup.id);
    }
  },
  _updatePopupConfig(popup) {
    __popups = __popups.map((p) => {
      if (p.id === popup.id) {
        return popup;
      }
      return p;
    });
  },
  extendPopupConfig(popup) {
    const popupConfig = __popups.find((p) => p.id === popup.id);
    this._updatePopupConfig({
      ...popupConfig,
      ...popup
    });
  },
  async hideAllPopups() {
    if (!isMobile()) {
      return;
    }
    transitionManager.startTransition();
    this.__isNoRenderWhileHidingRef = true;
    this.__currentPopupRef = null;
    if (this.__isNoRenderWhileHidingRef) {
      await this.__doSupportiveTransition();
    }
    if (this.__isNoRenderWhileHidingRef) {
      await this.updateContentSize();
    }
    if (this.__isNoRenderWhileHidingRef) {
      await new Promise((res) => {
        setTimeout(res, POPUP_APPEARANCE_DURATION / 4);
      });
    }
    if (this.__isNoRenderWhileHidingRef) {
      unfreezeScroll();
      this.currentPopup = null;
      this.__popupHistory = [];
      setTimeout(() => transitionManager.endTransition(), 100);
    }
    this.__isNoRenderWhileHidingRef = false;
  },
  hideCurrentPopup() {
    var _a;
    if (!isMobile()) {
      return;
    }
    document.removeEventListener("keydown", this._onKeyDown);
    (_a = this.originalFocusableEl) == null ? void 0 : _a.focus();
    this.originalFocusableEl = null;
    const popup = this.__currentPopupRef;
    const popupConfig = __popups.find((p) => p.id === popup);
    if (popupConfig && popupConfig.isPreventOverlayClose) {
      return;
    }
    for (let i = this.__popupHistory.length - 1; i >= 0; i--) {
      if (this.__popupHistory[i] === popup) {
        this.__popupHistory.pop();
      } else {
        break;
      }
    }
    const lastPopup = this.__popupHistory[this.__popupHistory.length - 1];
    if (!lastPopup) {
      this.hideAllPopups();
      return;
    }
    this.showPopup(lastPopup);
  },
  __updatePopupHeight(popup) {
    if (popup) {
      this.__popupContentHeight = document.getElementById("popup-content-portal").getBoundingClientRect().height;
    } else {
      this.__popupContentHeight = 0;
    }
  },
  async __doSupportiveTransition(popup = null) {
    var _a;
    const start = ((_a = document.getElementById("end-of-header")) == null ? void 0 : _a.getBoundingClientRect().top) || 0;
    this.__endOfHeaderHeight = start;
    this.__updatePopupHeight(popup);
    this.__nextPopupRef = popup;
    this._nextPopup = popup;
    if (!popup || Alpine.store("main").isReducedMotion) {
      return;
    }
    await new Promise((resolve) => {
      document.getElementById("popup-content").addEventListener(
        "transitionstart",
        () => {
          resolve();
        },
        { once: true }
      );
    });
  },
  async showPopup(popup, isClosePrevious = true) {
    if (!isMobile()) {
      return;
    }
    await transitionManager.waitForTransition();
    Alpine.store("main").hideMenu();
    this.originalFocusableEl = document.activeElement.closest(SELECTOR_LIST);
    document.addEventListener("keydown", this._onKeyDown.bind(this));
    if (this.__currentPopupRef) {
      const currentPopupConfig = __popups.find(
        (p) => p.id === this.__currentPopupRef
      );
      const nextPopupConfig = __popups.find((p) => p.id === popup);
      if (currentPopupConfig && currentPopupConfig.isFullScreen && (nextPopupConfig == null ? void 0 : nextPopupConfig.isFullScreen)) {
        this.__popupHistory.pop();
      }
    }
    if (!isClosePrevious && this.__currentPopupRef) {
      this.__popupHistory.unshift(popup);
      return;
    }
    const lastPopup = this.__popupHistory[this.__popupHistory.length - 1];
    if (lastPopup !== popup) {
      this.__popupHistory.push(popup);
    }
    const isAlreadyOpen = this.__currentPopupRef === popup;
    const popupConfig = __popups.find((p) => p.id === popup);
    if (!popupConfig) {
      return;
    }
    await Promise.resolve();
    this.__isNoRenderWhileHidingRef = false;
    if (!isAlreadyOpen) {
      await this.__doSupportiveTransition(popup);
    }
    const { isFocused } = popupConfig;
    if (isFocused) {
      freezeScroll();
      this.__mutationObserver = new MutationObserver(() => {
        this.__updateScrollLockIfNeeded();
      });
      this.__mutationObserver.observe(
        document.getElementById("popup-content-portal"),
        {
          childList: true,
          subtree: true
        }
      );
    } else {
      unfreezeScroll();
      if (this.__mutationObserver) {
        this.__mutationObserver.disconnect();
        this.__mutationObserver = null;
      }
    }
    try {
      Alpine.nextTick(() => {
        this.__updatePopupHeight(popup);
        this.__nextPopupRef = null;
        this.__currentPopupRef = popup;
        this.currentPopup = popup;
      });
    } catch (e) {
    }
  },
  _onKeyDown(e) {
    const isEscPressed = e.key === ESC_KEY;
    if (isEscPressed) {
      this.hideCurrentPopup();
    }
  },
  hidePopup(popup) {
    if (popup === this.__currentPopupRef) {
      this.hideCurrentPopup();
    }
  },
  __getWindowHeight() {
    if (this.__isKeyboardVisibleRef) {
      return this.__prevWindowHeightRef;
    }
    const newWindowHeight = window.visualViewport ? window.visualViewport.height : window.screen.availHeight;
    this.__prevWindowHeightRef = newWindowHeight;
    return newWindowHeight;
  },
  __updateScrollLockIfNeeded() {
    const contentPortal = document.getElementById("popup-content-portal");
    if (!contentPortal) {
      return;
    }
    const scopedIsMaxHeightReached = contentPortal.scrollHeight > this.__getWindowHeight() - this.__endOfHeaderHeight - 8 * 4;
    if (scopedIsMaxHeightReached) {
      makeElementScrollable(contentPortal);
    } else {
      makeElementNotScrollable();
    }
  },
  onPopupOverlayClick() {
    const event = new CustomEvent(POPUP_OVERLAY_CLICK_EVENT);
    document.dispatchEvent(event);
    this.hideCurrentPopup();
  },
  updateContentSize() {
    var _a;
    this.__updatePopupHeight(this.__currentPopupRef);
    this.__updateScrollLockIfNeeded();
    (_a = document.getElementById("popup-content-portal")) == null ? void 0 : _a.scrollTo({
      top: 0
    });
  },
  useOnPopupOverlayClick(popup, callback) {
    this.extendPopupConfig({ id: popup, overlayCallback: callback });
  },
  __addOverlayCallback(callback) {
    if (this.__attachedOverlayCallback && this.__attachedOverlayCallback !== callback) {
      this.__removeOverlayCallback();
    }
    if (!this.__attachedOverlayCallback) {
      document.addEventListener(POPUP_OVERLAY_CLICK_EVENT, callback);
      this.__attachedOverlayCallback = callback;
    }
  },
  __removeOverlayCallback() {
    if (this.__attachedOverlayCallback) {
      document.removeEventListener(
        POPUP_OVERLAY_CLICK_EVENT,
        this.__attachedOverlayCallback
      );
      this.__attachedOverlayCallback = null;
    }
  }
};
let _all = {};
const ResizableStore = {
  _current: {},
  originalFocusableEl: null,
  _keyDownEventListener: () => {
  },
  __observer: null,
  __onResize(entries) {
    for (const entry of entries) {
      const { id } = entry.target;
      if (!this._current[id]) {
        continue;
      }
      if (entry.contentBoxSize) {
        const { blockSize, inlineSize } = entry.contentBoxSize[0];
        this._current[id] = {
          width: inlineSize,
          height: blockSize
        };
        if (isDocumentFreezed && blockSize < entry.target.scrollHeight) {
          makeElementScrollable(document.getElementById(id));
        }
      }
    }
  },
  _maxHeight: window.innerHeight - 66,
  init() {
    this.__observer = new ResizeObserver(this.__onResize.bind(this));
    document.addEventListener("resize", () => {
      this._maxHeight = window.innerHeight - 66;
    });
  },
  _register(config) {
    _all[config.id] = config;
  },
  _unregister(areaId) {
    delete _all[areaId];
  },
  _onKeyDown(e, id) {
    const isEscPressed = e.key === ESC_KEY;
    if (isEscPressed) {
      this.hide(id);
    }
  },
  async show(id) {
    var _a;
    await transitionManager.waitForTransition();
    const config = _all[id];
    const isAlreadyOpen = Object.keys(this._current).length > 0;
    if (isAlreadyOpen) {
      Object.keys(this._current).forEach((id2) => {
        this.hide(id2);
      });
      await new Promise((resolve) => {
        setTimeout(resolve, 50);
      });
    }
    if (config) {
      const { width, height } = document.getElementById(id).getBoundingClientRect();
      this._current[id] = {
        width,
        height
      };
    }
    const resizable = document.getElementById(id);
    (_a = this.__observer) == null ? void 0 : _a.observe(resizable);
    this._keyDownEventListener = (e) => {
      this._onKeyDown(e, id);
    };
    document.addEventListener("keydown", this._keyDownEventListener);
    this.originalFocusableEl = document.activeElement.closest(SELECTOR_LIST);
  },
  hide(id) {
    var _a;
    const resizableElement = document.getElementById(id);
    if (resizableElement) {
      transitionManager.addTransitionState(resizableElement, { className: "resizable-transition" });
    }
    const wrapperEl = document.querySelector(
      ".resizable--visible .resizable__content--portal"
    );
    if (wrapperEl) {
      wrapperEl.removeAttribute("role");
      wrapperEl.removeAttribute("aria-modal");
      wrapperEl.removeAttribute("aria-labelledby");
    }
    const resizable = document.getElementById(id);
    (_a = this.__observer) == null ? void 0 : _a.unobserve(resizable);
    delete this._current[id];
    document.removeEventListener("keydown", this._keyDownEventListener);
    resizable.closest(".resizable").addEventListener(
      "transitionend",
      () => {
        var _a2;
        (_a2 = this.originalFocusableEl) == null ? void 0 : _a2.focus();
        if (resizableElement) {
          transitionManager.removeTransitionState(resizableElement, { className: "resizable-transition" });
        }
      },
      { once: true }
    );
  },
  hideAll() {
    Object.keys(this._current).forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        transitionManager.addTransitionState(element, { className: "resizable-transition" });
      }
    });
    Object.keys(this._current).forEach((id) => {
      this.hide(id);
    });
  },
  isVisible(id = null) {
    const keys = Object.keys(this._current);
    if (id) {
      return keys.includes(id);
    }
    return keys.length;
  }
};
const ProductListStore = {
  isFiltersSidebarExpanded: true,
  toggleFiltersSidebar() {
    this.isFiltersSidebarExpanded = !this.isFiltersSidebarExpanded;
  }
};
const Main = {
  showCurrency: false,
  isHeaderShadowVisible: false,
  scaleFactor: 1,
  yOffset: 0,
  totalCartQty: 0,
  totalWishlistQty: 0,
  isMobile: isMobile(),
  isTablet: isTablet(),
  isPrint: window.matchMedia("print").matches,
  isReducedMotion: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
  opacityOnZoom: 1,
  isMenuVisible: false,
  isTransitioning: false,
  isGrid: true,
  init() {
    this.setTransformValues();
    this.onResize();
    window.addEventListener("resize", this.onResize.bind(this));
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    mediaQuery.addEventListener("change", (e) => {
      this.isReducedMotion = e.matches;
    });
    const printQuery = window.matchMedia("print");
    printQuery.addEventListener("change", (e) => {
      this.isPrint = e.matches;
    });
    this.setHeaderHeightProperty();
    Alpine.effect(() => {
      if (this.isMobile && this.isMenuVisible) {
        document.body.style.overflow = "hidden";
        document.body.classList.add("mobile-menu-open");
      } else {
        document.body.style.overflow = "";
        document.body.classList.remove("mobile-menu-open");
      }
    });
    Alpine.effect(() => {
      this.isTransitioning = transitionManager.isInTransition();
    });
  },
  getHeaderHeight() {
    var _a;
    this.headerHeight = ((_a = document.querySelector("#header")) == null ? void 0 : _a.clientHeight) || 0;
    return this.headerHeight;
  },
  setHeaderHeightProperty() {
    Alpine.nextTick(() => {
      document.body.style.setProperty(
        "--header-height",
        `${this.getHeaderHeight()}px`
      );
    });
  },
  onResize() {
    const newIsMobile = isMobile();
    const newIsTablet = isTablet();
    if (this.isMobile !== newIsMobile || this.isTablet !== newIsTablet) {
      transitionManager.startTransition();
      Alpine.store("popup").currentPopup = null;
      Alpine.store("resizable")._current = {};
      unfreezeScroll();
      const portalTargets = [
        "popup-fixed-content-portal",
        "cart-desktop-fixed",
        "menu-desktop-fixed",
        "search-desktop",
        "filters-sidebar",
        "selected-filters-mobile",
        "popup-content-portal",
        "cart-totals",
        "wishlist-desktop",
        "notification-portal",
        "filters-form-mobile",
        "search-actions"
      ].map((id) => document.getElementById(id)).filter(Boolean);
      portalTargets.forEach((target) => {
        while (target == null ? void 0 : target.firstChild) {
          target.removeChild(target.firstChild);
        }
      });
      Alpine.nextTick(() => {
        this.isMobile = newIsMobile;
        this.isTablet = newIsTablet;
        document.documentElement.style.setProperty(
          "--screen-width",
          window.innerWidth.toString()
        );
        document.documentElement.style.setProperty(
          "--screen-height",
          window.innerHeight.toString()
        );
        this.setHeaderHeightProperty();
        setTimeout(() => transitionManager.endTransition(), 100);
      });
    } else {
      document.documentElement.style.setProperty(
        "--screen-width",
        window.innerWidth.toString()
      );
      document.documentElement.style.setProperty(
        "--screen-height",
        window.innerHeight.toString()
      );
      this.setHeaderHeightProperty();
    }
  },
  setTransformValues() {
    const desiredOffset = 8;
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const desiredEndWidth = windowWidth + desiredOffset * 2;
    const documentScrollHeight = document.body.scrollHeight;
    const widthScaleFactor = (desiredEndWidth - windowWidth) / windowWidth;
    const heightScaleFactor = (windowHeight - desiredOffset * 2) / windowHeight;
    const minScaleFactor = Math.min(widthScaleFactor, heightScaleFactor);
    const newScaleFactor = 1 + minScaleFactor;
    const newYOffset = documentScrollHeight * minScaleFactor * -1 * window.scrollY / documentScrollHeight;
    this.scaleFactor = newScaleFactor;
    this.yOffset = newYOffset;
  },
  getPrice(value) {
    var _a, _b, _c;
    const locale = ((_a = window == null ? void 0 : window.Shopify) == null ? void 0 : _a.locale) || "en";
    const currency = ((_c = (_b = window == null ? void 0 : window.Shopify) == null ? void 0 : _b.currency) == null ? void 0 : _c.active) || "USD";
    const displayedCurrency = this.showCurrency ? ` ${currency}` : "";
    const price = Number.isInteger(value) ? value / 100 : Number(value) / 100 || 0;
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency
    }).format(price).replace(".00", "") + displayedCurrency;
  },
  isPopupFocused() {
    return this.isMobile ? Alpine.store("popup").isCurrentPopupFocused : Object.keys(Alpine.store("resizable")._current).length > 0;
  },
  hideAllPopupsAndResizables() {
    Alpine.store("popup").hideAllPopups();
    Alpine.store("resizable").hideAll();
  },
  hideMenu() {
    this.isMenuVisible = false;
  },
  toggleMenu() {
    this.isMenuVisible = !this.isMenuVisible;
    if (this.isMenuVisible && Alpine.store("popup").currentPopup) {
      Alpine.store("popup").hideAllPopups();
    }
  }
};
const CART_RESIZABLE_ID = "cart-desktop";
const CART_POPUP_ID = "cart";
const SECTION_MAIN_CART_ITEMS = "main-cart-items";
const ABORT_ERROR_NAME = "AbortError";
const CartStore = {
  cartType: "drawer",
  cartUrl: "",
  cartItems: [],
  processedItemsCache: {},
  // Cache for processed items by variant_id
  discounts: [],
  isCartInitialized: false,
  isLoading: false,
  addingItemIds: [],
  removingItemKey: null,
  abortController: null,
  discountedPrice: null,
  discountError: null,
  discountSuccess: false,
  error: {
    message: void 0,
    errors: {}
  },
  accessToken: null,
  updatingItemKeys: /* @__PURE__ */ new Set(),
  init() {
    {
      document.addEventListener("la:dn:cart:updated", (event) => {
        const discountedCart = event.detail.data[0];
        if (discountedCart.total.discountedPrice) {
          this.discountedPrice = discountedCart.total.discountedPrice;
        }
      });
    }
  },
  setCartItems(cartItems) {
    if (typeof window.window.custom_storefront_api_token === "string") {
      this.setAccessToken(window.window.custom_storefront_api_token);
    }
    const processedItems = this.processCartItems(cartItems);
    this.cartItems = processedItems;
    Alpine.store("main").totalCartQty = cartItems.reduce(
      (total, item) => total + item.quantity,
      0
    );
    document.dispatchEvent(new CustomEvent("cart:updated"));
  },
  setAccessToken(token) {
    this.accessToken = token;
  },
  addCartItems(cartItems) {
    this.setCartItems([...cartItems, ...this.cartItems]);
  },
  addCartItemsAndShow(cartItems, focusKey, addingItemId) {
    const newCartItems = [...cartItems, ...this.cartItems];
    const processedItems = this.processCartItems(newCartItems);
    this.cartItems = processedItems;
    Alpine.store("main").totalCartQty = newCartItems.reduce(
      (total, item) => total + item.quantity,
      0
    );
    document.dispatchEvent(new CustomEvent("cart:updated"));
    if (focusKey) {
      this.focusInCart(focusKey);
    }
    if (addingItemId) {
      this.addingItemIds = this.addingItemIds.filter(
        (itemId) => itemId !== addingItemId
      );
    }
  },
  addCartItemsAndShowProcessed(cartItems, focusKey, addingItemId) {
    const newCartItems = [...cartItems, ...this.cartItems];
    this.cartItems = newCartItems;
    Alpine.store("main").totalCartQty = newCartItems.reduce(
      (total, item) => total + item.quantity,
      0
    );
    document.dispatchEvent(new CustomEvent("cart:updated"));
    this.isLoading = false;
    if (focusKey) {
      this.focusInCart(focusKey);
    }
    if (addingItemId) {
      this.addingItemIds = this.addingItemIds.filter(
        (itemId) => itemId !== addingItemId
      );
    }
  },
  addMultipleToCart(items, showCart = true) {
    if (items.length === 0) return Promise.resolve(false);
    const formData = {
      items,
      sections: "header"
    };
    return fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    }).then((response) => response.json()).then((response) => {
      var _a;
      if (response.status === 422) {
        this.error.message = response.description;
        this.error.errors = response.errors;
        return false;
      }
      const processedItems = this.processCartItems(response.items);
      const newCartItems = [...processedItems, ...this.cartItems];
      this.cartItems = newCartItems;
      Alpine.store("main").totalCartQty = newCartItems.reduce(
        (total, item) => total + item.quantity,
        0
      );
      document.dispatchEvent(new CustomEvent("cart:updated"));
      if (showCart && response.items.length > 0) {
        this.focusInCart((_a = response.items[0]) == null ? void 0 : _a.key);
      }
      this.error.message = "";
      this.error.errors = {};
      return true;
    }).catch((error) => {
      this.error.message = error.message;
      return false;
    });
  },
  // Cart items returned from 'cart/add.js' and 'cart/update.js' AJAX calls have image SRCs with cdn.shopify.com base URL.
  // This method updates the image SRCs to make them consistent with the SRCs we already have in PDP
  processCartItems(items) {
    return items.map((item) => {
      var _a;
      return {
        ...item,
        image: (_a = item.image) == null ? void 0 : _a.replace(
          /^https:\/\/cdn\.shopify\.com\/s\/files\/(?:\d+\/)+files/,
          `//${window.Shopify.cdnHost}/shop/files`
        )
      };
    });
  },
  addToCart(itemProps) {
    const { id } = itemProps;
    if (!this.addingItemIds.includes(id)) {
      this.addingItemIds.push(id);
    }
    const formData = {
      items: itemProps.items || [
        { id: itemProps.id, quantity: itemProps.quantity }
      ],
      sections: "header"
    };
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    }).then((response) => response.json()).then((response) => {
      var _a;
      if (response.status === 422) {
        this.error.message = response.description;
        this.error.errors = response.errors;
        this.isLoading = false;
        this.addingItemIds = this.addingItemIds.filter(
          (itemId) => itemId !== id
        );
        this.updateCart();
        return;
      }
      const items = this.processCartItems(response.items);
      this.addCartItemsAndShowProcessed(
        items,
        response.items.length > 0 ? (_a = response.items[0]) == null ? void 0 : _a.key : null,
        id
      );
      if (this.cartType === "page") {
        navigateWithTransition(this.cartUrl);
        this.addingItemIds = this.addingItemIds.filter(
          (itemId) => itemId !== id
        );
        return;
      }
      this.error.message = "";
      this.error.errors = {};
      if (response.sections.header) {
        replaceContent(
          response.sections.header,
          "mini-cart",
          document.getElementById("mini-cart")
        );
      }
    }).catch((error) => {
      this.error.message = error.message;
      this.isLoading = false;
      this.addingItemIds = this.addingItemIds.filter(
        (itemId) => itemId !== id
      );
    });
  },
  isItemUpdating(key) {
    return this.updatingItemKeys.has(key);
  },
  updateCartItem(key, qty) {
    if (this.abortController) {
      this.removingItemKey = null;
      this.abortController.abort();
    }
    this.updatingItemKeys.add(key);
    this.isLoading = true;
    this.abortController = new AbortController();
    const cartItem = this.cartItems.find((item) => item.key === key);
    if (!cartItem) {
      this.updatingItemKeys.delete(key);
      return;
    }
    if (cartItem.quantity === 0) {
      cartItem.isDeleted = true;
      this.removingItemKey = key;
    }
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: {
          [key]: qty
        },
        sections: SECTION_MAIN_CART_ITEMS
      }),
      signal: this.abortController.signal
    }).then((response) => response.json()).then((data) => {
      var _a;
      this.setDiscounts(
        (_a = data.cart_level_discount_applications) == null ? void 0 : _a.map((discount) => {
          var _a2, _b;
          return {
            title: (_a2 = discount.discount_application) == null ? void 0 : _a2.title,
            total_allocated_amount: (_b = discount.discount_application) == null ? void 0 : _b.total_allocated_amount
          };
        })
      );
      Alpine.store("main").totalCartQty = data.items.reduce(
        (total, item) => total + item.quantity,
        0
      );
      const items = this.processCartItems(data.items);
      this.setCartItems(items);
      this.isLoading = false;
      this.removingItemKey = null;
      this.updatingItemKeys.delete(key);
    }).catch((error) => {
      if (error.name !== ABORT_ERROR_NAME) {
        this.isLoading = false;
        this.removingItemKey = null;
      }
      this.updatingItemKeys.delete(key);
    });
  },
  updateCart() {
    if (this.abortController) {
      this.removingItemKey = null;
      this.abortController.abort();
    }
    this.isLoading = true;
    this.abortController = new AbortController();
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: {},
        sections: SECTION_MAIN_CART_ITEMS
      }),
      signal: this.abortController.signal
    }).then((response) => response.json()).then((data) => {
      var _a;
      Alpine.store("main").totalCartQty = data.items.reduce(
        (total, item) => total + item.quantity,
        0
      );
      this.setDiscounts(
        (_a = data.cart_level_discount_applications) == null ? void 0 : _a.map((discount) => {
          var _a2, _b;
          return {
            title: (_a2 = discount.discount_application) == null ? void 0 : _a2.title,
            total_allocated_amount: (_b = discount.discount_application) == null ? void 0 : _b.total_allocated_amount
          };
        })
      );
      const items = this.processCartItems(data.items);
      this.setCartItems(items);
      this.isLoading = false;
      this.removingItemKey = null;
    }).catch((error) => {
      if (error.name !== ABORT_ERROR_NAME) {
        this.isLoading = false;
        this.removingItemKey = null;
      }
    });
  },
  increaseQty(key, openCart = false) {
    var _a, _b, _c;
    if (this.isItemUpdating(key)) return;
    const cartItem = this.cartItems.find((item) => item.key === key);
    if (cartItem) {
      const increment = ((_a = cartItem.quantity_rule) == null ? void 0 : _a.increment) || 1;
      let newQuantity = Number(cartItem.quantity) + increment;
      if (((_b = cartItem.quantity_rule) == null ? void 0 : _b.max) !== null && ((_c = cartItem.quantity_rule) == null ? void 0 : _c.max) !== void 0) {
        newQuantity = Math.min(newQuantity, cartItem.quantity_rule.max);
      }
      cartItem.quantity = newQuantity;
      this.updateCartItem(key, cartItem.quantity);
      if (openCart) {
        return this.focusInCart(key);
      }
    }
  },
  focusInCart(key) {
    this.cartItems.forEach((cartItem) => {
      const isFocused = cartItem.key === key;
      cartItem.focusedUntil = isFocused ? Date.now() + 2e3 : void 0;
    });
    this.showCart();
  },
  showCart() {
    if (Alpine.store("main").isMobile) {
      Alpine.store("popup").showPopup(CART_POPUP_ID, true);
    } else {
      Alpine.store("resizable").show(CART_RESIZABLE_ID);
    }
  },
  hideCart() {
    this._updateFocusAnimation();
    if (Alpine.store("main").isMobile) {
      Alpine.store("popup").hidePopup(CART_POPUP_ID);
    } else {
      Alpine.store("resizable").hide(CART_RESIZABLE_ID);
    }
  },
  decreaseQty(key, openCart = false) {
    var _a;
    if (this.isItemUpdating(key)) return;
    const cartItem = this.cartItems.find((item) => item.key === key);
    if (cartItem) {
      const increment = ((_a = cartItem.quantity_rule) == null ? void 0 : _a.increment) || 1;
      let newQuantity = Number(cartItem.quantity) - increment;
      newQuantity = Math.max(newQuantity);
      cartItem.quantity = newQuantity;
      this.updateCartItem(key, cartItem.quantity);
      if (openCart) {
        return this.focusInCart(key);
      }
    }
  },
  setQty(quantity, key) {
    const cartItem = this.cartItems.find((item) => item.key === key);
    if (cartItem) {
      let newQuantity = Number(quantity);
      if (cartItem.quantity_rule) {
        const { min, max, increment } = cartItem.quantity_rule;
        newQuantity = Math.max(min || 0, newQuantity);
        if (max !== null && max !== void 0) {
          newQuantity = Math.min(max, newQuantity);
        }
        if (increment > 1) {
          const distanceFromMin = newQuantity - (min || 0);
          const increments = Math.round(distanceFromMin / increment);
          newQuantity = (min || 0) + increments * increment;
        }
      } else {
        newQuantity = Math.max(0, newQuantity);
      }
      cartItem.quantity = newQuantity;
      this.updateCartItem(key, cartItem.quantity);
    }
  },
  setDiscounts(discounts) {
    this.discounts = discounts;
  },
  subtotalPrice() {
    const subtotalPrice = this.cartItems.reduce(
      (total, item) => total + item.final_price * item.quantity,
      0
    );
    return Alpine.store("main").getPrice(subtotalPrice);
  },
  totalPrice() {
    const subtotalPrice = this.cartItems.reduce(
      (total, item) => total + item.final_price * item.quantity,
      0
    );
    const discounts = this.discounts.reduce(
      (total, discount) => total + discount.total_allocated_amount,
      0
    );
    return Alpine.store("main").getPrice(subtotalPrice - discounts);
  },
  freeShippingRemaining(freeShippingMin) {
    const subtotalPrice = this.cartItems.reduce(
      (total2, item) => total2 + item.final_price * item.quantity,
      0
    );
    const discounts = this.discounts.reduce(
      (total2, discount) => total2 + discount.total_allocated_amount,
      0
    );
    let total = subtotalPrice - discounts;
    {
      if (this.discountedPrice) {
        total = this.discountedPrice;
      }
    }
    const remaining = Math.max(freeShippingMin - total, 0);
    if (remaining === 0) return "0";
    return Alpine.store("main").getPrice(remaining);
  },
  applyDiscount(discountCode) {
    this.discountError = null;
    this.discountSuccess = false;
    this.isLoading = true;
    const formData = new FormData();
    formData.append("discount", discountCode);
    return fetch(`${window.Shopify.routes.root}discount/${discountCode}`, {
      method: "POST",
      body: formData
    }).then((response) => {
      if (!response.ok) {
        this.discountError = "Invalid discount code";
        this.discountSuccess = false;
        this.isLoading = false;
        return false;
      }
      return this.updateCart();
    }).then(() => {
      this.discountSuccess = true;
      this.isLoading = false;
      return true;
    }).catch((error) => {
      this.error.message = error.message;
      this.discountError = error.message || "Error applying discount code";
      this.discountSuccess = false;
      this.isLoading = false;
      return false;
    });
  },
  removeDiscount() {
    this.discountError = null;
    this.discountSuccess = false;
    this.isLoading = true;
    return fetch(`${window.Shopify.routes.root}discount/clear`, {
      method: "POST"
    }).then((response) => {
      if (!response.ok) {
        throw new Error("Failed to remove discount");
      }
      return this.updateCart();
    }).then(() => {
      this.isLoading = false;
      return true;
    }).catch((error) => {
      this.discountError = error.message || "Error removing discount code";
      this.discountSuccess = false;
      this.isLoading = false;
      return false;
    });
  },
  _updateFocusAnimation() {
    this.cartItems.forEach((cartItem) => {
      if (cartItem.focusedUntil) {
        cartItem.focusedUntil = Date.now() < cartItem.focusedUntil ? cartItem.focusedUntil : void 0;
      }
    });
  },
  // Add implementations of Cart methods for inventory management
  // These methods handle inventory checks, quantity limits, and warnings
  getAvailableQuantity(item) {
    return item.quantity_available || 99;
  },
  hasInventoryPolicy(item) {
    return typeof item.quantity_available !== "undefined";
  },
  getMaxQuantity(item) {
    var _a, _b;
    const availableQty = this.getAvailableQuantity(item);
    const hasDenyPolicy = this.hasInventoryPolicy(item);
    return hasDenyPolicy ? Math.min(((_a = item.quantity_rule) == null ? void 0 : _a.max) || 99, availableQty) : ((_b = item.quantity_rule) == null ? void 0 : _b.max) || 99;
  },
  isOverInventoryLimit(item) {
    const availableQty = this.getAvailableQuantity(item);
    const hasDenyPolicy = this.hasInventoryPolicy(item);
    return hasDenyPolicy && item.quantity > availableQty;
  },
  isIncreaseDisabled(item) {
    const availableQty = this.getAvailableQuantity(item);
    const hasDenyPolicy = this.hasInventoryPolicy(item);
    return hasDenyPolicy && item.quantity >= availableQty;
  },
  validateQuantityInput(event, item) {
    const input = event.target;
    const newQty = parseInt(input.value);
    if (isNaN(newQty)) return;
    const maxQty = this.getMaxQuantity(item);
    const hasDenyPolicy = this.hasInventoryPolicy(item);
    if (hasDenyPolicy && newQty > maxQty) {
      input.value = maxQty.toString();
      item.quantity = maxQty;
      this.showQuantityWarning(item.product_title, maxQty, item.key);
    }
  },
  validateAndSetQuantity(event, item) {
    if (this.isItemUpdating(item.key)) return;
    const input = event.target;
    const newQty = parseInt(input.value);
    if (isNaN(newQty)) return;
    const maxQty = this.getMaxQuantity(item);
    const hasDenyPolicy = this.hasInventoryPolicy(item);
    if (hasDenyPolicy && newQty > maxQty) {
      input.value = maxQty.toString();
      item.quantity = maxQty;
      this.showQuantityWarning(item.product_title, maxQty, item.key);
      this.setQty(maxQty, item.key);
    } else {
      this.setQty(newQty, item.key);
    }
  },
  validateAndIncreaseQty(item) {
    if (this.isIncreaseDisabled(item)) {
      const maxQty = this.getAvailableQuantity(item);
      this.showQuantityWarning(item.product_title, maxQty, item.key);
      return;
    }
    this.increaseQty(item.key);
  },
  showQuantityWarning(productTitle, maxQty, itemKey) {
    const message = maxQty === 1 ? `Only 1 ${productTitle} is available` : `Only ${maxQty} units of ${productTitle} are available`;
    window.dispatchEvent(
      new CustomEvent("show-quantity-warning", {
        detail: {
          message,
          itemKey
        }
      })
    );
  }
};
const dom = {
  wishlistContainer: () => document.getElementById(Alpine.store("main").isMobile ? "swym-wishlist-render-container" : "swym-wishlist-render-container-desktop"),
  emptyState: () => document.querySelector(".swym-empty-wishlist"),
  wishlistCounters: () => document.querySelectorAll(".swym-wishlist-counter"),
  wishlistButtons: () => document.querySelectorAll(".add-to-wishlist-button")
};
const wishListUtils = {
  withSwym: function(callback) {
    if (window.SwymCallbacks) {
      window.SwymCallbacks.push(callback);
    }
  },
  updateAlpineStore: function(count) {
    Alpine.store("main").totalWishlistQty = count;
  },
  showNotification: function(swat, type, message) {
    if (type === "success") {
      swat.ui.showSuccessNotification({ message });
    } else {
      swat.ui.showErrorNotification({ message });
    }
  },
  isWishlistVisible: function() {
    const isMobile2 = Alpine.store("main").isMobile;
    if (isMobile2) {
      return Alpine.store("popup").currentPopup === "wishlist";
    } else {
      return Alpine.store("resizable").isVisible("wishlist-desktop");
    }
  },
  dispatchEvent: function(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  },
  updatePDPButtons: function() {
    wishListUtils.withSwym((swat) => {
      swat.fetch((products) => {
        if (!products) return;
        dom.wishlistButtons().forEach((button) => {
          const productId = button.getAttribute("data-product-id");
          const variantId = button.getAttribute("data-variant-id");
          const isInWishlist = products.some((p) => p.empi == productId && p.epi == variantId);
          if (isInWishlist) {
            button.classList.add("in-wishlist");
            button.classList.remove("button--outline-secondary");
            button.classList.add("button--outline-danger");
            button.setAttribute("data-in-wishlist", "true");
            const outlineIcon = button.querySelector(".wishlist-icon-outline");
            const filledIcon = button.querySelector(".wishlist-icon-filled");
            if (outlineIcon && filledIcon) {
              outlineIcon.classList.add("hidden");
              filledIcon.classList.remove("hidden");
            }
          } else {
            button.classList.remove("in-wishlist");
            button.classList.add("button--outline-secondary");
            button.classList.remove("button--outline-danger");
            button.removeAttribute("data-in-wishlist");
            const outlineIcon = button.querySelector(".wishlist-icon-outline");
            const filledIcon = button.querySelector(".wishlist-icon-filled");
            if (outlineIcon && filledIcon) {
              outlineIcon.classList.remove("hidden");
              filledIcon.classList.add("hidden");
            }
          }
        });
      });
    });
  }
};
const wishListCounter = {
  update: function(count) {
    wishListUtils.updateAlpineStore(count);
    dom.wishlistCounters().forEach((counter) => {
      counter.textContent = `${count}`;
      counter.style.display = count > 0 ? "flex" : "none";
    });
  },
  refresh: function(swat) {
    swat.fetch((products) => {
      const count = products ? products.length : 0;
      this.update(count);
    });
  }
};
const WISHLIST_RESIZABLE_ID = "wishlist-desktop";
const WISHLIST_POPUP_ID = "wishlist";
const WishlistStore = {
  translations: {},
  init() {
    const self2 = this;
    document.addEventListener("wishlist:updated", function() {
      self2.refreshContent();
    });
    document.addEventListener("DOMContentLoaded", function() {
      self2.refreshContent();
      wishListUtils.withSwym((swat) => {
        self2.render(swat);
        swat.evtLayer.addEventListener(swat.JSEvents.wishlistCountUpdated, function() {
          self2.render(swat);
        });
        swat.evtLayer.addEventListener(swat.JSEvents.wishlistCountUpdated, function() {
          wishListCounter.refresh(swat);
        });
      });
    });
    document.addEventListener("cart:updated", function() {
      self2.refreshContent();
    });
  },
  registerTranslations(translations) {
    this.translations = translations;
  },
  setFallBackImage(url) {
    this.fallBackImage = url;
  },
  showWishlist() {
    if (Alpine.store("main").isMobile) {
      Alpine.store("popup").showPopup(WISHLIST_POPUP_ID, true);
    } else {
      Alpine.store("resizable").show(WISHLIST_RESIZABLE_ID);
    }
  },
  hideWishlist() {
    if (Alpine.store("main").isMobile) {
      Alpine.store("popup").hidePopup(WISHLIST_POPUP_ID);
    } else {
      Alpine.store("resizable").hide(WISHLIST_RESIZABLE_ID);
    }
  },
  render: function(swatInstance) {
    const swymInstance = swatInstance || window.swat;
    swymInstance.fetch((products) => {
      const container = dom.wishlistContainer();
      const emptyState = dom.emptyState();
      if (!products || products.length === 0) {
        if (emptyState) emptyState.classList.remove("hidden");
        if (container) container.innerHTML = "";
        return;
      }
      if (emptyState) emptyState.classList.add("hidden");
      this.processProducts(products, (formattedProducts) => {
        let html = "";
        formattedProducts.forEach((product) => {
          html += this.generateProductHTML(product);
        });
        wishListCounter.update(formattedProducts.length);
        if (container) {
          container.innerHTML = html;
        }
      });
    });
  },
  processProducts: function(products, callback) {
    const formattedProducts = products.map((p) => {
      const formattedProduct = window.SwymUtils.formatProductPrice(p);
      if (p.vt) {
        const variantParts = p.vt.split(" / ");
        formattedProduct.vi = variantParts.join(" | ");
      }
      return formattedProduct;
    });
    const fetchPromises = formattedProducts.map((product) => {
      const urlParts = product.du.split("/products/");
      if (urlParts.length < 2) return Promise.resolve(product);
      const handle = urlParts[1].split("?")[0].split("#")[0];
      return fetch(`/products/${handle}.js`).then((response) => response.json()).then((shopifyProduct) => {
        const variant = shopifyProduct.variants.find((v) => v.id == product.epi);
        if (variant) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            product.op = variant.compare_at_price / 100;
          }
          product.isAvailable = variant.available;
        }
        return product;
      }).catch(() => product);
    });
    Promise.all(fetchPromises).then(() => {
      callback(formattedProducts);
    }).catch((error) => {
      console.error("Error fetching product data:", error);
      callback(formattedProducts);
    });
  },
  generateProductHTML: function(product) {
    const hasVariantAttributes = product.vi && product.vi.length > 0;
    let variantInfo = product.vi;
    if (variantInfo && variantInfo.includes(" / ")) {
      variantInfo = variantInfo.split(" / ").join('</span><span class="pipe">|</span><span>');
      variantInfo = `<span>${variantInfo}</span>`;
    }
    function isImgUrl(url) {
      if (!url) return false;
      return /\.(jpg|jpeg|png|webp|avif|gif)$/.test(url) || !url.includes("[object");
    }
    const isValidUrl = isImgUrl(product.iu);
    const hasDiscount = product.op && product.op > +product.pr;
    const originalPrice = product.op || 0;
    const isInCart = Alpine.store("cart").cartItems.some((item) => item.id == Number(product.epi) && !item.isDeleted);
    return `
      <a href="${product.du}" class="swym-wishlist-item h-[120px] flex items-center  w-full gap-5 bg-transparent z-10">
        <div class="w-[124px] h-full flex items-center justify-center">
          ${`<img class='${isValidUrl ? "h-full w-full object-center object-cover" : ""} max-w-full' src='${isValidUrl ? product.iu : this.fallBackImage}' alt='${product.dt}'/>`}
        </div>
        <div class="w-full flex flex-col" >
        <div>
        <div class="text-base text-wrap">${product.dt}</div>
          ${hasVariantAttributes ? `<div class="text-[14px] text-grey-400 mt-0.5">${variantInfo}</div>` : ""}
        </div>
          <div class="gap-2 flex w-full justify-between items-end mt-[14px]">
            <div class="flex gap-3">
              <button
                class="swym-delete-btn h-9 w-9 flex items-center justify-center p-3 border border-grey-100 hover:bg-grey-50"
                data-variant-id="${product.epi}"
                data-product-id="${product.empi}"
                data-du="${product.du}"
                onmousedown="this.classList.remove('border-grey-900'); this.classList.add('border-grey-100');"
                onclick="event.preventDefault(); Alpine.store('wishlist').removeItem(this, '${product.empi}', '${product.epi}');"
                aria-label="Remove from wishlist"
              >
                <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5"
                >
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="currentColor"/>
                </svg>

              </button>
              ${product.isAvailable === false ? `
              <button
                class="px-3 py-2 h-9 text-sm border border-grey-100 button--disabled capitalize"
                disabled
              >${this.translations.outOfStock}</button>
              ` : isInCart ? `
              <button
                class="flex items-center gap-3 p-3 py-2 h-9 text-sm border border-grey-900 hover:bg-grey-50 capitalize"
              >
                <svg class="w-5 h-5 hidden md:block" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Icon/Arrows/icon/checkmark">
                <path id="Vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M15.2615 4.75526C15.6927 4.32412 16.3917 4.32412 16.8228 4.75526C17.254 5.1864 17.254 5.88542 16.8228 6.31657L7.40362 15.7358L3.19276 11.5249C2.76162 11.0938 2.76162 10.3947 3.19276 9.9636C3.6239 9.53245 4.32292 9.53245 4.75407 9.9636L7.40362 12.6132L15.2615 4.75526Z" fill="#181818"/>
                </g>
                </svg>
                <p >${this.translations.addedToCart}</p>
              </button>
              ` : `
              <button
                class="px-3 py-2 h-9 text-sm border border-grey-100 hover:bg-grey-50 capitalize"
                onclick="event.preventDefault(); event.stopPropagation(); Alpine.store('wishlist').addToCart(this, '${product.epi}', '${product.empi}', '${product.du}', '${product.dt}');"
              >${this.translations.addToCart}</button>
              `}
            </div>
            <div class="swym-product-price-container">
              ${hasDiscount ? `<div class="text-grey-400 text-sm text-end line-through">${product.cu}${originalPrice}</div>` : ""}
              <div class="text-base font-medium leading-[20px]">${product.cu}${parseFloat(product.pr).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}</div>
            </div>
          </div>
        </div>
      </a>
    `;
  },
  renderWishList() {
    if (window.SwymCallbacks) {
      window.SwymCallbacks.push((swat) => {
        this.render(swat);
      });
    }
  },
  addToCart: function(button, variantId, productId, productUrl, productTitle) {
    wishListUtils.withSwym((swat) => {
      swat.replayAddToCart(
        {
          empi: productId,
          du: productUrl,
          qty: 1
        },
        variantId,
        function(success) {
          try {
            const response = JSON.parse(success);
            const variant = response.items[0];
            const title = variant.title || productTitle;
            button.classList.add("flex", "items-center", "gap-3", "p-3", "py-2", "h-9", "text-sm", "border", "border-grey-900", "hover:bg-grey-50", "capitalize");
            button.innerHTML = `
             <svg class="w-5 h-5 hidden md:block" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Icon/Arrows/icon/checkmark">
                <path id="Vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M15.2615 4.75526C15.6927 4.32412 16.3917 4.32412 16.8228 4.75526C17.254 5.1864 17.254 5.88542 16.8228 6.31657L7.40362 15.7358L3.19276 11.5249C2.76162 11.0938 2.76162 10.3947 3.19276 9.9636C3.6239 9.53245 4.32292 9.53245 4.75407 9.9636L7.40362 12.6132L15.2615 4.75526Z" fill="#181818"/>
                </g>
                </svg>
                <p class="capitalize">Added to cart</p>
            `;
            wishListUtils.showNotification(swat, "success", `<strong>${title}</strong> has been added to cart!`);
            wishListUtils.dispatchEvent("wishlist:item-added-to-cart", {
              variantId,
              productId,
              productUrl
            });
            Alpine.store("cart").updateCart();
          } catch (error) {
            console.error("Error parsing add to cart response:", error);
            wishListUtils.showNotification(swat, "error", "Error adding to cart. Please try again.");
          }
        },
        function(error) {
          console.error("Failed to add to cart:", error);
          wishListUtils.showNotification(swat, "error", error.description || "Error adding to cart. Please try again.");
        }
      );
    });
  },
  removeItem: function(button, productId, variantId) {
    wishListUtils.withSwym((swat) => {
      swat.fetch((products) => {
        const product = products == null ? void 0 : products.find((p) => p.empi == productId && p.epi == variantId);
        if (product) {
          swat.removeFromWishList(product, function() {
            const wishlistItem = button.closest(".swym-wishlist-item");
            if (wishlistItem) {
              wishlistItem.remove();
            }
            wishListUtils.showNotification(swat, "success", `<strong>${product.dt}</strong> has been removed from your wishlist!`);
            swat.fetch((updatedProducts) => {
              var _a;
              const count = updatedProducts ? updatedProducts.length : 0;
              const container = dom.wishlistContainer();
              wishListCounter.update(count);
              if (count === 0) {
                (_a = dom.emptyState()) == null ? void 0 : _a.classList.remove("hidden");
                if (container) {
                  container.innerHTML = "";
                }
              }
              wishListUtils.dispatchEvent("wishlist:updated", {
                action: "remove",
                product
              });
            });
          });
          wishListUtils.updatePDPButtons();
        } else {
          console.error("Product not found in wishlist");
          wishListUtils.showNotification(swat, "error", "Error: Product not found in wishlist");
        }
      });
    });
  },
  refreshContent: function(forceRefresh = false) {
    if (forceRefresh || wishListUtils.isWishlistVisible()) {
      wishListUtils.withSwym((swat) => {
        this.render(swat);
      });
    }
    wishListUtils.updatePDPButtons();
  }
};
window.handleRingSettingClick = function(element, productHandle, variantId, store, dispatch) {
  try {
    let decodeAndParseJSON = function(data, fallback = []) {
      if (!data) return fallback;
      try {
        const decoded = data.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        return JSON.parse(decoded);
      } catch (e) {
        console.warn("Failed to parse JSON data:", { data, error: e });
        return fallback;
      }
    };
    const variants = decodeAndParseJSON(element.dataset.variants, []);
    let ringShapes = [];
    const shapesData = element.dataset.ringShapes;
    if (shapesData && shapesData !== "null") {
      ringShapes = decodeAndParseJSON(shapesData, []);
    }
    if (!Array.isArray(ringShapes)) {
      ringShapes = [];
    }
    const currentVariant = variants.find((v) => v.id == variantId);
    if (!currentVariant) {
      console.error("❌ Could not find variant with ID:", variantId);
      return;
    }
    const currentVariantOption = currentVariant.option1;
    let ringShapeLabel = null;
    if (ringShapes.length > 0) {
      if (ringShapes.length === 1) {
        ringShapeLabel = ringShapes[0].label;
      } else if (currentVariantOption && currentVariantOption !== "Default Title") {
        const exactMatch = ringShapes.find(
          (shape) => shape.label === currentVariantOption
        );
        if (exactMatch) {
          ringShapeLabel = exactMatch.label;
        } else {
          const caseInsensitiveMatch = ringShapes.find(
            (shape) => {
              var _a;
              return ((_a = shape.label) == null ? void 0 : _a.toLowerCase()) === (currentVariantOption == null ? void 0 : currentVariantOption.toLowerCase());
            }
          );
          if (caseInsensitiveMatch) {
            ringShapeLabel = caseInsensitiveMatch.label;
          } else {
            console.warn("❌ No shape match found for variant option:", currentVariantOption);
            console.warn("Available shapes:", ringShapes.map((s) => s.label));
          }
        }
      } else if (ringShapes.length > 1) {
        console.warn("❌ Multiple shapes available but variant option is Default Title");
        console.warn("Available shapes:", ringShapes.map((s) => s.label));
      }
    } else if (currentVariantOption && currentVariantOption !== "Default Title") {
      const commonShapes = ["round", "oval", "emerald", "princess", "radiant", "cushion", "pear", "marquise", "asscher", "heart"];
      if (commonShapes.includes(currentVariantOption.toLowerCase())) {
        ringShapeLabel = currentVariantOption;
      } else {
        console.warn("❌ Variant option doesn't look like a shape name:", currentVariantOption);
      }
    }
    if (ringShapeLabel) {
      const autoFilterInfo = {
        ringShape: ringShapeLabel,
        ringShapeLabel: ringShapeLabel.toLowerCase().trim(),
        timestamp: Date.now()
      };
      localStorage.setItem("ringBuilderAutoShape", JSON.stringify(autoFilterInfo));
    } else {
      console.warn("❌ No valid ring shape found - not storing for auto-filtering");
      localStorage.removeItem("ringBuilderAutoShape");
    }
    if (store.ringBuilder.data.settingData && store.ringBuilder.data.diamondData && store.ringBuilder.data.settingData.handle === productHandle) {
      dispatch("open-ring-popup");
    } else {
      store.ringBuilder.addSetting(productHandle, variantId);
    }
  } catch (error) {
    console.error("❌ Error in ring setting click handler:", error);
  }
};
const RingBuilderStore = {
  data: {
    isDiamondFirst: false,
    diamondData: void 0,
    settingData: void 0
  },
  loading: false,
  isAddingDiamond: false,
  isAddingSetting: false,
  isDiamondFirst: true,
  init() {
    this.loadRingData();
    this.fetchProducts();
    window.ringBuilder = {
      addDiamond: this.addDiamond.bind(this),
      addSetting: this.addSetting.bind(this),
      clearRing: this.clearRing.bind(this),
      setDiamondFirst: this.setDiamondFirst.bind(this),
      refreshData: this.fetchProducts.bind(this)
    };
  },
  setDiamondFirst(isDiamondFirst) {
    this.data.isDiamondFirst = isDiamondFirst;
    this.saveRingData();
  },
  async addDiamond(handle, variantId, specs = {}) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
    if (!handle || !variantId) {
      return;
    }
    this.isAddingDiamond = true;
    const hasExistingSetting = !!this.data.settingData;
    const isFirstProduct = !this.data.diamondData && !this.data.settingData;
    if (isFirstProduct) {
      this.data.isDiamondFirst = true;
    }
    this.data.diamondData = {
      handle,
      variantId,
      specs
    };
    this.saveRingData();
    await this.fetchProduct(handle, "diamond");
    if ((_a = this.data.diamondData) == null ? void 0 : _a.product) {
      const product = this.data.diamondData.product;
      let diamondShape = null;
      if ((_e = (_d = (_c = (_b = product.metafields) == null ? void 0 : _b.diamond_details) == null ? void 0 : _c.shape) == null ? void 0 : _d.value) == null ? void 0 : _e.label) {
        diamondShape = product.metafields.diamond_details.shape.value.label;
      } else if ((_h = (_g = (_f = product.metafields) == null ? void 0 : _f.diamond_details) == null ? void 0 : _g.shape) == null ? void 0 : _h.value) {
        diamondShape = product.metafields.diamond_details.shape.value;
      } else if ((_j = (_i = product.metafields) == null ? void 0 : _i.diamond_details) == null ? void 0 : _j.shape) {
        diamondShape = product.metafields.diamond_details.shape;
      } else if ((_n = (_m = (_l = (_k = product.metafields) == null ? void 0 : _k["Diamond details."]) == null ? void 0 : _l.shape) == null ? void 0 : _m.value) == null ? void 0 : _n.label) {
        diamondShape = product.metafields["Diamond details."].shape.value.label;
      } else if ((_q = (_p = (_o = product.metafields) == null ? void 0 : _o["Diamond details."]) == null ? void 0 : _p.shape) == null ? void 0 : _q.value) {
        diamondShape = product.metafields["Diamond details."].shape.value;
      } else if ((_s = (_r = product.metafields) == null ? void 0 : _r["Diamond details."]) == null ? void 0 : _s.shape) {
        diamondShape = product.metafields["Diamond details."].shape;
      }
      if (diamondShape && typeof diamondShape === "string") {
        const autoFilterInfo = {
          diamondShape,
          diamondShapeLabel: diamondShape.toLowerCase().trim(),
          timestamp: Date.now()
        };
        localStorage.setItem(
          "ringBuilderAutoDiamondShape",
          JSON.stringify(autoFilterInfo)
        );
      }
    }
    document.dispatchEvent(
      new CustomEvent("ring-builder:updated", { detail: { type: "diamond" } })
    );
    if (hasExistingSetting) {
      window.dispatchEvent(new CustomEvent("open-ring-popup"));
      this.isAddingDiamond = false;
    } else {
      window.location.href = this.getSecondStepCollectionUrl();
    }
  },
  async addSetting(handle, variantId) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
    if (!handle || !variantId) {
      return;
    }
    this.isAddingSetting = true;
    const hasExistingDiamond = !!this.data.diamondData;
    const isFirstProduct = !this.data.diamondData && !this.data.settingData;
    if (isFirstProduct) {
      this.data.isDiamondFirst = false;
    }
    this.data.settingData = {
      handle,
      variantId
    };
    this.saveRingData();
    await this.fetchProduct(handle, "setting");
    if ((_a = this.data.settingData) == null ? void 0 : _a.product) {
      const product = this.data.settingData.product;
      let ringShape = null;
      if ((_d = (_c = (_b = product.metafields) == null ? void 0 : _b.magento) == null ? void 0 : _c.ring_mainstone_shape) == null ? void 0 : _d.value) {
        if (Array.isArray(product.metafields.magento.ring_mainstone_shape.value)) {
          const firstShape = product.metafields.magento.ring_mainstone_shape.value[0];
          if (firstShape == null ? void 0 : firstShape.label) {
            ringShape = firstShape.label;
          }
        } else if (typeof product.metafields.magento.ring_mainstone_shape.value === "string") {
          ringShape = product.metafields.magento.ring_mainstone_shape.value;
        }
      } else if ((_f = (_e = product.metafields) == null ? void 0 : _e.magento) == null ? void 0 : _f.ring_mainstone_shape) {
        ringShape = product.metafields.magento.ring_mainstone_shape;
      } else if ((_i = (_h = (_g = product.metafields) == null ? void 0 : _g.magento) == null ? void 0 : _h.shape) == null ? void 0 : _i.value) {
        ringShape = product.metafields.magento.shape.value;
      } else if ((_k = (_j = product.metafields) == null ? void 0 : _j.magento) == null ? void 0 : _k.shape) {
        ringShape = product.metafields.magento.shape;
      }
      if (ringShape && typeof ringShape === "string") {
        const existingData = localStorage.getItem("ringBuilderAutoShape");
        if (!existingData) {
          const autoFilterInfo = {
            ringShape,
            ringShapeLabel: ringShape.toLowerCase().trim(),
            timestamp: Date.now()
          };
          localStorage.setItem(
            "ringBuilderAutoShape",
            JSON.stringify(autoFilterInfo)
          );
        }
      }
    }
    document.dispatchEvent(
      new CustomEvent("ring-builder:updated", { detail: { type: "setting" } })
    );
    if (hasExistingDiamond) {
      window.dispatchEvent(new CustomEvent("open-ring-popup"));
      this.isAddingSetting = false;
    } else {
      window.location.href = this.getSecondStepCollectionUrl();
    }
  },
  clearRing() {
    this.data = {
      isDiamondFirst: false,
      diamondData: void 0,
      settingData: void 0
    };
    localStorage.removeItem("ringBuilderData");
    localStorage.removeItem("ringBuilderAutoShape");
    localStorage.removeItem("ringBuilderAutoDiamondShape");
    document.dispatchEvent(new CustomEvent("ring-builder:clear"));
  },
  loadRingData() {
    const savedData = localStorage.getItem("ringBuilderData");
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        this.data = { ...this.data, ...parsedData };
      } catch (e) {
        this.data = {
          isDiamondFirst: false,
          diamondData: void 0,
          settingData: void 0
        };
      }
    }
  },
  saveRingData() {
    localStorage.setItem("ringBuilderData", JSON.stringify(this.data));
  },
  async fetchProducts() {
    var _a, _b;
    this.loading = true;
    const promises = [];
    if ((_a = this.data.settingData) == null ? void 0 : _a.handle) {
      promises.push(this.fetchProduct(this.data.settingData.handle, "setting"));
    }
    if ((_b = this.data.diamondData) == null ? void 0 : _b.handle) {
      promises.push(this.fetchProduct(this.data.diamondData.handle, "diamond"));
    }
    await Promise.all(promises);
    this.loading = false;
    this.data = { ...this.data };
    document.dispatchEvent(new CustomEvent("ring-builder:fresh-data"));
  },
  async fetchProduct(handle, type) {
    var _a, _b, _c, _d;
    try {
      const metafieldsResponse = await fetch(
        `/products/${handle}?view=metafields&_=${Date.now()}`
      );
      if (metafieldsResponse.ok) {
        const responseText = await metafieldsResponse.text();
        try {
          const productWithMetafields = JSON.parse(responseText);
          if (productWithMetafields && productWithMetafields.product) {
            const product2 = productWithMetafields.product;
            const dataKey2 = type === "diamond" ? "diamondData" : "settingData";
            const variantId2 = (_a = this.data[dataKey2]) == null ? void 0 : _a.variantId;
            let selectedVariant2 = null;
            if (variantId2) {
              selectedVariant2 = product2.variants.find(
                (v) => v.id === variantId2
              );
            }
            if (!selectedVariant2) {
              selectedVariant2 = product2.variants[0];
            }
            const newData2 = {
              handle: product2.handle,
              variantId: selectedVariant2.id,
              product: {
                ...product2,
                selected_or_first_available_variant: {
                  ...selectedVariant2,
                  product: {
                    has_only_default_variant: product2.variants.length === 1
                  }
                }
              },
              // Preserve specs if it's diamond data
              ...type === "diamond" && ((_b = this.data[dataKey2]) == null ? void 0 : _b.specs) ? { specs: this.data[dataKey2].specs } : {}
            };
            this.data[dataKey2] = newData2;
            this.saveRingData();
            this.data = { ...this.data };
            return;
          }
        } catch (parseError) {
        }
      }
      const response = await fetch(`/products/${handle}.js?_=${Date.now()}`);
      if (!response.ok) throw new Error("Product not found");
      const product = await response.json();
      const dataKey = type === "diamond" ? "diamondData" : "settingData";
      const variantId = (_c = this.data[dataKey]) == null ? void 0 : _c.variantId;
      let selectedVariant = null;
      if (variantId) {
        selectedVariant = product.variants.find((v) => v.id === variantId);
      }
      if (!selectedVariant) {
        selectedVariant = product.variants[0];
      }
      const newData = {
        handle: product.handle,
        variantId: selectedVariant.id,
        product: {
          ...product,
          images: product.images,
          selected_or_first_available_variant: {
            ...selectedVariant,
            product: {
              has_only_default_variant: product.variants.length === 1
            }
          }
        },
        // Preserve specs if it's diamond data
        ...type === "diamond" && ((_d = this.data[dataKey]) == null ? void 0 : _d.specs) ? { specs: this.data[dataKey].specs } : {}
      };
      this.data[dataKey] = newData;
      this.saveRingData();
      this.data = { ...this.data };
    } catch (error) {
    }
  },
  async addToCart() {
    var _a, _b;
    this.loading = true;
    try {
      const items = [];
      if ((_a = this.data.settingData) == null ? void 0 : _a.variantId) {
        items.push({
          id: this.data.settingData.variantId,
          quantity: 1
        });
      }
      if ((_b = this.data.diamondData) == null ? void 0 : _b.variantId) {
        items.push({
          id: this.data.diamondData.variantId,
          quantity: 1
        });
      }
      if (items.length === 0) {
        return false;
      }
      const success = await Alpine.store("cart").addMultipleToCart(items, true);
      if (success) {
        this.clearRing();
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error adding items to cart:", error);
      return false;
    } finally {
      this.loading = false;
    }
  },
  addSingleItem(item) {
    return new Promise((resolve) => {
      const cartItem = {
        id: item.id,
        quantity: item.quantity,
        properties: item.properties || {}
      };
      Alpine.store("cart").addToCart(cartItem);
      const onCartUpdated = () => {
        document.removeEventListener("cart:updated", onCartUpdated);
        resolve();
      };
      document.addEventListener("cart:updated", onCartUpdated);
      setTimeout(() => {
        document.removeEventListener("cart:updated", onCartUpdated);
        resolve();
      }, 3e3);
    });
  },
  get isComplete() {
    var _a, _b;
    return !!(((_a = this.data.diamondData) == null ? void 0 : _a.product) && ((_b = this.data.settingData) == null ? void 0 : _b.product));
  },
  get hasItems() {
    return !!(this.data.diamondData || this.data.settingData);
  },
  get totalPrice() {
    var _a, _b, _c, _d, _e, _f;
    let total = 0;
    if ((_c = (_b = (_a = this.data.diamondData) == null ? void 0 : _a.product) == null ? void 0 : _b.selected_or_first_available_variant) == null ? void 0 : _c.price) {
      total += this.data.diamondData.product.selected_or_first_available_variant.price;
    }
    if ((_f = (_e = (_d = this.data.settingData) == null ? void 0 : _d.product) == null ? void 0 : _e.selected_or_first_available_variant) == null ? void 0 : _f.price) {
      total += this.data.settingData.product.selected_or_first_available_variant.price;
    }
    return total;
  },
  get cartItems() {
    var _a, _b;
    const items = [];
    if ((_a = this.data.settingData) == null ? void 0 : _a.variantId) {
      items.push({
        id: this.data.settingData.variantId,
        quantity: 1,
        properties: {}
      });
    }
    if ((_b = this.data.diamondData) == null ? void 0 : _b.variantId) {
      items.push({
        id: this.data.diamondData.variantId,
        quantity: 1,
        properties: {}
      });
    }
    return items;
  },
  getCurrentStep() {
    var _a, _b;
    const hasSetting = !!((_a = this.data.settingData) == null ? void 0 : _a.product);
    const hasDiamond = !!((_b = this.data.diamondData) == null ? void 0 : _b.product);
    if (hasSetting && hasDiamond) {
      return 3;
    } else if (hasSetting || hasDiamond) {
      return 2;
    } else {
      return 0;
    }
  },
  getFirstStepProduct() {
    var _a, _b;
    if (this.data.isDiamondFirst) {
      return ((_a = this.data.diamondData) == null ? void 0 : _a.product) || null;
    } else {
      return ((_b = this.data.settingData) == null ? void 0 : _b.product) || null;
    }
  },
  getSecondStepProduct() {
    var _a, _b;
    if (this.data.isDiamondFirst) {
      return ((_a = this.data.settingData) == null ? void 0 : _a.product) || null;
    } else {
      return ((_b = this.data.diamondData) == null ? void 0 : _b.product) || null;
    }
  },
  get isFirstStepComplete() {
    var _a, _b;
    if (this.data.isDiamondFirst) {
      return !!((_a = this.data.diamondData) == null ? void 0 : _a.product);
    } else {
      return !!((_b = this.data.settingData) == null ? void 0 : _b.product);
    }
  },
  get isSecondStepComplete() {
    var _a, _b;
    if (this.data.isDiamondFirst) {
      return !!((_a = this.data.settingData) == null ? void 0 : _a.product);
    } else {
      return !!((_b = this.data.diamondData) == null ? void 0 : _b.product);
    }
  },
  getFirstStepCollectionUrl() {
    return this.data.isDiamondFirst ? "/collections/diamond-finder" : "/collections/engagement-rings";
  },
  getSecondStepCollectionUrl() {
    return this.data.isDiamondFirst ? "/collections/engagement-rings" : "/collections/diamond-finder";
  },
  getStepTexts(settingText, diamondText) {
    return {
      firstStep: this.data.isDiamondFirst ? diamondText : settingText,
      secondStep: this.data.isDiamondFirst ? settingText : diamondText
    };
  }
};
const _MetaobjectService = class _MetaobjectService {
  constructor() {
    __publicField(this, "cache", /* @__PURE__ */ new Map());
    __publicField(this, "CACHE_TTL", 5 * 60 * 1e3);
    // 5 minutes
    __publicField(this, "LOCALSTORAGE_TTL", 60 * 60 * 1e3);
    // 1 hour
    __publicField(this, "MAX_CACHE_SIZE", 100);
    __publicField(this, "MAX_LOCALSTORAGE_SIZE", 1e3);
    __publicField(this, "LOCALSTORAGE_KEY", "jrdunn_metaobjects");
    __publicField(this, "STORAGE_VERSION", "1.0");
    __publicField(this, "accessToken", null);
    // Global batching coordinator
    __publicField(this, "pendingIds", /* @__PURE__ */ new Set());
    __publicField(this, "batchTimeout", null);
    __publicField(this, "pendingPromises", []);
    if (typeof window !== "undefined" && window.custom_storefront_api_token) {
      this.accessToken = window.custom_storefront_api_token;
    }
    this.cleanupLocalStorage();
  }
  static getInstance() {
    if (!_MetaobjectService.instance) {
      _MetaobjectService.instance = new _MetaobjectService();
    }
    return _MetaobjectService.instance;
  }
  /**
   * Extract metaobject IDs from various formats
   */
  static extractMetaobjectId(value) {
    const gidMatch = value.match(/gid:\/\/shopify\/Metaobject\/(\d+)/);
    if (gidMatch) return gidMatch[1];
    if (/^\d+$/.test(value)) return value;
    return null;
  }
  /**
   * Check if a value appears to be a metaobject reference
   */
  static isMetaobjectReference(value) {
    return this.extractMetaobjectId(value) !== null;
  }
  /**
  * Build GraphQL query for fetching metaobjects
  */
  buildMetaobjectQuery(ids) {
    const nodeQueries = ids.map((id) => `"gid://shopify/Metaobject/${id}"`).join(", ");
    return `
      query GetMetaobjects {
        nodes(ids: [${nodeQueries}]) {
          ... on Metaobject {
            id
            handle
            type
            fields {
              key
              value
              type
              reference {
                ... on MediaImage {
                  image {
                    url
                    altText
                  }
                }
              }
            }
          }
        }
      }
    `;
  }
  /**
   * Fetch metaobjects from cache, localStorage, or API (hybrid approach)
   */
  async getMetaobjects(ids) {
    return new Promise((resolve, reject) => {
      ids.forEach((id) => this.pendingIds.add(id));
      this.pendingPromises.push({
        resolve,
        reject,
        requestedIds: [...ids]
      });
      this.scheduleBatch();
    });
  }
  /**
   * Fetch metaobjects from Shopify Storefront API
   */
  async fetchMetaobjectsFromAPI(ids) {
    var _a;
    if (!this.accessToken) {
      throw new Error("No storefront access token available");
    }
    const query = this.buildMetaobjectQuery(ids);
    const response = await fetch("/api/2025-04/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": this.accessToken
      },
      body: JSON.stringify({ query })
    });
    if (!response.ok) {
      throw new Error(`GraphQL request failed: ${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    if (data.errors) {
      console.error("GraphQL Errors:", data.errors);
      throw new Error("GraphQL query returned errors");
    }
    const result = /* @__PURE__ */ new Map();
    if ((_a = data.data) == null ? void 0 : _a.nodes) {
      data.data.nodes.forEach((node) => {
        if (node && node.id) {
          const numericId = _MetaobjectService.extractMetaobjectId(node.id);
          if (numericId) {
            result.set(numericId, node);
          }
        }
      });
    }
    return result;
  }
  /**
   * Get metaobject from cache if still valid
   */
  getCachedMetaobject(id) {
    const entry = this.cache.get(id);
    if (!entry) return null;
    const now = Date.now();
    if (now - entry.timestamp > this.CACHE_TTL) {
      this.cache.delete(id);
      return null;
    }
    return entry.data;
  }
  /**
   * Cache metaobject with TTL and size management
   */
  cacheMetaobject(id, metaobject) {
    if (this.cache.size >= this.MAX_CACHE_SIZE) {
      const oldestKey = this.cache.keys().next().value;
      if (oldestKey) {
        this.cache.delete(oldestKey);
      }
    }
    this.cache.set(id, {
      data: metaobject,
      timestamp: Date.now()
    });
  }
  /**
   * Clear memory cache manually
   */
  clearCache() {
    this.cache.clear();
  }
  /**
   * Clear localStorage manually
   */
  clearLocalStorage() {
    try {
      localStorage.removeItem(this.LOCALSTORAGE_KEY);
    } catch (error) {
      console.warn("Failed to clear localStorage:", error);
    }
  }
  /**
   * Clear all caches (memory + localStorage)
   */
  clearAllCaches() {
    this.clearCache();
    this.clearLocalStorage();
  }
  /**
   * Load metaobjects from localStorage
   */
  loadFromLocalStorage(ids) {
    const result = /* @__PURE__ */ new Map();
    try {
      const storedData = localStorage.getItem(this.LOCALSTORAGE_KEY);
      if (!storedData) return result;
      const data = JSON.parse(storedData);
      const now = Date.now();
      ids.forEach((id) => {
        const entry = data.metaobjects[id];
        if (entry && now - entry.timestamp <= this.LOCALSTORAGE_TTL) {
          result.set(id, entry.data);
        }
      });
    } catch (error) {
      console.warn("Failed to load metaobjects from localStorage:", error);
    }
    return result;
  }
  /**
   * Save metaobjects to localStorage
   */
  saveToLocalStorage(metaobjects) {
    try {
      let data;
      const storedData = localStorage.getItem(this.LOCALSTORAGE_KEY);
      if (storedData) {
        data = JSON.parse(storedData);
      } else {
        data = {
          metaobjects: {},
          metadata: {
            version: this.STORAGE_VERSION,
            lastCleanup: Date.now()
          }
        };
      }
      const now = Date.now();
      metaobjects.forEach((metaobject, id) => {
        data.metaobjects[id] = {
          data: metaobject,
          timestamp: now
        };
      });
      const totalEntries = Object.keys(data.metaobjects).length;
      if (totalEntries > this.MAX_LOCALSTORAGE_SIZE) {
        const sortedEntries = Object.entries(data.metaobjects).sort(([, a], [, b]) => a.timestamp - b.timestamp);
        const entriesToKeep = sortedEntries.slice(-this.MAX_LOCALSTORAGE_SIZE);
        data.metaobjects = Object.fromEntries(entriesToKeep);
      }
      localStorage.setItem(this.LOCALSTORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      console.warn("Failed to save metaobjects to localStorage:", error);
    }
  }
  /**
  * Get display name for metaobject, with fallback
  * Tries to find a display name from common fields like 'name', 'title', or falls back to handle
  */
  getDisplayName(metaobject) {
    const displayNameFields = ["name", "title", "display_name", "label"];
    for (const fieldName of displayNameFields) {
      const field = metaobject.fields.find((f) => f.key === fieldName);
      if (field && field.value) {
        return field.value;
      }
    }
    return metaobject.handle || `Metaobject ${metaobject.id}`;
  }
  /**
  * Get specific field value from metaobject
  */
  getFieldValue(metaobject, fieldKey) {
    const field = metaobject.fields.find((f) => f.key === fieldKey);
    return (field == null ? void 0 : field.value) || null;
  }
  /**
   * Get swatch image URL from metaobject
   * Looks for common swatch field names and returns the image URL
   */
  getSwatchImageUrl(metaobject) {
    var _a, _b;
    const swatchFieldNames = ["swatch_image", "swatch", "image", "color_swatch", "thumbnail"];
    for (const fieldName of swatchFieldNames) {
      const field = metaobject.fields.find((f) => f.key === fieldName);
      if (field && ((_b = (_a = field.reference) == null ? void 0 : _a.image) == null ? void 0 : _b.url)) {
        return field.reference.image.url;
      }
    }
    return null;
  }
  /**
   * Get swatch alt text from metaobject
   */
  getSwatchAltText(metaobject) {
    var _a, _b;
    const swatchFieldNames = ["swatch_image", "swatch", "image", "color_swatch", "thumbnail"];
    for (const fieldName of swatchFieldNames) {
      const field = metaobject.fields.find((f) => f.key === fieldName);
      if (field && ((_b = (_a = field.reference) == null ? void 0 : _a.image) == null ? void 0 : _b.altText)) {
        return field.reference.image.altText;
      }
    }
    return null;
  }
  /**
   * Create Shopify-compatible metaobject value structure
   * Matches the format that Shopify provides natively in Liquid templates
   */
  createShopifyCompatibleMetaobjectValue(metaobject) {
    const value = {
      id: metaobject.id,
      handle: metaobject.handle,
      label: this.getDisplayName(metaobject)
    };
    metaobject.fields.forEach((field) => {
      var _a;
      if (field.type === "file_reference" && ((_a = field.reference) == null ? void 0 : _a.image)) {
        const imageUrl = field.reference.image.url;
        value[field.key] = {
          url: imageUrl,
          alt: field.reference.image.altText || "",
          width: 800,
          // Default dimensions
          height: 800,
          // Add Shopify image object methods for filter compatibility
          toString: () => imageUrl,
          valueOf: () => imageUrl
        };
        value[field.key] = new Proxy(value[field.key], {
          get(target, prop) {
            if (prop === Symbol.toPrimitive || prop === "toString" || prop === "valueOf") {
              return () => imageUrl;
            }
            return target[prop];
          }
        });
      } else {
        value[field.key] = field.value;
      }
    });
    return value;
  }
  // Add localStorage-specific methods
  cleanupLocalStorage() {
    const localStorageData = localStorage.getItem(this.LOCALSTORAGE_KEY);
    if (localStorageData) {
      const data = JSON.parse(localStorageData);
      const now = Date.now();
      const expiredEntries = Object.entries(data.metaobjects).filter(([, entry]) => now - entry.timestamp > this.LOCALSTORAGE_TTL);
      expiredEntries.forEach(([id]) => delete data.metaobjects[id]);
      data.metadata.lastCleanup = now;
      localStorage.setItem(this.LOCALSTORAGE_KEY, JSON.stringify(data));
    }
  }
  /**
   * Global batching coordinator - collects all requests and executes in single batch
   */
  async processBatch() {
    if (this.pendingIds.size === 0 || this.pendingPromises.length === 0) {
      return;
    }
    const idsToFetch = Array.from(this.pendingIds);
    const promises = [...this.pendingPromises];
    this.pendingIds.clear();
    this.pendingPromises = [];
    this.batchTimeout = null;
    try {
      const result = await this.getMetaobjectsDirectly(idsToFetch);
      promises.forEach(({ resolve, requestedIds }) => {
        const subset = /* @__PURE__ */ new Map();
        requestedIds.forEach((id) => {
          const metaobject = result.get(id);
          if (metaobject) {
            subset.set(id, metaobject);
          }
        });
        resolve(subset);
      });
    } catch (error) {
      promises.forEach(({ reject }) => {
        reject(error);
      });
    }
  }
  /**
   * Schedule batch processing with debouncing
   */
  scheduleBatch() {
    if (this.batchTimeout !== null) {
      clearTimeout(this.batchTimeout);
    }
    this.batchTimeout = window.setTimeout(() => {
      this.processBatch();
    }, 10);
  }
  /**
   * Direct metaobject fetching (used internally by batch processor)
   */
  async getMetaobjectsDirectly(ids) {
    const result = /* @__PURE__ */ new Map();
    const memoryMissing = [];
    for (const id of ids) {
      const cached = this.getCachedMetaobject(id);
      if (cached) {
        result.set(id, cached);
      } else {
        memoryMissing.push(id);
      }
    }
    const localStorageMissing = [];
    if (memoryMissing.length > 0) {
      const localStorageCached = this.loadFromLocalStorage(memoryMissing);
      localStorageCached.forEach((metaobject, id) => {
        result.set(id, metaobject);
        this.cacheMetaobject(id, metaobject);
      });
      memoryMissing.forEach((id) => {
        if (!localStorageCached.has(id)) {
          localStorageMissing.push(id);
        }
      });
    }
    if (localStorageMissing.length > 0) {
      try {
        const fetchedMetaobjects = await this.fetchMetaobjectsFromAPI(localStorageMissing);
        fetchedMetaobjects.forEach((metaobject, id) => {
          result.set(id, metaobject);
          this.cacheMetaobject(id, metaobject);
        });
        if (fetchedMetaobjects.size > 0) {
          this.saveToLocalStorage(fetchedMetaobjects);
        }
      } catch (error) {
        console.warn("Failed to fetch metaobjects:", error);
      }
    }
    return result;
  }
};
__publicField(_MetaobjectService, "instance");
let MetaobjectService = _MetaobjectService;
class FastSimonUtils {
  static extractPriceValue(priceString) {
    const match = priceString.match(/[\d.]+/);
    return match ? parseFloat(match[0]) : null;
  }
  /**
   * Unified conversion method that fetches all metaobjects once for both products and facets
   *
   * This method ensures ONLY ONE API call per FastSimon response by:
   * 1. Collecting all metaobject IDs from both products and facets
   * 2. Fetching all metaobjects in a single batch
   * 3. Using the shared data for both product and facet conversions
   *
   * @example
   * // Instead of calling separately:
   * // const products = await FastSimonUtils.fastSimonToShopifyProducts(fsProducts);
   * // const filters = await FastSimonUtils.fastSimonToShopify(fsFacets);
   *
   * // Use the unified method:
   * const { products, filters } = await FastSimonUtils.convertFastSimonResponse(fsProducts, fsFacets);
   *
   * @param fastSimonProducts - Products from FastSimon API
   * @param fastSimonFacets - Facets from FastSimon API
   * @param resolveMetaobjects - Whether to resolve metaobject references
   * @returns Promise with both products and filters
   */
  static async convertFastSimonResponse(fastSimonProducts, fastSimonFacets, resolveMetaobjects = true) {
    if (!resolveMetaobjects) {
      return {
        products: fastSimonProducts.map(
          (product) => this.convertFastSimonProduct(product)
        ),
        filters: await this.fastSimonToShopify(fastSimonFacets)
      };
    }
    const productMetaobjectIds = this.collectMetaobjectIdsFromProducts(fastSimonProducts);
    const facetMetaobjectIds = this.collectMetaobjectIdsFromFacets(fastSimonFacets);
    const allMetaobjectIds = /* @__PURE__ */ new Set([
      ...productMetaobjectIds,
      ...facetMetaobjectIds
    ]);
    let metaobjects = /* @__PURE__ */ new Map();
    if (allMetaobjectIds.size > 0) {
      try {
        metaobjects = await MetaobjectService.getInstance().getMetaobjects(
          Array.from(allMetaobjectIds)
        );
      } catch (error) {
        console.warn("Failed to batch fetch metaobjects:", error);
      }
    }
    const products = fastSimonProducts.map(
      (product) => this.convertFastSimonProduct(product, metaobjects)
    );
    const filters = this.convertFastSimonFacetsWithMetaobjects(
      fastSimonFacets,
      metaobjects
    );
    return { products, filters };
  }
  /**
   * Collect metaobject IDs from products
   */
  static collectMetaobjectIdsFromProducts(fastSimonProducts) {
    const metaobjectIds = [];
    fastSimonProducts.forEach((fsProduct) => {
      if (fsProduct.att && fsProduct.att.length > 0) {
        fsProduct.att.forEach(([, attributeValues]) => {
          attributeValues.forEach((value) => {
            const flattenedValues = Array.isArray(value) ? value : [value];
            flattenedValues.forEach((flatValue) => {
              const valueStr = String(flatValue);
              if (MetaobjectService.isMetaobjectReference(valueStr)) {
                const id = MetaobjectService.extractMetaobjectId(valueStr);
                if (id && !metaobjectIds.includes(id)) {
                  metaobjectIds.push(id);
                }
              }
            });
          });
        });
      }
    });
    return metaobjectIds;
  }
  /**
   * Collect metaobject IDs from facets
   */
  static collectMetaobjectIdsFromFacets(facets) {
    const metaobjectIds = [];
    facets.forEach((facet) => {
      const [, facetValues] = facet;
      if (Array.isArray(facetValues)) {
        facetValues.forEach((value) => {
          if (Array.isArray(value) && value.length > 0) {
            const valueStr = String(value[0]);
            if (MetaobjectService.isMetaobjectReference(valueStr)) {
              const id = MetaobjectService.extractMetaobjectId(valueStr);
              if (id && !metaobjectIds.includes(id)) {
                metaobjectIds.push(id);
              }
            }
          }
        });
      }
    });
    return metaobjectIds;
  }
  static async fastSimonToShopifyProducts(fastSimonProducts, resolveMetaobjects = true) {
    if (!resolveMetaobjects || fastSimonProducts.length === 0) {
      return fastSimonProducts.map(
        (product) => this.convertFastSimonProduct(product)
      );
    }
    const allMetaobjectIds = /* @__PURE__ */ new Set();
    fastSimonProducts.forEach((fsProduct) => {
      if (fsProduct.att && fsProduct.att.length > 0) {
        fsProduct.att.forEach(([, attributeValues]) => {
          attributeValues.forEach((value) => {
            const flattenedValues = Array.isArray(value) ? value : [value];
            flattenedValues.forEach((flatValue) => {
              const valueStr = String(flatValue);
              if (MetaobjectService.isMetaobjectReference(valueStr)) {
                const id = MetaobjectService.extractMetaobjectId(valueStr);
                if (id) allMetaobjectIds.add(id);
              }
            });
          });
        });
      }
    });
    let metaobjects = /* @__PURE__ */ new Map();
    if (allMetaobjectIds.size > 0) {
      try {
        metaobjects = await MetaobjectService.getInstance().getMetaobjects(
          Array.from(allMetaobjectIds)
        );
      } catch (error) {
        console.warn("Failed to batch fetch metaobjects:", error);
      }
    }
    return fastSimonProducts.map(
      (product) => this.convertFastSimonProduct(product, metaobjects)
    );
  }
  static convertFastSimonProduct(fsProduct, metaobjects) {
    const price = parseFloat(fsProduct.p) || 0;
    const priceMin = parseFloat(fsProduct.p_min) || price;
    const priceMax = parseFloat(fsProduct.p_max) || price;
    const compareAtPrice = fsProduct.p_c ? parseFloat(fsProduct.p_c) : null;
    const compareAtPriceMin = fsProduct.p_min_c ? parseFloat(fsProduct.p_min_c) : null;
    const compareAtPriceMax = fsProduct.p_max_c ? parseFloat(fsProduct.p_max_c) : null;
    const urlParts = fsProduct.u.split("/products/");
    const handle = urlParts.length > 1 ? urlParts[1].split("?")[0].split("#")[0] : fsProduct.id;
    const createShopifyImage = (src, position, productId, alt) => {
      const imageObj = {
        id: parseInt(productId) + position - 1,
        position,
        src,
        alt,
        width: 800,
        height: 800,
        toString: () => src,
        valueOf: () => src
      };
      return new Proxy(imageObj, {
        get(target, prop) {
          if (prop === Symbol.toPrimitive || prop === "toString" || prop === "valueOf") {
            return () => src;
          }
          return target[prop];
        }
      });
    };
    const images = [];
    let featuredImage = {
      id: "",
      position: 0,
      src: "/cdn/shop/files/jrdunn-logo-dark_bb476ce1-fa3b-4547-b013-488d15c23f25.png",
      alt: fsProduct.l
    };
    if (fsProduct.att && fsProduct.att.length > 0) {
      const productImagesEntry = fsProduct.att.find(
        ([attributeName]) => attributeName === "Product images"
      );
      if (productImagesEntry && productImagesEntry[1] && Array.isArray(productImagesEntry[1])) {
        const imageUrls = productImagesEntry[1].flat();
        imageUrls.forEach((imageUrl, index) => {
          if (typeof imageUrl === "string" && imageUrl.trim()) {
            const shopifyImage = createShopifyImage(
              imageUrl,
              index + 1,
              fsProduct.id,
              fsProduct.l
            );
            images.push(shopifyImage);
            if (index === 0) {
              featuredImage = shopifyImage;
            }
          }
        });
      }
    }
    if (images.length === 0) {
      if (fsProduct.t && fsProduct.t.trim()) {
        const primaryImage = createShopifyImage(
          fsProduct.t,
          1,
          fsProduct.id,
          fsProduct.l
        );
        images.push(primaryImage);
        featuredImage = primaryImage;
      }
      if (fsProduct.t2 && fsProduct.t2.trim() && fsProduct.t2 !== fsProduct.t) {
        images.push(
          createShopifyImage(fsProduct.t2, 2, fsProduct.id, fsProduct.l)
        );
      }
    }
    const options = [];
    const attributeMap = /* @__PURE__ */ new Map();
    if (fsProduct.vra && fsProduct.vra.length > 0) {
      fsProduct.vra.forEach(([_, attributes]) => {
        attributes.forEach(([attrName, attrValues]) => {
          if (Array.isArray(attrValues) && attrValues.length > 0) {
            const attrNameStr = String(attrName);
            if (!attributeMap.has(attrNameStr)) {
              attributeMap.set(attrNameStr, /* @__PURE__ */ new Set());
            }
            attrValues.forEach((value) => {
              attributeMap.get(attrNameStr).add(String(value));
            });
          }
        });
      });
      let position = 1;
      attributeMap.forEach((values, attrName) => {
        options.push({
          id: parseInt(fsProduct.id) + position - 1,
          product_id: parseInt(fsProduct.id),
          name: attrName,
          position,
          values: Array.from(values)
        });
        position++;
      });
    }
    const variants = [];
    if (fsProduct.vra && fsProduct.vra.length > 0) {
      fsProduct.vra.forEach(([_, attributes], index) => {
        const variantOptions = [];
        attributes.forEach(([_2, attrValues]) => {
          if (Array.isArray(attrValues) && attrValues.length > 0) {
            variantOptions.push(String(attrValues[0]));
          }
        });
        const variant = {
          id: parseInt(fsProduct.id) + index,
          product_id: parseInt(fsProduct.id),
          title: variantOptions.length > 0 ? variantOptions.join(" / ") : "Default Title",
          price: price * 100,
          compare_at_price: compareAtPrice ? compareAtPrice * 100 : null,
          sku: fsProduct.skus && fsProduct.skus[index] ? fsProduct.skus[index] : fsProduct.sku || "",
          position: index + 1,
          inventory_quantity: 10,
          option1: variantOptions[0] || null,
          option2: variantOptions[1] || null,
          option3: variantOptions[2] || null,
          options: variantOptions,
          image: featuredImage,
          available: fsProduct.f !== 0,
          featured_image: featuredImage ? {
            src: featuredImage.src,
            alt: featuredImage.alt
          } : void 0
        };
        variants.push(variant);
      });
    } else {
      const defaultVariant = {
        id: parseInt(fsProduct.id),
        product_id: parseInt(fsProduct.id),
        title: "Default Title",
        price: price * 100,
        compare_at_price: compareAtPrice ? compareAtPrice * 100 : null,
        sku: fsProduct.sku || "",
        position: 1,
        inventory_quantity: 10,
        option1: null,
        option2: null,
        option3: null,
        options: [],
        image: featuredImage,
        available: fsProduct.f !== 0,
        featured_image: featuredImage ? {
          src: featuredImage.src,
          alt: featuredImage.alt
        } : void 0
      };
      variants.push(defaultVariant);
    }
    const metafields = {
      fastsimon: {
        original_data: {
          type: "json",
          value: fsProduct
        }
      }
    };
    const createMetafield = (value) => {
      if (Array.isArray(value)) {
        if (value.length === 1) {
          const singleValue = value[0];
          if (typeof singleValue === "string") {
            return { type: "single_line_text_field", value: singleValue };
          } else if (typeof singleValue === "number") {
            return { type: "number_integer", value: singleValue };
          } else if (typeof singleValue === "boolean") {
            return { type: "boolean", value: singleValue };
          }
        } else {
          return { type: "list.single_line_text_field", value };
        }
      } else {
        if (typeof value === "string") {
          return { type: "single_line_text_field", value };
        } else if (typeof value === "number") {
          return { type: "number_integer", value };
        } else if (typeof value === "boolean") {
          return { type: "boolean", value };
        }
      }
      return { type: "json", value };
    };
    if (fsProduct.att && fsProduct.att.length > 0) {
      fsProduct.att.forEach(([attributeName, attributeValues]) => {
        if (attributeName.startsWith("Custom.") || attributeName.startsWith("magento.") || attributeName.startsWith("Magento.") || attributeName.startsWith("Diamond details.") || attributeName.startsWith("diamond_details.")) {
          let namespace;
          let key;
          if (attributeName.startsWith("Custom.")) {
            namespace = "custom";
            key = attributeName.replace("Custom.", "");
          } else if (attributeName.startsWith("diamond_details.")) {
            namespace = "diamond_details";
            key = attributeName.replace("diamond_details.", "");
          } else if (attributeName.startsWith("Diamond details.")) {
            namespace = "Diamond details.";
            key = attributeName.replace("Diamond details.", "");
          } else {
            namespace = "magento";
            key = attributeName.replace("magento.", "");
          }
          if (!metafields[namespace]) {
            metafields[namespace] = {};
          }
          const processedValues = attributeValues.map((value) => {
            const flattenedValues = Array.isArray(value) ? value : [value];
            return flattenedValues.map((flatValue) => {
              const valueStr = String(flatValue);
              if (MetaobjectService.isMetaobjectReference(valueStr)) {
                const metaobjectId = MetaobjectService.extractMetaobjectId(valueStr);
                const metaobject = metaobjectId && metaobjects ? metaobjects.get(metaobjectId) : null;
                if (metaobject) {
                  return MetaobjectService.getInstance().createShopifyCompatibleMetaobjectValue(
                    metaobject
                  );
                } else {
                  return valueStr;
                }
              }
              return flatValue;
            });
          });
          const flatProcessedValues = processedValues.flat();
          const finalValue = flatProcessedValues.length === 1 ? flatProcessedValues[0] : flatProcessedValues;
          metafields[namespace][key] = {
            type: MetaobjectService.isMetaobjectReference(
              String(attributeValues[0])
            ) ? "metaobject_reference" : createMetafield(finalValue).type,
            value: finalValue
          };
        } else {
          if (!metafields.attributes) {
            metafields.attributes = {};
          }
          const processedValues = attributeValues.map((value) => {
            const flattenedValues = Array.isArray(value) ? value : [value];
            return flattenedValues.map((flatValue) => {
              const valueStr = String(flatValue);
              if (MetaobjectService.isMetaobjectReference(valueStr)) {
                const metaobjectId = MetaobjectService.extractMetaobjectId(valueStr);
                const metaobject = metaobjectId && metaobjects ? metaobjects.get(metaobjectId) : null;
                if (metaobject) {
                  return MetaobjectService.getInstance().createShopifyCompatibleMetaobjectValue(
                    metaobject
                  );
                } else {
                  return valueStr;
                }
              }
              return flatValue;
            });
          });
          const flatProcessedValues = processedValues.flat();
          const finalValue = flatProcessedValues.length === 1 ? flatProcessedValues[0] : flatProcessedValues;
          metafields.attributes[attributeName] = {
            type: MetaobjectService.isMetaobjectReference(
              String(attributeValues[0])
            ) ? "metaobject_reference" : createMetafield(finalValue).type,
            value: finalValue
          };
        }
      });
    }
    let vendor = "J.R.DUNN";
    if (fsProduct.att && fsProduct.att.length > 0) {
      const brandAttribute = fsProduct.att.find(
        ([name, _values]) => name === "magento.brand" || name === "Custom.brand"
      );
      if (brandAttribute && brandAttribute[1] && brandAttribute[1].length > 0) {
        const brandValue = brandAttribute[1][0];
        if (Array.isArray(brandValue) && brandValue.length > 0) {
          vendor = String(brandValue[0]);
        } else {
          vendor = String(brandValue);
        }
      }
    }
    const shopifyProduct = {
      id: parseInt(fsProduct.id),
      title: fsProduct.l,
      handle,
      description: fsProduct.d || "",
      vendor,
      product_type: "",
      created_at: new Date(fsProduct.c_date * 1e3).toISOString(),
      updated_at: (/* @__PURE__ */ new Date()).toISOString(),
      published_at: new Date(fsProduct.c_date * 1e3).toISOString(),
      url: fsProduct.u,
      tags: fsProduct.b || [],
      options,
      variants,
      images,
      featured_image: featuredImage,
      price: price * 100,
      price_min: priceMin * 100,
      price_max: priceMax * 100,
      compare_at_price: compareAtPrice ? compareAtPrice * 100 : null,
      compare_at_price_min: compareAtPriceMin ? compareAtPriceMin * 100 : null,
      compare_at_price_max: compareAtPriceMax ? compareAtPriceMax * 100 : null,
      available: fsProduct.f !== 0,
      selected_or_first_available_variant: variants[0],
      media: images,
      metafields
    };
    if (images.length > 0) {
      images.size = images.length;
    }
    return shopifyProduct;
  }
  static async fastSimonToShopify(facets) {
    const shopifyFilters = [];
    const metaobjectService = MetaobjectService.getInstance();
    const metaobjectIds = [];
    facets.forEach((facet) => {
      const [, facetValues] = facet;
      if (Array.isArray(facetValues)) {
        facetValues.forEach((value) => {
          if (Array.isArray(value) && value.length > 0) {
            const valueStr = String(value[0]);
            if (MetaobjectService.isMetaobjectReference(valueStr)) {
              const id = MetaobjectService.extractMetaobjectId(valueStr);
              if (id && !metaobjectIds.includes(id)) {
                metaobjectIds.push(id);
              }
            }
          }
        });
      }
    });
    const metaobjects = metaobjectIds.length > 0 ? await metaobjectService.getMetaobjects(metaobjectIds) : /* @__PURE__ */ new Map();
    facets.reverse().forEach((facet) => {
      const [facetName, facetValues, displayName, ,] = facet;
      switch (facetName) {
        case "Price_max":
          let maxPrice = 0;
          if (Array.isArray(facetValues) && facetValues.length > 0) {
            maxPrice = facetValues[0];
          }
          shopifyFilters.push({
            type: "price_range",
            label: "Price",
            param_name: "filter.v.price",
            active_values: [],
            values: [],
            min_value: {
              value: null,
              param_name: "filter.v.price.gte"
            },
            max_value: {
              value: null,
              param_name: "filter.v.price.lte"
            },
            range_max: maxPrice
          });
          break;
        case "Categories":
          if (Array.isArray(facetValues)) {
            shopifyFilters.push({
              type: "list",
              label: "Categories",
              param_name: "filter.v.categories",
              active_values: [],
              values: facetValues.map(
                ([categoryId, count, categoryName, ,]) => ({
                  label: categoryName,
                  value: categoryId,
                  param_name: "filter.v.categories",
                  count
                })
              ),
              min_value: { value: null, param_name: "" },
              max_value: { value: null, param_name: "" }
            });
          }
          break;
        case "Type":
        case "Price_min":
        case "Price":
        case "Isp-in-stock":
          break;
        default:
          if (facetName.startsWith("Custom.") || facetName.startsWith("magento.") || facetName.startsWith("Diamond details.") || facetName.startsWith("diamond_details.") || facetName.startsWith("Magento.")) {
            const metafieldKey = facetName.replace("Custom.", "").replace("magento.", "").replace("Diamond details.", "").replace("diamond_details.", "").replace("Magento.variant nav ", "").replace("Magento.variant", "").replace("Magento.nav", "").replace("Magento.", "");
            const paramName = `filter.p.m.${metafieldKey}`;
            if (Array.isArray(facetValues)) {
              const processedValues = facetValues.map(([value, count]) => {
                const valueStr = String(value);
                if (MetaobjectService.isMetaobjectReference(valueStr)) {
                  const metaobjectId = MetaobjectService.extractMetaobjectId(valueStr);
                  const metaobject = metaobjectId ? metaobjects.get(metaobjectId) : null;
                  if (metaobject) {
                    const filterValue = {
                      label: metaobjectService.getDisplayName(metaobject),
                      value: valueStr,
                      param_name: paramName,
                      count
                    };
                    const swatchUrl = metaobjectService.getSwatchImageUrl(metaobject);
                    if (swatchUrl) {
                      filterValue.swatch = swatchUrl;
                    }
                    return filterValue;
                  }
                }
                return {
                  label: valueStr,
                  value: valueStr,
                  param_name: paramName,
                  count
                };
              });
              const minValue = {
                value: null,
                param_name: ""
              };
              const maxValue = {
                value: null,
                param_name: ""
              };
              if (metafieldKey.toLowerCase() === "depth" || metafieldKey.toLowerCase() === "size") {
                const numericValues = processedValues.map((v) => parseFloat(v.value)).filter((v) => !isNaN(v));
                if (numericValues.length > 0) {
                  const min = Math.min(...numericValues);
                  const max = Math.max(...numericValues);
                  minValue.value = min === Infinity ? null : min.toString();
                  minValue.param_name = `${paramName}.gte`;
                  maxValue.value = max === -Infinity ? null : max.toString();
                  maxValue.param_name = `${paramName}.lte`;
                }
                shopifyFilters.push({
                  type: "price_range",
                  label: metafieldKey,
                  param_name: paramName,
                  active_values: [],
                  values: processedValues,
                  min_value: minValue,
                  max_value: maxValue,
                  range_max: Math.ceil(parseFloat(maxValue.value || "0"))
                });
              } else {
                shopifyFilters.push({
                  type: "list",
                  label: metafieldKey,
                  param_name: paramName,
                  active_values: [],
                  values: processedValues,
                  min_value: minValue,
                  max_value: maxValue
                });
              }
            }
          } else {
            const paramName = `filter.v.${facetName.toLowerCase()}`;
            if (Array.isArray(facetValues)) {
              const processedValues = facetValues.map(([value, count]) => {
                const valueStr = String(value);
                if (MetaobjectService.isMetaobjectReference(valueStr)) {
                  const metaobjectId = MetaobjectService.extractMetaobjectId(valueStr);
                  const metaobject = metaobjectId ? metaobjects.get(metaobjectId) : null;
                  if (metaobject) {
                    const filterValue = {
                      label: metaobjectService.getDisplayName(metaobject),
                      value: valueStr,
                      param_name: paramName,
                      count
                    };
                    const swatchUrl = metaobjectService.getSwatchImageUrl(metaobject);
                    if (swatchUrl) {
                      filterValue.swatch = swatchUrl;
                    }
                    return filterValue;
                  }
                }
                return {
                  label: valueStr,
                  value: valueStr,
                  param_name: paramName,
                  count
                };
              });
              shopifyFilters.push({
                type: "list",
                label: displayName,
                param_name: paramName,
                active_values: [],
                values: processedValues,
                min_value: { value: null, param_name: "" },
                max_value: { value: null, param_name: "" }
              });
            }
          }
          break;
      }
    });
    const priceFilterIndex = shopifyFilters.findIndex(
      (filter) => filter.type === "price_range"
    );
    if (priceFilterIndex !== -1 && shopifyFilters.length > 1) {
      const priceFilter = shopifyFilters.splice(priceFilterIndex, 1)[0];
      const insertIndex = Math.max(0, shopifyFilters.length - 2);
      shopifyFilters.splice(insertIndex, 0, priceFilter);
    }
    return shopifyFilters;
  }
  static filtersToNarrowBy(filterParams) {
    const narrowBy = [];
    let priceMin = null;
    let priceMax = null;
    let originValue = null;
    const paramGroups = {};
    filterParams.forEach((param) => {
      var _a;
      if (param.name.startsWith("filter.v.")) {
        const attributeName = param.name.replace("filter.v.", "");
        if (param.name === "filter.v.price.gte") {
          priceMin = param.value;
          return;
        } else if (param.name === "filter.v.price.lte") {
          priceMax = param.value;
          return;
        } else if (param.name === "filter.v.origin") {
          originValue = param.value;
          return;
        } else if (param.name.startsWith("filter.v.price")) {
          narrowBy.push(["Price", param.value]);
        } else {
          const capitalizedName = attributeName.charAt(0).toUpperCase() + attributeName.slice(1);
          narrowBy.push([capitalizedName, param.value]);
        }
      } else if (param.name.startsWith("filter.p.m.")) {
        const metafieldName = param.name.replace("filter.p.m.", "");
        const baseName = metafieldName.replace(/\.(gte|lte)$/, "");
        if (!paramGroups[baseName]) {
          paramGroups[baseName] = { values: [] };
        }
        if (param.name.endsWith(".gte")) {
          paramGroups[baseName].gte = param.value;
        } else if (param.name.endsWith(".lte")) {
          paramGroups[baseName].lte = param.value;
        } else {
          paramGroups[baseName].values.push(param.value);
        }
        const store = Alpine.store("fastSimon");
        if (store) {
          const filter = (_a = store.fastSimonFilters) == null ? void 0 : _a.find(
            (f) => f.param_name === `filter.p.m.${baseName}`
          );
          if (filter && filter.name_space) {
            paramGroups[baseName].nameSpace = filter.name_space;
          } else {
            const storedNamespace = store.getFilterNamespace(`filter.p.m.${baseName}`);
            if (storedNamespace) {
              paramGroups[baseName].nameSpace = storedNamespace;
            }
          }
        }
      }
    });
    if (originValue === "lab_grown") {
      narrowBy.push(["Diamond details.lab grown", "True"]);
    } else if (originValue === "natural") {
      narrowBy.push(["Diamond details.lab grown", "False"]);
    }
    if (priceMin || priceMax) {
      const minValue = priceMin || "0";
      const maxValue = priceMax || "999999";
      narrowBy.push(["Price_from_to", `${minValue}-${maxValue}`]);
    }
    Object.entries(paramGroups).forEach(([baseName, group]) => {
      var _a, _b, _c;
      if (group.gte || group.lte) {
        const store = (_b = (_a = window.Alpine) == null ? void 0 : _a.store) == null ? void 0 : _b.call(_a, "fastSimon");
        if (!store) return;
        const filter = (_c = store.fastSimonFilters) == null ? void 0 : _c.find(
          (f) => f.param_name === `filter.p.m.${baseName}`
        );
        if (filter) {
          const minValue = group.gte ? group.gte : filter.min_value.value;
          const maxValue = group.lte ? group.lte : filter.max_value.value;
          const prefix = group.nameSpace || "Magento.";
          narrowBy.push([`${prefix}${baseName}_from_to`, `${minValue}-${maxValue}`]);
        } else {
          const storedNamespace = store.getFilterNamespace(`filter.p.m.${baseName}`);
          if (storedNamespace) {
            const prefix = storedNamespace;
            if (group.gte) {
              narrowBy.push([`${prefix}${baseName}`, group.gte]);
            }
            if (group.lte) {
              narrowBy.push([`${prefix}${baseName}`, group.lte]);
            }
          }
        }
      } else {
        group.values.forEach((value) => {
          const prefix = group.nameSpace || "Magento.";
          narrowBy.push([`${prefix}${baseName}`, value]);
        });
      }
    });
    return narrowBy;
  }
  /**
   * Convert facets using pre-fetched metaobjects (no additional API calls)
   */
  static convertFastSimonFacetsWithMetaobjects(facets, metaobjects) {
    const shopifyFilters = [];
    const metaobjectService = MetaobjectService.getInstance();
    const rangeFilters = /* @__PURE__ */ new Map();
    facets.reverse().forEach((facet) => {
      const [facetName, facetValues, displayName, ,] = facet;
      switch (facetName) {
        case "Price_max":
          let maxPrice = 0;
          if (Array.isArray(facetValues) && facetValues.length > 0) {
            maxPrice = facetValues[0];
          }
          shopifyFilters.push({
            type: "price_range",
            label: "Price",
            param_name: "filter.v.price",
            active_values: [],
            values: [],
            min_value: {
              value: null,
              param_name: "filter.v.price.gte"
            },
            max_value: {
              value: null,
              param_name: "filter.v.price.lte"
            },
            range_max: maxPrice
          });
          break;
        case "Categories":
          if (Array.isArray(facetValues)) {
            shopifyFilters.push({
              type: "list",
              label: "Categories",
              param_name: "filter.v.categories",
              active_values: [],
              values: facetValues.map(
                ([categoryId, count, categoryName, ,]) => ({
                  label: categoryName,
                  value: categoryId,
                  param_name: "filter.v.categories",
                  count
                })
              ),
              min_value: { value: null, param_name: "" },
              max_value: { value: null, param_name: "" }
            });
          }
          break;
        case "Type":
        case "Price_min":
        case "Price":
        case "Isp-in-stock":
        case "Diamond details.depth":
        case "Diamond details.size":
          break;
        default:
          if (facetName.startsWith("Custom.") || facetName.startsWith("magento.") || facetName.startsWith("Magento.") || facetName.startsWith("Diamond details.") || facetName.startsWith("diamond_details.") || facetName.startsWith("Magento.variant") || facetName.startsWith("Magento.nav")) {
            const isRangeFilter = facetName.includes("_max") || facetName.includes("_min");
            const metafieldKey = facetName.replace("Custom.", "").replace("magento.", "").replace("Diamond details.", "").replace("diamond_details.", "").replace("Magento.variant nav", "").replace("Magento.variant", "").replace("Magento.variant nav", "").replace("Magento.nav", "").replace("Magento.", "");
            const baseKey = metafieldKey.replace("_max", "").replace("_min", "");
            const paramName = `filter.p.m.${baseKey}`;
            const nameSpace = facetName.replace(`${metafieldKey}`, "");
            if (Array.isArray(facetValues)) {
              let processedValues = [];
              if (isRangeFilter) {
                const valueStr = String(facetValues[0]);
                processedValues = [
                  {
                    label: valueStr,
                    value: valueStr,
                    param_name: paramName,
                    count: 1
                  }
                ];
              } else {
                processedValues = facetValues.map(([value, count]) => {
                  const valueStr = String(value);
                  if (MetaobjectService.isMetaobjectReference(valueStr)) {
                    const metaobjectId = MetaobjectService.extractMetaobjectId(valueStr);
                    const metaobject = metaobjectId ? metaobjects.get(metaobjectId) : null;
                    if (metaobject) {
                      const filterValue = {
                        label: metaobjectService.getDisplayName(metaobject),
                        value: valueStr,
                        param_name: paramName,
                        count
                      };
                      const swatchUrl = metaobjectService.getSwatchImageUrl(metaobject);
                      if (swatchUrl) {
                        filterValue.swatch = swatchUrl;
                      }
                      return filterValue;
                    }
                  }
                  return {
                    label: valueStr,
                    value: valueStr,
                    param_name: paramName,
                    count
                  };
                });
              }
              if (baseKey.toLowerCase() === "depth" || baseKey.toLowerCase() === "size") {
                let existingFilter = rangeFilters.get(baseKey.toLowerCase());
                if (!existingFilter) {
                  existingFilter = {
                    type: "price_range",
                    label: baseKey,
                    param_name: paramName,
                    active_values: [],
                    name_space: nameSpace,
                    values: [],
                    min_value: {
                      value: null,
                      param_name: `${paramName}.gte`
                    },
                    max_value: {
                      value: null,
                      param_name: `${paramName}.lte`
                    },
                    range_max: 0
                  };
                  rangeFilters.set(baseKey.toLowerCase(), existingFilter);
                }
                if (metafieldKey.includes("_max")) {
                  existingFilter.max_value.value = processedValues[0].value === -Infinity ? null : processedValues[0].value.toString();
                  existingFilter.range_max = Math.ceil(parseFloat(existingFilter.max_value.value || "0"));
                }
                if (metafieldKey.includes("_min")) {
                  existingFilter.min_value.value = processedValues[0].value === Infinity ? null : processedValues[0].value.toString();
                }
              } else {
                shopifyFilters.push({
                  type: "list",
                  label: baseKey,
                  param_name: paramName,
                  name_space: nameSpace,
                  active_values: [],
                  values: processedValues,
                  min_value: { value: null, param_name: "" },
                  max_value: { value: null, param_name: "" }
                });
              }
            }
          } else {
            const paramName = `filter.v.${facetName.toLowerCase()}`;
            if (Array.isArray(facetValues)) {
              const processedValues = facetValues.map(([value, count]) => {
                const valueStr = String(value);
                if (MetaobjectService.isMetaobjectReference(valueStr)) {
                  const metaobjectId = MetaobjectService.extractMetaobjectId(valueStr);
                  const metaobject = metaobjectId ? metaobjects.get(metaobjectId) : null;
                  if (metaobject) {
                    const filterValue = {
                      label: metaobjectService.getDisplayName(metaobject),
                      value: valueStr,
                      param_name: paramName,
                      count
                    };
                    const swatchUrl = metaobjectService.getSwatchImageUrl(metaobject);
                    if (swatchUrl) {
                      filterValue.swatch = swatchUrl;
                    }
                    return filterValue;
                  }
                }
                return {
                  label: valueStr,
                  value: valueStr,
                  param_name: paramName,
                  count
                };
              });
              shopifyFilters.push({
                type: "list",
                label: displayName,
                param_name: paramName,
                active_values: [],
                values: processedValues,
                min_value: { value: null, param_name: "" },
                max_value: { value: null, param_name: "" }
              });
            }
          }
          break;
      }
    });
    rangeFilters.forEach((filter) => {
      if (filter.min_value.value !== null || filter.max_value.value !== null) {
        shopifyFilters.push(filter);
      }
    });
    const priceFilterIndex = shopifyFilters.findIndex(
      (filter) => filter.type === "price_range" && filter.label === "Price"
    );
    if (priceFilterIndex !== -1 && shopifyFilters.length > 1) {
      const priceFilter = shopifyFilters.splice(priceFilterIndex, 1)[0];
      const insertIndex = Math.max(0, shopifyFilters.length - 3);
      shopifyFilters.splice(insertIndex, 0, priceFilter);
    }
    return shopifyFilters;
  }
}
const formatPrice = (price, currency) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency
  }).format(price);
};
const FastSimonStore = {
  // Initialize all properties with default values
  currentName: "",
  collectionId: "",
  isTopLevel: false,
  isTopFilterVisible: false,
  isFetchingProducts: false,
  isFetchingFilters: false,
  fetchedProducts: null,
  loadedProductsCount: 0,
  currentUrl: "",
  urlParams: new URLSearchParams(),
  fastSimonSDK: null,
  fastSimonFilters: null,
  persistedDiamondFilters: [],
  fastSimonSortOptions: [],
  selectedFilters: {},
  pendingFilters: {},
  // Add pending filters initialization
  currentSort: null,
  _isUpdatingFromURL: false,
  showTabletPopup: false,
  initialTotalProducts: null,
  // Manager references
  _urlManager: null,
  _stateManager: null,
  _productManager: null,
  _debouncedFetch: null,
  _abortCurrentRequest: null,
  currency: "",
  productsPerPage: 20,
  init() {
    this.currentUrl = window.location.href;
    this.urlParams = new URLSearchParams(window.location.search);
    this._initializeSDK();
    Alpine.effect(() => {
      if (this.selectedFilters) {
        document.dispatchEvent(
          new CustomEvent("fastsimon:filters-changed", {
            detail: { filters: this.selectedFilters }
          })
        );
      }
    });
    Alpine.effect(() => {
      if (this.currentSort) {
        document.dispatchEvent(
          new CustomEvent("fastsimon:sort-changed", {
            detail: { sort: this.currentSort }
          })
        );
      }
    });
    Alpine.effect(() => {
      if (this.isFetchingProducts !== void 0) {
        document.dispatchEvent(
          new CustomEvent("fastsimon:loading-changed", {
            detail: { isLoading: this.isFetchingProducts }
          })
        );
      }
    });
  },
  _initializeSDK() {
    if (!window.__fast_simon_sdk_config) {
      window.__fast_simon_sdk_config = {
        store_uuid: "0d15ce6e-f5cc-4819-b23d-c7fe2de734e8",
        store_id: 68541939812,
        type: "SPA",
        withAttributes: true,
        onReady: () => {
          this.fastSimonSDK = window.FastSimonSDK;
        }
      };
    }
  },
  setProductsPerPage(productsPerPage) {
    this.productsPerPage = productsPerPage;
  },
  resetState() {
    this.selectedFilters = {};
    this.currentSort = null;
    this.currentName = "";
    this.isTopLevel = false;
    this.isTopFilterVisible = null;
    this.loadedProductsCount = 0;
    this.persistedDiamondFilters = [];
    this.clearFilterNamespaces();
    this.resetSEOLinks();
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete("page");
    searchParams.delete("sort_by");
    searchParams.delete("sort");
    for (const [key] of Array.from(searchParams.entries())) {
      if (key.startsWith("filter.") || key === "vendor") {
        searchParams.delete(key);
      }
    }
    const newUrl = `${window.location.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
    if (newUrl !== window.location.href) {
      history.replaceState(null, document.title, newUrl);
    }
    this.currentUrl = newUrl;
    this.urlParams = searchParams;
  },
  updateURL() {
    if (this._isUpdatingFromURL) {
      return;
    }
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete("page");
    searchParams.delete("sort_by");
    searchParams.delete("sort");
    if (this.currentSort) {
      searchParams.set("sort_by", this.currentSort);
    }
    for (const [key] of Array.from(searchParams.entries())) {
      if (key.startsWith("filter.")) {
        searchParams.delete(key);
      } else if (key === "vendor") {
        searchParams.delete(key);
      }
    }
    Object.entries(this.selectedFilters).forEach(([name, values]) => {
      values.forEach((value) => {
        searchParams.append(name, value);
      });
    });
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    if (newUrl !== window.location.href) {
      history.replaceState(null, document.title, newUrl);
    }
    this.currentUrl = newUrl;
    this.urlParams = searchParams;
  },
  syncFromURL() {
    this._isUpdatingFromURL = true;
    const searchParams = new URLSearchParams(window.location.search);
    const sort = searchParams.get("sort_by") || searchParams.get("sort") || null;
    this.currentSort = sort;
    const filters = {};
    for (const [key, value] of searchParams.entries()) {
      if (key.startsWith("filter.")) {
        if (!filters[key]) {
          filters[key] = [];
        }
        if (!filters[key].includes(value)) {
          filters[key].push(value);
        }
      } else if (key === "vendor") {
        if (!filters[key]) {
          filters[key] = [];
        }
        if (!filters[key].includes(value)) {
          filters[key].push(value);
        }
      }
    }
    this.selectedFilters = filters;
    this.currentUrl = window.location.href;
    this.urlParams = searchParams;
    this._isUpdatingFromURL = false;
  },
  getFilterParams() {
    const params = [];
    Object.entries(this.selectedFilters).forEach(([name, values]) => {
      values.forEach((value) => {
        params.push({ name, value });
      });
    });
    return params;
  },
  // Filter Management Methods
  addFilter(name, value) {
    if (this.shouldUsePendingFilters()) {
      const current = { ...this.pendingFilters };
      if (!current[name]) {
        current[name] = [];
      }
      if (!current[name].includes(value)) {
        current[name].push(value);
      }
      this.pendingFilters = current;
    } else {
      const current = { ...this.selectedFilters };
      if (!current[name]) {
        current[name] = [];
      }
      if (!current[name].includes(value)) {
        current[name].push(value);
      }
      this.selectedFilters = current;
      this._resetPagination();
      this._saveNamespaceForFilter(name);
    }
  },
  removeFilter(name, value, clear = false) {
    if (this.shouldUsePendingFilters() && !clear) {
      const current = { ...this.pendingFilters };
      if (value && current[name]) {
        current[name] = current[name].filter((v) => v !== value);
        if (current[name].length === 0) {
          delete current[name];
        }
      } else {
        delete current[name];
      }
      this.pendingFilters = current;
    } else {
      const current = { ...this.selectedFilters };
      if (value && current[name]) {
        current[name] = current[name].filter((v) => v !== value);
        if (current[name].length === 0) {
          delete current[name];
        }
      } else {
        delete current[name];
      }
      this.selectedFilters = current;
    }
  },
  setSort(sort) {
    this.currentSort = sort;
  },
  clearFilters() {
    this.selectedFilters = {};
    this.clearFilterNamespaces();
  },
  isFilterApplied(filterName, filterValue) {
    var _a;
    const filters = this.shouldUsePendingFilters() ? this.pendingFilters : this.selectedFilters;
    if (!filterValue) {
      return !!filters[filterName];
    }
    return !!((_a = filters[filterName]) == null ? void 0 : _a.includes(filterValue));
  },
  // Namespace Management Methods
  saveFilterNamespace(paramName, namespace) {
    try {
      const namespaces = this._getStoredNamespaces();
      namespaces[paramName] = namespace;
      localStorage.setItem("fastsimon_filter_namespaces", JSON.stringify(namespaces));
    } catch (error) {
      console.warn("Failed to save filter namespace to localStorage:", error);
    }
  },
  getFilterNamespace(paramName) {
    try {
      const namespaces = this._getStoredNamespaces();
      return namespaces[paramName] || null;
    } catch (error) {
      console.warn("Failed to get filter namespace from localStorage:", error);
      return null;
    }
  },
  clearFilterNamespaces() {
    try {
      localStorage.removeItem("fastsimon_filter_namespaces");
    } catch (error) {
      console.warn("Failed to clear filter namespaces from localStorage:", error);
    }
  },
  // Private helper methods for namespace management
  _saveNamespaceForFilter(paramName) {
    var _a;
    if (paramName.startsWith("filter.p.m.")) {
      const filter = (_a = this.fastSimonFilters) == null ? void 0 : _a.find((f) => f.param_name === paramName);
      if (filter && filter.name_space) {
        this.saveFilterNamespace(paramName, filter.name_space);
      }
    }
  },
  _getStoredNamespaces() {
    try {
      const stored = localStorage.getItem("fastsimon_filter_namespaces");
      return stored ? JSON.parse(stored) : {};
    } catch (error) {
      console.warn("Failed to parse stored namespaces:", error);
      return {};
    }
  },
  // Computed Getters
  getAppliedFilters() {
    const appliedFilters = [];
    Object.entries(this.selectedFilters).forEach(
      ([paramName, selectedValues]) => {
        var _a, _b;
        if (selectedValues && selectedValues.length > 0) {
          const matchingFilter = (_a = this.fastSimonFilters) == null ? void 0 : _a.find(
            (filter) => filter.param_name === paramName
          );
          if (matchingFilter) {
            const selectedFilterValues = selectedValues.map(
              (value) => {
                const matchingValue = matchingFilter.values.find(
                  (v) => v.value === value
                );
                return {
                  label: (matchingValue == null ? void 0 : matchingValue.label) || value,
                  value,
                  param_name: paramName,
                  count: matchingValue == null ? void 0 : matchingValue.count,
                  swatch: matchingValue == null ? void 0 : matchingValue.swatch
                };
              }
            );
            const appliedFilter = {
              ...matchingFilter,
              values: selectedFilterValues,
              active_values: selectedFilterValues
            };
            appliedFilters.push(appliedFilter);
          } else if (paramName.includes("price")) {
            const priceFilter = (_b = this.fastSimonFilters) == null ? void 0 : _b.find(
              (filter) => filter.type === "price_range"
            );
            if (priceFilter && !appliedFilters.some((f) => f.type === "price_range")) {
              const appliedPriceFilter = {
                ...priceFilter,
                active_values: selectedValues.map((value) => ({
                  label: value,
                  value,
                  param_name: paramName
                }))
              };
              appliedFilters.push(appliedPriceFilter);
            }
          }
        }
      }
    );
    return appliedFilters;
  },
  getAppliedFiltersCount() {
    const selectedFilterKeys = Object.keys(this.selectedFilters);
    const uniqueFilters = /* @__PURE__ */ new Set();
    selectedFilterKeys.forEach((key) => {
      const baseFilterName = key.replace(/\.(gte|lte)$/, "");
      uniqueFilters.add(baseFilterName);
    });
    return uniqueFilters.size;
  },
  getDisplayLabel(filter) {
    if (filter.label === "ring mainstone shape") {
      return "Center Diamond Shape";
    }
    return filter.label;
  },
  getPriceFilter() {
    var _a;
    return (_a = this.fastSimonFilters) == null ? void 0 : _a.find((filter) => filter.label === "Price");
  },
  getPriceFilterState() {
    var _a, _b;
    const priceFilter = this.getPriceFilter();
    if (!priceFilter) return { min: null, max: null };
    const minPriceValues = ((_a = priceFilter.min_value) == null ? void 0 : _a.param_name) ? this.selectedFilters[priceFilter.min_value.param_name] : null;
    const maxPriceValues = ((_b = priceFilter.max_value) == null ? void 0 : _b.param_name) ? this.selectedFilters[priceFilter.max_value.param_name] : null;
    return {
      min: minPriceValues && minPriceValues.length > 0 ? minPriceValues[0] : null,
      max: maxPriceValues && maxPriceValues.length > 0 ? maxPriceValues[0] : null
    };
  },
  getRangeFilters() {
    if (!this.fastSimonFilters) return [];
    return this.fastSimonFilters.filter(
      (filter) => {
        var _a, _b;
        return filter.type === "price_range" && filter.label.toLowerCase() !== "price" && // Exclude the main price filter
        ((_a = filter.min_value) == null ? void 0 : _a.param_name) && ((_b = filter.max_value) == null ? void 0 : _b.param_name);
      }
    ).map((filter) => {
      var _a, _b;
      const minValues = ((_a = filter.min_value) == null ? void 0 : _a.param_name) ? this.selectedFilters[filter.min_value.param_name] : null;
      const maxValues = ((_b = filter.max_value) == null ? void 0 : _b.param_name) ? this.selectedFilters[filter.max_value.param_name] : null;
      return {
        label: filter.label,
        param_name: filter.param_name,
        min: minValues && minValues.length > 0 ? minValues[0] : null,
        max: maxValues && maxValues.length > 0 ? maxValues[0] : null
      };
    });
  },
  getFormattedMinPrice() {
    const priceState = this.getPriceFilterState();
    if (!priceState.min) return "";
    const price = Math.trunc(parseFloat(priceState.min));
    return formatPrice(price, this.currency).replace(".00", "");
  },
  getFormattedMaxPrice() {
    const priceState = this.getPriceFilterState();
    if (!priceState.max) return "";
    const maxValue = parseFloat(priceState.max);
    const adjustedValue = maxValue % 1 !== 0 ? Math.trunc(maxValue) + 1 : maxValue;
    return formatPrice(adjustedValue, this.currency).replace(".00", "");
  },
  // New method to get price state
  getPriceState() {
    const priceState = this.getPriceFilterState();
    return {
      min: Boolean(priceState.min && !priceState.max),
      max: Boolean(priceState.max && !priceState.min),
      both: Boolean(priceState.max && priceState.min)
    };
  },
  // Product Fetching
  async fetchProducts(collectionId, itemsPerPage, pageNumber, isPreviousPage = false) {
    if (this._abortCurrentRequest) {
      this._abortCurrentRequest();
    }
    return new Promise((resolve, reject) => {
      var _a;
      let isAborted = false;
      this._abortCurrentRequest = () => {
        isAborted = true;
        this.isFetchingProducts = false;
      };
      this.isFetchingProducts = true;
      const sdk = this.fastSimonSDK || window.FastSimonSDK;
      if (!sdk) {
        setTimeout(() => {
          if (!isAborted) {
            this.fetchProducts(collectionId, itemsPerPage, pageNumber, isPreviousPage).then(resolve).catch(reject);
          }
        }, 1e3);
        return;
      }
      const narrowBy = FastSimonUtils.filtersToNarrowBy(this.getFilterParams());
      try {
        sdk.smartCollections({
          categoryID: collectionId,
          page: pageNumber,
          productsPerPage: itemsPerPage,
          narrowBy,
          sortBy: this.currentSort || "relevency",
          withAttributes: true,
          facets: false,
          callback: async (response) => {
            var _a2, _b, _c;
            if (isAborted) {
              return;
            }
            this._abortCurrentRequest = null;
            if (response.action === "products") {
              try {
                if (response.payload) {
                  const payload = response.payload;
                  const fastSimonProducts = payload.totalResults && payload.products ? payload.products : [];
                  const { products: shopifyProducts } = await FastSimonUtils.convertFastSimonResponse(
                    fastSimonProducts,
                    [],
                    true
                  );
                  let products = [];
                  if (isPreviousPage) {
                    products = [
                      ...shopifyProducts,
                      ...((_a2 = this.fetchedProducts) == null ? void 0 : _a2.products) || []
                    ];
                  } else {
                    products = [
                      ...((_b = this.fetchedProducts) == null ? void 0 : _b.products) || [],
                      ...shopifyProducts
                    ];
                  }
                  const result = {
                    products: payload.page === 1 && !isPreviousPage ? shopifyProducts : products,
                    totalPages: payload.pageCount || 1,
                    totalProducts: payload.totalResults || 0,
                    currentPage: isPreviousPage ? this.getCurrentPage() : payload.page || 1
                  };
                  this.fetchedProducts = result;
                  this.loadedProductsCount = result.products.length;
                  this.isFetchingProducts = false;
                  if (!isPreviousPage) {
                    const searchParams = new URLSearchParams(window.location.search);
                    searchParams.delete("page");
                    if (result.totalProducts > itemsPerPage && result.currentPage !== 1) {
                      searchParams.set("page", result.currentPage.toString());
                    }
                    const newUrl = `${window.location.pathname}${((_c = searchParams == null ? void 0 : searchParams.toString()) == null ? void 0 : _c.length) ? `?${searchParams.toString()}` : ""}`;
                    if (newUrl !== window.location.href) {
                      const scrollPosition = window.scrollY;
                      history.replaceState({ ...history.state, scrollPosition }, document.title, newUrl);
                    }
                    this.currentUrl = newUrl;
                    this.urlParams = searchParams;
                    const existingNextLinks = [...document.head.querySelectorAll(`link[rel="next"]`), ...document.head.querySelectorAll(`link[rel="prev"]`)];
                    existingNextLinks.forEach((link) => link.remove());
                    if (result.totalPages > 1 && pageNumber > 1 && pageNumber <= result.totalPages) {
                      if (pageNumber < result.totalPages) {
                        const nextParams = new URLSearchParams();
                        nextParams.set("page", (pageNumber + 1).toString());
                        const nextLink = document.createElement("link");
                        nextLink.rel = "next";
                        nextLink.href = `${window.location.origin}${window.location.pathname}?${nextParams.toString()}`;
                        document.head.appendChild(nextLink);
                      }
                      if (pageNumber > 1) {
                        const previousLink = document.createElement("link");
                        previousLink.rel = "prev";
                        previousLink.href = `${window.location.origin}${window.location.pathname}${pageNumber > 2 ? `?page=${pageNumber - 1}` : ""}`;
                        document.head.appendChild(previousLink);
                      }
                    }
                  }
                  resolve(result);
                } else {
                  this.isFetchingProducts = false;
                  reject(new Error("Invalid response format from FastSimon"));
                }
              } catch (error) {
                this.isFetchingProducts = false;
                reject(error);
              }
            }
          }
        });
      } catch (error) {
        this.isFetchingProducts = false;
        if (!isPreviousPage && pageNumber > 1 && this.fetchedProducts && ((_a = this.fetchedProducts.products) == null ? void 0 : _a.length)) {
          resolve(this.fetchedProducts);
        } else {
          const emptyResult = {
            products: [],
            totalPages: 1,
            totalProducts: 0,
            currentPage: isPreviousPage ? this.getCurrentPage() : pageNumber
          };
          this.fetchedProducts = emptyResult;
          this.loadedProductsCount = 0;
          resolve(emptyResult);
        }
      }
    });
  },
  // Load More Products (for pagination - appends instead of replaces)
  async loadMoreProducts(productsPerPage = 20) {
    if (productsPerPage <= 0) {
      return Promise.reject(new Error("Products per page must be positive"));
    }
    if (!this.fetchedProducts) {
      return Promise.reject(new Error("No initial products loaded"));
    }
    const nextPage = this.getCurrentPage() + 1;
    if (nextPage > this.fetchedProducts.totalPages) {
      return Promise.reject(new Error("No more pages to load"));
    }
    if (this.isFetchingProducts) {
      return Promise.reject(new Error("Already fetching products"));
    }
    try {
      const result = await this.fetchProducts(
        this.collectionId,
        productsPerPage,
        nextPage,
        false
      );
      return result;
    } catch (error) {
      this.isFetchingProducts = false;
      return this.fetchedProducts;
    }
  },
  async loadPreviousProducts(productsPerPage = 20) {
    if (productsPerPage <= 0) {
      return Promise.reject(new Error("Products per page must be positive"));
    }
    if (!this.fetchedProducts) {
      return Promise.reject(new Error("No initial products loaded"));
    }
    let previousPage;
    if (this.fetchedProducts.products.length === 0) {
      previousPage = 1;
    } else {
      const totalLoadedProducts = this.fetchedProducts.products.length;
      const completePagesLoaded = Math.floor(totalLoadedProducts / productsPerPage);
      const currentPage = this.getCurrentPage();
      if (completePagesLoaded > 0) {
        previousPage = currentPage - completePagesLoaded;
      } else {
        previousPage = 1;
      }
    }
    if (previousPage < 1) {
      return Promise.reject(new Error("No more pages to load"));
    }
    if (this.isFetchingProducts) {
      return Promise.reject(new Error("Already fetching products"));
    }
    try {
      const result = await this.fetchProducts(
        this.collectionId,
        productsPerPage,
        previousPage,
        true
      );
      this._scrollToTop();
      return result;
    } catch (error) {
      this.isFetchingProducts = false;
      throw error;
    }
  },
  // Check if more products can be loaded
  canLoadMoreProducts() {
    if (!this.fetchedProducts) {
      return false;
    }
    const currentPage = this.getCurrentPage();
    return currentPage < this.fetchedProducts.totalPages && this.loadedProductsCount < this.fetchedProducts.totalProducts;
  },
  canLoadPreviousProducts() {
    if (!this.fetchedProducts) {
      return false;
    }
    const currentPage = this.getCurrentPage();
    if (currentPage <= 1) {
      return false;
    }
    const PRODUCTS_PER_PAGE = this.productsPerPage - 4;
    const expectedPreviousProducts = (currentPage - 1) * PRODUCTS_PER_PAGE;
    const actualPreviousProducts = this.fetchedProducts.products.length - PRODUCTS_PER_PAGE;
    return actualPreviousProducts < expectedPreviousProducts;
  },
  setCurrency(currency) {
    this.currency = currency;
  },
  getCurrentPage() {
    const searchParams = new URLSearchParams(window.location.search);
    const page = parseInt(searchParams.get("page") || "1", 10);
    return isNaN(page) || page < 1 ? 1 : page;
  },
  // Helper method to reset pagination to page 1
  _resetPagination() {
    const currentPage = this.getCurrentPage();
    if (currentPage > 1) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete("page");
      const newUrl = `${window.location.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
      if (newUrl !== window.location.href) {
        history.replaceState(null, document.title, newUrl);
      }
      this.currentUrl = newUrl;
      this.urlParams = searchParams;
      this.resetSEOLinks();
    }
  },
  setInitialTotalProducts(total) {
    this.initialTotalProducts = total;
  },
  resetSEOLinks() {
    var _a;
    const existingNextLinks = [...document.head.querySelectorAll(`link[rel="next"]`), ...document.head.querySelectorAll(`link[rel="prev"]`)];
    existingNextLinks.forEach((link) => link.remove());
    if (this.fetchedProducts) {
      if (((_a = this.fetchedProducts) == null ? void 0 : _a.totalPages) > 1) {
        const nextParams = new URLSearchParams();
        nextParams.set("page", "1");
        const nextLink = document.createElement("link");
        nextLink.rel = "next";
        nextLink.href = `${window.location.origin}${window.location.pathname}?${nextParams.toString()}`;
        document.head.appendChild(nextLink);
      }
    }
  },
  // Helper method to scroll to top of the product grid
  _scrollToTop() {
    const productGridContainer = document.getElementById("ProductGridContainer");
    if (productGridContainer) {
      productGridContainer.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
  // Add method to check if we should use pending filters
  shouldUsePendingFilters() {
    var _a;
    if (!Alpine.store("main").isMobile && !Alpine.store("main").isTablet) {
      return false;
    }
    const collectionHandle = document.body.dataset.collectionHandle;
    const isRingBuilderCollection = collectionHandle === "engagement-rings" || collectionHandle === "diamond-finder";
    if (isRingBuilderCollection) {
      return false;
    }
    const currentFilter = (_a = this.fastSimonFilters) == null ? void 0 : _a.find(
      (f) => {
        var _a2;
        return f.label === "shape" && ((_a2 = f.values) == null ? void 0 : _a2.some((v) => {
          var _a3;
          return (_a3 = this.pendingFilters[f.param_name]) == null ? void 0 : _a3.includes(v.value);
        }));
      }
    );
    if (currentFilter) {
      return false;
    }
    return true;
  },
  // Add method to apply pending filters
  applyPendingFilters() {
    var _a;
    if (Object.keys(this.pendingFilters).length > 0) {
      const shapeFilter = (_a = this.fastSimonFilters) == null ? void 0 : _a.find((f) => f.label === "shape");
      const shapeFilterValues = shapeFilter ? this.selectedFilters[shapeFilter.param_name] : null;
      this.selectedFilters = { ...this.pendingFilters };
      if (shapeFilter && shapeFilterValues) {
        this.selectedFilters[shapeFilter.param_name] = shapeFilterValues;
      }
      this._resetPagination();
      this.updateURL();
      if (this._debouncedFetch) {
        this._debouncedFetch();
      } else {
        this.fetchProducts(
          this.collectionId,
          this.productsPerPage,
          1,
          false
        );
      }
    }
  },
  // Add method to clear pending filters
  clearPendingFilters() {
    this.pendingFilters = {};
  }
};
const BeforeAfter = (props) => ({
  wrapperRect: null,
  wrapperEl: null,
  exposure: 50,
  init() {
    const { id } = props;
    this.wrapperEl = document.getElementById(id);
    const computeWrapperRect = () => {
      if (!this.wrapperEl) {
        return;
      }
      const rect = this.wrapperEl.getBoundingClientRect();
      this.wrapperRect = rect;
    };
    window.addEventListener("resize", computeWrapperRect);
    computeWrapperRect();
    this.$watch("exposure", (value) => {
      if (!this.wrapperEl) {
        return;
      }
      this.wrapperEl.style.setProperty(
        "--exposure",
        `${100 - parseInt(value, 10)}%`
      );
    });
  },
  onPointerDown() {
    const move = (e) => {
      if (!this.wrapperEl || !this.wrapperRect) {
        return;
      }
      const x = e.clientX - this.wrapperRect.left;
      this.exposure = Math.min(
        100,
        Math.max(0, x / this.wrapperRect.width * 100)
      );
    };
    const up = () => {
      document.removeEventListener("pointermove", move);
      document.removeEventListener("pointerup", up);
    };
    document.addEventListener("pointermove", move);
    document.addEventListener("pointerup", up);
  },
  onKeyDown(e) {
    if (!this.wrapperEl) {
      return;
    }
    if (e.key === ARROW_RIGHT_KEY && this.exposure < 100) {
      this.exposure++;
      e.preventDefault();
    }
    if (e.key === ARROW_LEFT_KEY && this.exposure > 0) {
      this.exposure--;
      e.preventDefault();
    }
  }
});
const easeInOutQuad = (x) => {
  return x;
};
const OFFSET_TOP = window.innerHeight > 1080 ? 400 : 200;
let prevIsMobile = isMobile();
const TransitionPreview = () => ({
  isActive: false,
  lastSeenWithoutPreview: 0,
  offsetTop: OFFSET_TOP,
  maxScroll: OFFSET_TOP / 4 * 3,
  _scrollContainerRef: null,
  init() {
    Alpine.nextTick(() => {
      this._scrollContainerRef = this.$refs.scrollContainer;
    });
    window.addEventListener("pushstate", async (event) => {
      const { state } = event.detail;
      if (state == null ? void 0 : state.isPreview) {
        this.lastSeenWithoutPreview += 1;
        this.showPreview();
      } else {
        this.lastSeenWithoutPreview = 0;
        this.hidePreview();
      }
    });
    window.addEventListener("popstate", async (event) => {
      const { state } = event;
      if (state == null ? void 0 : state.isPreview) {
        this.lastSeenWithoutPreview -= 1;
        this.showPreview();
      } else {
        this.lastSeenWithoutPreview = 0;
        this.hidePreview();
      }
    });
    window.addEventListener("beforeunload", function() {
      const { isPreview } = window.history.state || {};
      if (isPreview) {
        history.replaceState({ isPreview: false }, "", window.location.href);
      }
    });
    this.$refs.scrollContainer.addEventListener("scroll", () => {
      const percentOfMaxScroll = Math.min(
        this.$refs.scrollContainer.scrollTop / this.maxScroll,
        1
      );
      this.$refs.preview.style.setProperty(
        "--scroll-progress",
        easeInOutQuad(percentOfMaxScroll).toString()
      );
    });
    window.addEventListener("resize", () => {
      if (prevIsMobile !== isMobile()) {
        this.hidePreview();
      }
    });
  },
  scrollToPreviewTop() {
    var _a;
    (_a = this._scrollContainerRef) == null ? void 0 : _a.scrollTo({
      top: this.maxScroll,
      behavior: "smooth"
    });
  },
  scrollToTop() {
    var _a;
    (_a = this._scrollContainerRef) == null ? void 0 : _a.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  },
  showPreview() {
    if (this.isActive) {
      this.scrollToPreviewTop();
      return;
    }
    this.isActive = true;
    Alpine.store("transition").isPreviewActive = true;
    this.scrollToTop();
    freezeScroll();
    makeElementScrollable(this._scrollContainerRef);
    document.addEventListener("keydown", this._onKeyDown.bind(this));
  },
  hidePreview() {
    if (!this.isActive) return;
    this.scrollToTop();
    this.isActive = false;
    Alpine.store("transition").isPreviewActive = false;
    if (this.lastSeenWithoutPreview) {
      history.go(-this.lastSeenWithoutPreview);
    }
    unfreezeScroll();
    setTimeout(() => {
      var _a;
      const wrapperEl = document.querySelector(".transition-preview");
      if (wrapperEl) {
        wrapperEl.removeAttribute("role");
        wrapperEl.removeAttribute("aria-modal");
        wrapperEl.removeAttribute("aria-labelledby");
      }
      document.getElementById("PreviewContent").innerHTML = "";
      (_a = Alpine.store("transition").originalFocusableEl) == null ? void 0 : _a.focus();
      Alpine.store("transition").originalFocusableEl = null;
    }, 300);
    document.removeEventListener("keydown", this._onKeyDown);
  },
  _onKeyDown(e) {
    const isEscPressed = e.key === ESC_KEY;
    if (isEscPressed) {
      const resizables = Alpine.store("resizable")._current;
      if (!Object.keys(resizables).length) {
        this.hidePreview();
      }
    }
  }
});
const SEARCH_QUERY_NAME = "q";
const ProductList = (...args) => {
  const [path] = args;
  return {
    isLoadingProducts: false,
    init() {
      this._fetchPage = this._fetchPage.bind(this);
    },
    resetAll() {
      history.replaceState(
        history.state,
        "",
        location.pathname
      );
      this._fetchPage(this._getSearchQueryString(), true);
      this.$dispatch("reset-filters");
    },
    _getSearchQuery() {
      return new URLSearchParams(window.location.search).get(SEARCH_QUERY_NAME) || "";
    },
    _getSearchQueryString() {
      const searchValue = this._getSearchQuery();
      return searchValue ? `?${SEARCH_QUERY_NAME}=${searchValue}` : "";
    },
    _fetchPage(queryString, isReset = false) {
      this.isLoadingProducts = true;
      fetch(`${path}${queryString}`).then((response) => response.text()).then((data) => {
        const resultHtml = document.createElement("div");
        resultHtml.innerHTML = data;
        const productGridHtml = resultHtml.querySelector(
          "#ProductGridContainer"
        );
        const productGridElem = this.$refs.ProductGridContainer;
        replaceElement(productGridElem, productGridHtml, isReset);
        history.replaceState(
          history.state,
          "",
          queryString || location.pathname
        );
      }).catch((error) => console.error("Error:", error)).finally(() => this.isLoadingProducts = false);
    }
  };
};
const FILTER_GIA_NUM_List = ["diamond_details.cert_number", "Diamond details.cert id"];
const FILTER_SKU_NUM_List = ["diamond_details.stock_num", "diamond_details.diamond_id"];
const DiamondSearch = () => ({
  diamondIdentifier: "",
  isDiamondNotAvailable: null,
  isSimonAppDown: false,
  isLoading: false,
  searchByGIAorSKU() {
    const $form = document.getElementById("diamond-search-form");
    this.diamondIdentifier = this.diamondIdentifier.trim();
    if (!$form || !this.diamondIdentifier) return;
    this.isLoading = true;
    if (window.FastSimonSDK) {
      window.FastSimonSDK.fullTextSearch({
        term: this.diamondIdentifier,
        narrowBy: [...FILTER_GIA_NUM_List, ...FILTER_SKU_NUM_List],
        page: 1,
        productsPerPage: 1,
        withAttributes: true,
        facets: false,
        callback: (response) => {
          if (!response || !response.payload) {
            this.isSimonAppDown = true;
            return;
          }
          this.isSimonAppDown = false;
          if (response.payload.isNoResults || response.payload.products.length === 0) {
            this.isDiamondNotAvailable = true;
            this.isLoading = false;
            return;
          }
          let isGiaMatch = false;
          let isSkuMatch = false;
          if (response.payload.products[0].sku.toLowerCase() === this.diamondIdentifier.toLowerCase()) {
            isSkuMatch = true;
          }
          response.payload.products[0].att.forEach((attr) => {
            FILTER_GIA_NUM_List.forEach((filter) => {
              if (attr[0] === filter && attr[1][0].toLowerCase() === this.diamondIdentifier.toLowerCase()) {
                isGiaMatch = true;
              }
            });
            FILTER_SKU_NUM_List.forEach((filter) => {
              if (attr[0] === filter && attr[1][0].toLowerCase() === this.diamondIdentifier.toLowerCase()) {
                isSkuMatch = true;
              }
            });
          });
          if (isGiaMatch || isSkuMatch) {
            const product = response.payload.products[0];
            const productUrl = `${window.location.origin}${product.u}`;
            this.isDiamondNotAvailable = false;
            window.location.href = productUrl;
          } else {
            this.isDiamondNotAvailable = true;
          }
          this.isLoading = false;
        }
      });
    }
  }
});
const POPUP_BOTTOM_ACTIONS = "product_bottom_actions";
const ProductPage = () => ({
  isVariantInCart: false,
  variantQty: 1,
  selectedVariantId: void 0,
  selectedOptions: [],
  uiSelectedOptions: [],
  // Track UI state separately
  manuallySelectedVariantId: void 0,
  productId: void 0,
  contentId: "product-page",
  isSyncedWithUrl: true,
  isScrollingToTop: false,
  // Changed default to false
  productUrl: "",
  sectionId: null,
  XRMediaModels: [],
  properties: {
    __shopify_send_gift_card_to_recipient: false,
    "Recipient email": null,
    "Recipient name": null,
    Message: null,
    "Send on": null
  },
  cartItemKey: void 0,
  variantsCount: null,
  _formRef: null,
  _mutationObserver: null,
  productActionsPopup: "product_actions",
  variants: [],
  variantsOptions: [],
  isVariantAvailable: true,
  isVariantUpdating: false,
  updateVariantDebounced: null,
  setProductPageProps({
    manuallySelectedVariantId,
    selectedVariantId,
    selectedOptions,
    productId,
    productUrl,
    isSyncedWithUrl = false,
    isScrollingToTop = false,
    sectionId = null,
    XRMediaModels = [],
    variants = []
  }) {
    this.isVariantManuallySelected = !!manuallySelectedVariantId;
    this.selectedVariantId = selectedVariantId;
    this.selectedOptions = selectedOptions;
    this.uiSelectedOptions = [...selectedOptions];
    this.productId = productId;
    this.productActionsPopup += `-${productId}`;
    this.productUrl = productUrl;
    this.isSyncedWithUrl = isSyncedWithUrl;
    this.isScrollingToTop = isScrollingToTop;
    this.sectionId = sectionId;
    this.XRMediaModels = XRMediaModels;
    this.variants = variants;
    this.variantsOptions = variants.map((variant) => variant.options);
    this.variantsCount = variants.length;
    if (sectionId) {
      this.productActionsPopup += `-${sectionId}`;
    }
    this._updateSelectedVariantCartState();
    if (this.XRMediaModels.length) {
      this.setupShopifyXR();
    }
  },
  get isProductBeingRemoved() {
    return Alpine.store("cart").removingItemKey === this.cartItemKey;
  },
  get isProductBeingAdded() {
    if (this.selectedVariantId) {
      return Alpine.store("cart").addingItemIds.includes(
        this.selectedVariantId
      );
    } else {
      return false;
    }
  },
  init() {
    var _a;
    (_a = window.Shopify.PaymentButton) == null ? void 0 : _a.init();
    this._formRef = this.$refs.ProductForm;
    this.updateVariantDebounced = this.debounce((variantId, variantImg) => {
      this._updateVariantInBackground(variantId, variantImg);
    }, 300);
    this.$watch("$store.cart.cartItems", () => {
      this._updateSelectedVariantCartState();
    });
    this.$watch("properties", () => {
      if (!this.properties.__shopify_send_gift_card_to_recipient) {
        this.properties = {
          __shopify_send_gift_card_to_recipient: false,
          "Recipient email": null,
          "Recipient name": null,
          Message: null,
          "Send on": null
        };
      }
      this._updateSelectedVariantCartState();
    });
    Alpine.nextTick(() => {
      if (!this._formRef) {
        return;
      }
      this._mutationObserver = new MutationObserver((mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === "childList") {
            this._updateSelectedVariantCartState();
            return;
          }
          if (mutation.target.nodeName === "INPUT" && mutation.target.name === "selling_plan") {
            this._updateSelectedVariantCartState();
          }
        }
      });
      this._mutationObserver.observe(this._formRef, {
        attributeFilter: ["value"],
        subtree: true,
        childList: true
      });
    });
    document.addEventListener(POPUP_OVERLAY_CLICK_EVENT, () => {
      if (this.$store.popup.currentPopup === this.productActionsPopup) {
        this._handleStickyProductActionsClosure();
      }
    });
  },
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },
  async _updateVariantInBackground(variantId, variantImg) {
    if (this.variantsCount <= 1) return;
    const nextUrl = new URL(this.productUrl, document.baseURI);
    nextUrl.searchParams.set("variant", variantId.toString());
    if (this.sectionId) {
      nextUrl.searchParams.set("section_id", this.sectionId);
    }
    try {
      const html = await fetchPage(nextUrl.href);
      const wrapper = document.getElementById(this.sectionId || this.contentId);
      wrapper.classList.add("disable-fade");
      Alpine.store("transition").pageData = {
        ...Alpine.store("transition").pageData,
        variantImg
      };
      replaceContent(
        html,
        this.sectionId || `${this.contentId}-content`,
        wrapper
      );
      if (this.isSyncedWithUrl) {
        history.replaceState(history.state, "", nextUrl.href);
      }
      if (typeof initMagic !== "undefined") {
        initMagic();
      }
      document.dispatchEvent(new CustomEvent("variant:changed", {
        detail: { variantId }
      }));
    } catch (error) {
      console.error("Failed to update variant:", error);
    }
  },
  setupShopifyXR() {
    window.Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupXRElements.bind(this)
      }
    ]);
  },
  setupXRElements(errors) {
    if (errors) return;
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () => {
        this.setupXRElements();
      });
      return;
    }
    window.ShopifyXR.addModels(this.XRMediaModels);
    window.ShopifyXR.setupXRElements();
  },
  _updateSelectedVariantCartState() {
    if (!this.selectedVariantId) {
      return;
    }
    const cartItem = Alpine.store("cart").cartItems.find(
      this.checkIsItemInCart.bind(this)
    );
    this.isVariantInCart = !!cartItem;
    this.variantQty = (cartItem == null ? void 0 : cartItem.quantity) || 1;
    this.cartItemKey = cartItem == null ? void 0 : cartItem.key;
  },
  checkIsItemInCart(item) {
    var _a, _b;
    if (item.isDeleted) {
      return false;
    }
    if (item.id !== this.selectedVariantId) {
      return false;
    }
    const selling_plan = (_a = this._formRef) == null ? void 0 : _a.querySelector(
      "input[name=selling_plan]"
    );
    if (Number((selling_plan == null ? void 0 : selling_plan.value) || null) !== Number(((_b = item.selling_plan_allocation) == null ? void 0 : _b.selling_plan.id) || null)) {
      return false;
    }
    const isDifferentRecipient = Object.keys(this.properties).some((key) => {
      const value = this.properties[key];
      const valueToCheck = value === "" ? null : value;
      const itemProps = Object.keys(item.properties).length ? item.properties : {
        __shopify_send_gift_card_to_recipient: false,
        "Recipient email": null,
        "Recipient name": null,
        Message: null,
        "Send on": null
      };
      return itemProps[key] !== valueToCheck;
    });
    if (isDifferentRecipient) {
      return false;
    }
    return true;
  },
  selectOptionAndSetVariantId(optionIndex, optionValue, variantId, variantImg, isRingSize) {
    if (!this.selectedOptions) return;
    requestAnimationFrame(() => {
      if (isRingSize && this.selectedOptions && this.selectedOptions[optionIndex] === optionValue) {
        const defaultVariant = this.variants.find(
          (v) => v.options.includes("I don't know my size")
        );
        if (defaultVariant) {
          if (this.selectedOptions) {
            this.selectedOptions[optionIndex] = "I don't know my size";
          }
          this.selectedVariantId = defaultVariant.id;
          this._updateSelectedVariantCartState();
          if (this.updateVariantDebounced) {
            this.updateVariantDebounced(defaultVariant.id, variantImg);
          }
          return;
        }
      }
      if (this.selectedOptions) {
        this.selectedOptions[optionIndex] = optionValue;
      }
      this.isVariantManuallySelected = true;
      this.isVariantAvailable = this.variantsOptions.some(
        (variant) => variant.every((option) => {
          var _a;
          return (_a = this.selectedOptions) == null ? void 0 : _a.includes(option);
        })
      );
      if (!this.isVariantAvailable) {
        const value = this.selectedOptions ? Object.values(this.selectedOptions)[0] : "";
        const variant = this.variants.find((v) => v.option1 === value) || this.variants.find((v) => v.option2 === value) || this.variants.find((v) => v.option3 === value);
        variantId = variant.id;
      }
      this.selectedVariantId = variantId;
      this._updateSelectedVariantCartState();
      if (this.updateVariantDebounced) {
        this.updateVariantDebounced(variantId, variantImg);
      }
    });
  },
  toggleStickyProductActions(show) {
    if (this.$store.popup.currentPopup && this.$store.popup.currentPopup !== POPUP_BOTTOM_ACTIONS) {
      return;
    }
    if (!show) {
      this.$store.popup.hidePopup(POPUP_BOTTOM_ACTIONS);
    } else {
      this.$store.popup.showPopup(POPUP_BOTTOM_ACTIONS, true);
    }
  },
  decreaseQty() {
    if (!this.selectedVariantId && this.variantQty <= 0) {
      return;
    }
    this.variantQty -= 1;
    Alpine.store("cart").decreaseQty(this.cartItemKey);
  },
  increaseQty() {
    if (!this.selectedVariantId) {
      return;
    }
    this.variantQty += 1;
    Alpine.store("cart").increaseQty(this.cartItemKey);
  },
  setQuantity(quantity) {
    if (!this.selectedVariantId) {
      return;
    }
    this.variantQty = Math.max(0, Number(quantity));
    Alpine.store("cart").setQty(quantity, this.cartItemKey);
  },
  addToCart() {
    if (!this.selectedVariantId) {
      return;
    }
    const formData = new FormData(this._formRef);
    const formProps = Object.fromEntries(formData);
    this.hideProductActions();
    this.$store.cart.addToCart({
      ...formProps,
      id: this.selectedVariantId,
      quantity: this.variantQty,
      properties: this.properties
    });
  },
  hideProductActions() {
    this._handleStickyProductActionsClosure();
    this.$store.popup.hidePopup(this.productActionsPopup);
  },
  _handleStickyProductActionsClosure() {
    const el = document.getElementById(
      "product-actions"
    );
    if (el && el._x_visible) {
      this.$store.popup.__popupHistory = this.$store.popup.__popupHistory.filter((p) => {
        return p !== POPUP_BOTTOM_ACTIONS;
      });
    }
  },
  showProductActions() {
    this.$store.popup.showPopup(this.productActionsPopup, true);
  },
  quickBuy(singleVariant) {
    if (singleVariant) {
      if (this.isVariantInCart) {
        return Alpine.store("cart").increaseQty(this.cartItemKey, true);
      }
      return this.$store.cart.addToCart({
        id: this.selectedVariantId,
        quantity: 1
      });
    }
    this.contentId = "product-options";
    this.showProductActions();
  },
  scrollToTop() {
    if (typeof this.scrollToPreviewTop !== "undefined") {
      this.scrollToPreviewTop();
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
  scrollToRequestForm() {
    const formContainer = document.getElementById("product-request-form-container");
    if (formContainer) {
      const headerHeight = Alpine.store("main").getHeaderHeight();
      const formContainerRect = formContainer.getBoundingClientRect();
      const currentScrollTop = window.scrollY;
      const top = currentScrollTop + formContainerRect.top - headerHeight;
      window.scrollTo({ top, behavior: "smooth" });
    }
  },
  async fetchProductRecommendations(id, url) {
    const nextPage = fetchPage(url);
    const text = await nextPage;
    const html = document.createElement("div");
    html.innerHTML = text;
    const fallback = html.querySelector(`#${id}`);
    const wrapper = document.querySelector(`#${id}-wrapper`);
    if (fallback) {
      wrapper.remove();
      return;
    }
    const content = html.querySelector(`#${id}-wrapper`);
    wrapper.innerHTML = content == null ? void 0 : content.innerHTML;
  }
});
const Dropdown = () => ({
  isDropdownVisible: false,
  _dropdownWrapper: null,
  _onClick: (_event) => {
  },
  _onKeydown: (_event) => {
  },
  init() {
    Alpine.nextTick(() => {
      this._dropdownWrapper = this.$refs.DropdownWrapper;
    });
  },
  toggleDropdown() {
    if (this.isDropdownVisible) {
      this.hide();
    } else {
      this.show();
    }
  },
  show() {
    this.isDropdownVisible = true;
    this._onClick = (e) => {
      var _a;
      if (!((_a = this._dropdownWrapper) == null ? void 0 : _a.contains(e.target))) {
        this.hide();
      }
    };
    document.addEventListener("click", this._onClick);
    this._onKeydown = (e) => {
      const isEscPressed = e.key === ESC_KEY;
      if (isEscPressed) {
        this.hide();
      }
    };
    document.addEventListener("keydown", this._onKeydown);
  },
  hide() {
    this.isDropdownVisible = false;
    document.removeEventListener("click", this._onClick);
    document.removeEventListener("keydown", this._onKeydown);
  },
  search(value) {
    var _a;
    const options = (_a = this._dropdownWrapper) == null ? void 0 : _a.querySelectorAll("li a");
    options == null ? void 0 : options.forEach((option) => {
      const optionValue = option.outerText.toLowerCase();
      const match = optionValue.includes(value.toLowerCase());
      option.classList.toggle("hidden", !match);
    });
  }
});
const initialSearch = new URLSearchParams(window.location.search).get("q");
const Search = (context = "resizable") => ({
  isLoading: false,
  searchTerm: context === "page" ? initialSearch || "" : "",
  searchTermInput: context === "page" ? initialSearch || "" : "",
  queries: [],
  products: null,
  isNoResults: false,
  isSimonAppDown: false,
  totalResults: null,
  currentPage: 0,
  pageCount: null,
  productsPerPage: context === "page" ? 20 : 6,
  context,
  simonAppDownCount: 0,
  simonAppDownLimit: 3,
  getIsSearchActive() {
    return this.searchTerm && !this.isSimonAppDown;
  },
  init() {
    if (this.context === "page" && this.searchTerm) {
      setTimeout(() => {
        this.search(true);
      }, 100);
    } else {
      this.handleMobileSearchPopupHeight();
    }
    this.$watch("searchTerm", (value) => {
      if (value) {
        this.search(true);
      }
    });
  },
  setSearchTerm() {
    if (this.searchTerm.trim() !== this.searchTermInput.trim()) {
      this.isLoading = true;
    }
    this.searchTerm = this.searchTermInput.trim().toLowerCase();
    this.handleMobileSearchPopupHeight();
  },
  resetSearchTerm() {
    this.searchTermInput = "";
    this.setSearchTerm();
    this.isLoading = false;
  },
  clearSearchState() {
    this.searchTerm = "";
    this.searchTermInput = "";
    this.products = [];
    this.isNoResults = false;
    this.isSimonAppDown = false;
    this.totalResults = null;
    this.currentPage = 0;
    this.pageCount = null;
    this.isLoading = false;
    this.handleMobileSearchPopupHeight();
  },
  search(resetProducts = false, page = 1) {
    this.isLoading = true;
    if (window.FastSimonSDK) {
      window.FastSimonSDK.instantSearch({
        query: this.searchTerm.toLocaleLowerCase(),
        callback: (response) => {
          var _a;
          const linksContainers = document.getElementsByClassName("search-suggestions");
          for (let i = 0; i < linksContainers.length; i++) {
            const container = linksContainers[i];
            container.innerHTML = "";
          }
          if ((_a = response.payload) == null ? void 0 : _a.turbolinks) {
            const topThreeTurbolinks = response.payload.turbolinks.slice(0, 3);
            topThreeTurbolinks.forEach((turbolink) => {
              for (let i = 0; i < linksContainers.length; i++) {
                const container = linksContainers[i];
                const turboLink = document.createElement("a");
                turboLink.href = turbolink.u;
                turboLink.innerText = turbolink.l;
                turboLink.className = "link link--standard block mb-2 hover:text-primary-500 transition-colors duration-200";
                container.appendChild(turboLink);
              }
            });
          }
        }
      });
      window.FastSimonSDK.fullTextSearch({
        term: this.searchTerm.toLocaleLowerCase(),
        page,
        productsPerPage: this.productsPerPage,
        withAttributes: true,
        callback: (response) => {
          var _a, _b;
          if (response.action === "turbolink") {
            if ((_a = response.payload.turbolink) == null ? void 0 : _a.u) {
              window.location.href = response.payload.turbolink.u;
              return;
            }
          }
          if (!response || !response.payload) {
            this.isSimonAppDown = true;
            this.products = [];
            this.totalResults = 0;
            this.isLoading = false;
            return;
          }
          this.isSimonAppDown = false;
          if (response.payload.isNoResults || !response.payload.products) {
            this.isNoResults = true;
            this.products = [];
            this.totalResults = 0;
            this.isLoading = false;
            return;
          }
          const products = response.payload.products.map((product) => ({
            id: product.id,
            title: product.l,
            url: product.u,
            price: product.p * 100,
            compare_at_price_min: product.p_c * 100,
            sku: product.sku,
            featuredImage: product.t,
            vendor: product.att.find((attr) => attr[0] === "Vendor") ? product.att.find((attr) => attr[0] === "Vendor")[1].join(", ") : "",
            brand: product.att.find(
              (attr) => attr[0] === "Magento.brand" || attr[0] === "Custom.brand"
            ) ? product.att.find(
              (attr) => attr[0] === "Magento.brand" || attr[0] === "Custom.brand"
            )[1].join(", ") : "J.R. Dunn",
            tags: product.att.find((attr) => attr[0] === "Tag") ? product.att.find((attr) => attr[0] === "Tag")[1] : [],
            images: product.att.find(
              (attr) => attr[0] === "Product images"
            ) ? product.att.find((attr) => attr[0] === "Product images")[1].map((image) => ({
              src: image,
              alt: product.l
            })) : product.vra ? product.vra.map((variant) => {
              var _a2;
              const imgUrl = ((_a2 = variant[1].find(
                (item) => item[0] === "imgs"
              )) == null ? void 0 : _a2[1]) || "";
              return imgUrl ? {
                src: imgUrl,
                alt: product.l
              } : null;
            }).filter(Boolean) : [],
            description: product.d,
            variants: product.vra ? product.vra.map((variant) => ({
              variantId: variant[0],
              options: variant[1].map(
                (option) => ({
                  name: option[0],
                  value: Array.isArray(option[1]) ? option[1].join(", ") : option[1]
                })
              )
            })) : [],
            availability: product.vra ? product.vra.some(
              (variant) => variant[1].some(
                (option) => option[0] === "Sellable" && option[1][0] === true
              )
            ) : false,
            priceMin: product.p_min * 100,
            priceMax: product.p_max * 100,
            currency: product.c,
            imagesAlt: product.t2,
            featured_image: {
              src: product.t || product.t2 || "/cdn/shop/files/jrdunn-logo-dark.png",
              alt: product.l
            },
            image: product.t2
          }));
          this.products = resetProducts ? products : [...this.products || [], ...products];
          this.totalResults = response.payload.totalResults || (((_b = this.products) == null ? void 0 : _b.length) || 0);
          this.currentPage = response.payload.page;
          this.pageCount = response.payload.pageCount;
          this.isNoResults = false;
          this.isLoading = false;
        }
      });
    } else {
      this.simonAppDownCount++;
      if (this.simonAppDownCount >= this.simonAppDownLimit) {
        this.isSimonAppDown = true;
        this.isLoading = false;
        return;
      }
      this._initializeSDK();
      setTimeout(() => {
        this.search(true);
      }, 100);
    }
  },
  goToSearchPage(path) {
    window.location.href = this.getSearchUrl(path);
  },
  getSearchUrl(path) {
    return this.searchTermInput ? `${path}?q=${encodeURIComponent(this.searchTermInput.trim())}` : path;
  },
  handleMobileSearchPopupHeight() {
    const mainPopup = document.querySelector(".popup__main");
    if (mainPopup) {
      if (!this.searchTerm && this.$store.main.isMobile) {
        mainPopup.classList.add("popup__main--mobile-search-no-result");
      } else {
        mainPopup.classList.remove("popup__main--mobile-search-no-result");
      }
    }
  },
  loadMoreProducts() {
    if (this.currentPage && this.pageCount && this.currentPage >= this.pageCount) {
      return;
    }
    this.search(false, ++this.currentPage);
  },
  _initializeSDK() {
    if (!window.__fast_simon_sdk_config) {
      window.__fast_simon_sdk_config = {
        store_uuid: "0d15ce6e-f5cc-4819-b23d-c7fe2de734e8",
        store_id: 68541939812,
        type: "SPA",
        withAttributes: true,
        onReady: () => {
          this.fastSimonSDK = window.FastSimonSDK;
        }
      };
    }
  }
});
const Accordion = (isExpanded = false, duration = 0, onlyMobile = false, isAccordionGroup = false) => ({
  _buttonRef: null,
  _panelRef: null,
  _iconRef: null,
  isExpanded: Boolean(isExpanded),
  duration: Number(duration),
  init() {
    if (onlyMobile && !Alpine.store("main").isMobile) {
      return;
    }
    this._initElements();
    Alpine.nextTick(() => {
      this._update();
      const watchKey = isAccordionGroup ? "isAccordionGroupOpen" : "isExpanded";
      this.$watch(watchKey, this._update.bind(this));
    });
  },
  _initElements() {
    this._buttonRef = this.$refs.AccordionButton;
    this._panelRef = this.$refs.AccordionPanel;
    this._iconRef = this.$refs.AccordionIcon;
    if (this._buttonRef) {
      this._buttonRef.addEventListener("click", this._toggle.bind(this));
    }
    if (this._panelRef) {
      this._panelRef.style.transitionDuration = `${this.duration}ms`;
    }
    if (this._iconRef) {
      this._iconRef.style.transitionProperty = "rotate";
      this._iconRef.style.transitionDuration = `${this.duration}ms`;
    }
  },
  _toggle() {
    this.isExpanded = !this.isExpanded;
    if (isAccordionGroup) {
      this.isAccordionGroupOpen = this.isExpanded;
    }
  },
  _update() {
    if (isAccordionGroup) {
      this.isExpanded = this.isAccordionGroupOpen;
    }
    if (this._panelRef) {
      this._panelRef.style.opacity = this.isExpanded ? "1" : "0";
      const containerMaxheight = this._panelRef.scrollHeight ? `${String(this._panelRef.scrollHeight)}px` : "10000px";
      this._panelRef.style.maxHeight = this.isExpanded ? containerMaxheight : "0";
    }
    if (this._iconRef) {
      this._iconRef.style.rotate = this.isExpanded ? "-180deg" : "";
    }
  }
});
const Address = () => ({
  renderedPage: "",
  address: {},
  province: null,
  deleteId: null,
  editId: null,
  _onKeyDown(e) {
    if (e.key === ESC_KEY) {
      this.hideForm();
    }
  },
  showForm(page, popup_id) {
    this.focusableEl = document.activeElement;
    document.addEventListener("keydown", this._onKeyDown.bind(this));
    this._updateProvince(this.$refs.address_country);
    if (Alpine.store("main").isMobile) {
      Alpine.store("popup").showPopup(popup_id, true);
      return;
    }
    this.renderedPage = page;
    this._focusOnForm(popup_id);
  },
  _focusOnForm(popup_id) {
    setTimeout(() => {
      var _a;
      const firstEl = (_a = document.querySelector(`#${popup_id}-desktop form`)) == null ? void 0 : _a.querySelector(
        "a, button, textarea, input:not([type=hidden]), select"
      );
      firstEl == null ? void 0 : firstEl.focus();
    }, 150);
  },
  hideForm() {
    document.removeEventListener("keydown", this._onKeyDown);
    this.renderedPage = "";
    this.address = {};
    this.deleteId = null;
    this.editId = null;
    setTimeout(() => {
      var _a;
      (_a = this.focusableEl) == null ? void 0 : _a.focus();
      this.focusableEl = null;
    }, 150);
  },
  updateCountry(e) {
    const country = e.target;
    this.address.country = country.selectedOptions[0].text;
    this._updateProvince(country);
  },
  _updateProvince(country) {
    Alpine.nextTick(() => {
      this.province = JSON.parse(
        (country == null ? void 0 : country.selectedOptions[0].dataset.provinces) || "[]"
      );
    });
  }
});
const POPUP_FILTERS = "filters";
const POPUP_BOTTOM_FILTERS = "bottom-filters";
const FILTER_SORT = "sort_by";
const FILTER_PRICE = "Price";
const FILTER_PRICE_PARAM_NAME = "filter.v.price";
const FILTER_SIZE_PARAM_NAME = "filter.p.m.size";
const FILTER_SIZE_MIN = "filter.p.m.size.gte";
const FILTER_SIZE_MAX = "filter.p.m.size.lte";
const FILTER_DEPTH_PARAM_NAME = "filter.p.m.depth";
const FILTER_DEPTH_MIN = "filter.p.m.depth.gte";
const FILTER_DEPTH_MAX = "filter.p.m.depth.lte";
const FastSimon = () => ({
  // Initialize internal properties
  _isInitializing: false,
  init() {
    const store = Alpine.store("fastSimon");
    store.init();
    this._setupReactiveSystem();
    this._setupURLMonitoring();
    this.$watch(
      () => store.isTopFilterVisible,
      (value) => {
        if (value) {
          this.$store.popup.hidePopup(POPUP_BOTTOM_FILTERS);
        } else {
          this.$store.popup.showPopup(POPUP_BOTTOM_FILTERS, false);
        }
      }
    );
    this.$watch("$store.popup.currentPopup", (value) => {
      if (value === POPUP_BOTTOM_FILTERS && store.isTopFilterVisible) {
        this.$store.popup.hidePopup(POPUP_BOTTOM_FILTERS);
      }
    });
  },
  _setupReactiveSystem() {
    const store = Alpine.store("fastSimon");
    this.$watch(
      () => store.currentSort,
      (newSort, oldSort) => {
        if (!store._isUpdatingFromURL && newSort !== oldSort && !this._isInitializing) {
          this._handleURLChange();
        }
      }
    );
    this.$watch(
      () => store.selectedFilters,
      () => {
        if (!store._isUpdatingFromURL && !this._isInitializing) {
          this._handleURLChange();
        }
      }
    );
  },
  _setupURLMonitoring() {
    const store = Alpine.store("fastSimon");
    store.syncFromURL();
    window.addEventListener("popstate", () => {
      store.syncFromURL();
      this._fetchProducts();
    });
  },
  _handleURLChange() {
    const store = Alpine.store("fastSimon");
    store.updateURL();
    this._fetchProducts();
  },
  async _fetchProducts() {
    const store = Alpine.store("fastSimon");
    if (!store.collectionId) {
      throw new Error("Collection ID not set");
    }
    const currentPage = store.getCurrentPage();
    return store.fetchProducts(store.collectionId, store.productsPerPage, currentPage, false);
  },
  _getCachedUnfilteredCount(collectionID) {
    try {
      const cacheKey = `fastsimon_unfiltered_count_${collectionID}`;
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        const data = JSON.parse(cached);
        const maxAge = 24 * 60 * 60 * 1e3;
        if (Date.now() - data.timestamp < maxAge) {
          return data.count;
        } else {
          localStorage.removeItem(cacheKey);
        }
      }
    } catch (error) {
    }
    return null;
  },
  _setCachedUnfilteredCount(collectionID, count) {
    try {
      const cacheKey = `fastsimon_unfiltered_count_${collectionID}`;
      const data = {
        count,
        timestamp: Date.now()
      };
      localStorage.setItem(cacheKey, JSON.stringify(data));
    } catch (error) {
    }
  },
  _fetchUnfilteredCount(collectionID, store, retryCount = 0) {
    const sdk = store.fastSimonSDK || window.FastSimonSDK;
    if (!sdk) {
      if (retryCount < 10) {
        setTimeout(() => this._fetchUnfilteredCount(collectionID, store, retryCount + 1), 500);
      }
      return;
    }
    let callbackCalled = false;
    const timeoutId = setTimeout(() => {
      var _a;
      if (!callbackCalled) {
        const currentTotal = ((_a = store.fetchedProducts) == null ? void 0 : _a.totalProducts) || 0;
        if (currentTotal > 0) {
          store.setInitialTotalProducts(currentTotal);
        }
      }
    }, 1e4);
    try {
      sdk.smartCollections({
        categoryID: collectionID,
        page: 1,
        productsPerPage: 1,
        // We only need the count, so fetch minimal products
        narrowBy: [],
        // No filters - this ensures we get the true collection size
        sortBy: "relevency",
        facets: false,
        withAttributes: false,
        callback: (response) => {
          callbackCalled = true;
          clearTimeout(timeoutId);
          if (response.action === "facets and products" && response.payload) {
            const unfilteredTotal = response.payload.totalResults || 0;
            store.setInitialTotalProducts(unfilteredTotal);
            this._setCachedUnfilteredCount(collectionID, unfilteredTotal);
          }
        }
      });
    } catch (error) {
      callbackCalled = true;
      clearTimeout(timeoutId);
    }
  },
  _applyRingBuilderAutoFilters() {
    if (this._autoFilterTimeout) {
      clearTimeout(this._autoFilterTimeout);
    }
    const pageType = document.body.dataset.pageType;
    const collectionTemplate = document.body.dataset.collectionTemplate;
    const collectionHandle = document.body.dataset.collectionHandle;
    const isDiamondCollection = pageType === "collection" && (collectionTemplate === "diamond" || collectionHandle === "diamonds" || collectionHandle === "diamond-finder");
    const isRingCollection = pageType === "collection" && (collectionTemplate === "ring" || (collectionHandle == null ? void 0 : collectionHandle.includes("engagement")) || (collectionHandle == null ? void 0 : collectionHandle.includes("ring")));
    if (isDiamondCollection) {
      const autoShapeData = localStorage.getItem("ringBuilderAutoShape");
      if (autoShapeData && !this._autoFilterApplied) {
        try {
          const autoFilterInfo = JSON.parse(autoShapeData);
          const applyDiamondShapeFilter = (attempt = 1) => {
            var _a;
            const store = Alpine.store("fastSimon");
            const isFastSimonReady = store.fastSimonFilters && store.fastSimonFilters.length > 0 && !store.isFetchingFilters && !store.isFetchingProducts;
            if (isFastSimonReady) {
              const shapeFilter = (_a = store.fastSimonFilters) == null ? void 0 : _a.find(
                (f) => {
                  var _a2, _b;
                  return ((_a2 = f.label) == null ? void 0 : _a2.toLowerCase()) === "shape" || ((_b = f.param_name) == null ? void 0 : _b.includes("shape"));
                }
              );
              if (shapeFilter && shapeFilter.values) {
                const isFilterAlreadyApplied = this.isFilterApplied(
                  shapeFilter.param_name
                );
                if (isFilterAlreadyApplied) {
                  this._autoFilterApplied = true;
                  return;
                }
                const shapeValue = shapeFilter.values.find((v) => {
                  var _a2, _b;
                  const valueLabel = ((_a2 = v.label) == null ? void 0 : _a2.toLowerCase()) || "";
                  const filterLabel = autoFilterInfo.ringShapeLabel || ((_b = autoFilterInfo.ringShape) == null ? void 0 : _b.toLowerCase()) || "";
                  return valueLabel === filterLabel || valueLabel.includes(filterLabel) || filterLabel.includes(valueLabel);
                });
                if (shapeValue) {
                  this.applyFilter(shapeValue.param_name, shapeValue.value);
                  this.applyFilter("filter.p.m.size.gte", "1.5");
                  this.applyFilter("filter.p.m.size.lte", "2.5");
                  this._autoFilterApplied = true;
                  setTimeout(() => {
                    this._handleURLChange();
                  }, 200);
                }
              }
            } else {
              if (attempt < 15) {
                this._autoFilterTimeout = setTimeout(
                  () => applyDiamondShapeFilter(attempt + 1),
                  1e3
                );
              }
            }
          };
          applyDiamondShapeFilter();
        } catch (error) {
        }
      }
    } else if (isRingCollection) {
      const autoDiamondShapeData = localStorage.getItem(
        "ringBuilderAutoDiamondShape"
      );
      if (autoDiamondShapeData && !this._autoFilterApplied) {
        try {
          const autoFilterInfo = JSON.parse(autoDiamondShapeData);
          const applyMainstoneShapeFilter = (attempt = 1) => {
            var _a;
            const store = Alpine.store("fastSimon");
            const isFastSimonReady = store.fastSimonFilters && store.fastSimonFilters.length > 0 && !store.isFetchingFilters && !store.isFetchingProducts;
            if (isFastSimonReady) {
              const mainstoneShapeFilter = (_a = store.fastSimonFilters) == null ? void 0 : _a.find(
                (f) => {
                  var _a2, _b, _c;
                  return ((_a2 = f.param_name) == null ? void 0 : _a2.includes("magento.ring_mainstone_shape")) || ((_b = f.param_name) == null ? void 0 : _b.includes("ring_mainstone_shape")) || ((_c = f.label) == null ? void 0 : _c.toLowerCase().includes("mainstone"));
                }
              );
              if (mainstoneShapeFilter && mainstoneShapeFilter.values) {
                const isFilterAlreadyApplied = this.isFilterApplied(
                  mainstoneShapeFilter.param_name
                );
                if (isFilterAlreadyApplied) {
                  this._autoFilterApplied = true;
                  return;
                }
                const shapeValue = mainstoneShapeFilter.values.find(
                  (v) => {
                    var _a2, _b;
                    const valueLabel = ((_a2 = v.label) == null ? void 0 : _a2.toLowerCase()) || "";
                    const filterLabel = autoFilterInfo.diamondShapeLabel || ((_b = autoFilterInfo.diamondShape) == null ? void 0 : _b.toLowerCase()) || "";
                    return valueLabel === filterLabel || valueLabel.includes(filterLabel) || filterLabel.includes(valueLabel);
                  }
                );
                if (shapeValue) {
                  this.applyFilter(shapeValue.param_name, shapeValue.value);
                  this._autoFilterApplied = true;
                  setTimeout(() => {
                    this._handleURLChange();
                  }, 200);
                }
              }
            } else {
              if (attempt < 15) {
                this._autoFilterTimeout = setTimeout(
                  () => applyMainstoneShapeFilter(attempt + 1),
                  1e3
                );
              }
            }
          };
          applyMainstoneShapeFilter();
        } catch (error) {
        }
      }
    }
  },
  initializeCollection(collectionID, sortTranslations, currency, productsPerPage = 20) {
    this._isInitializing = true;
    this._autoFilterApplied = false;
    if (this._autoFilterTimeout) {
      clearTimeout(this._autoFilterTimeout);
      this._autoFilterTimeout = null;
    }
    const store = Alpine.store("fastSimon");
    if (store.collectionId !== collectionID) {
      store.initialTotalProducts = null;
    }
    store.fastSimonSortOptions = sortTranslations;
    store.collectionId = collectionID;
    store.setCurrency(currency);
    store.syncFromURL();
    store.setProductsPerPage(productsPerPage);
    const sdk = store.fastSimonSDK || window.FastSimonSDK;
    if (!sdk) {
      setTimeout(
        () => this.initializeCollection(
          collectionID,
          sortTranslations,
          currency,
          productsPerPage
        ),
        600
      );
      return;
    }
    const narrowBy = FastSimonUtils.filtersToNarrowBy(
      store.getFilterParams()
    );
    const sortBy = store.currentSort || "relevency";
    const currentPage = store.getCurrentPage();
    store.isFetchingProducts = true;
    store.isFetchingFilters = true;
    try {
      sdk.smartCollections({
        categoryID: collectionID,
        page: currentPage,
        productsPerPage: productsPerPage || 20,
        narrowBy,
        sortBy,
        facets: true,
        withAttributes: true,
        callback: async (response) => {
          var _a;
          if (response.action === "facets and products") {
            try {
              const fastSimonProducts = response.payload.totalResults && response.payload.products ? response.payload.products : [];
              const fastSimonFacets = response.payload.facets || [];
              const productsPerPage2 = 20;
              const isInitialLoad = !store.fetchedProducts || store.loadedProductsCount === 0;
              const resolveMetaobjects = isInitialLoad;
              const { products: shopifyProducts, filters: shopifyFilters } = await FastSimonUtils.convertFastSimonResponse(
                fastSimonProducts,
                fastSimonFacets,
                resolveMetaobjects
              );
              store.fastSimonFilters = shopifyFilters;
              const result = {
                products: shopifyProducts,
                totalPages: response.payload.pageCount || 1,
                totalProducts: response.payload.totalResults || 0,
                currentPage: response.payload.page || 1
              };
              store.fetchedProducts = result;
              if (store.initialTotalProducts === null) {
                const cachedCount = this._getCachedUnfilteredCount(collectionID);
                if (cachedCount !== null) {
                  store.setInitialTotalProducts(cachedCount);
                } else if (Object.keys(store.selectedFilters).length === 0) {
                  const totalCount = response.payload.totalResults || 0;
                  store.setInitialTotalProducts(totalCount);
                  this._setCachedUnfilteredCount(collectionID, totalCount);
                } else {
                  this._fetchUnfilteredCount(collectionID, store);
                }
              }
              if (result.totalPages > 1) {
                const head = document.head;
                const currentPage2 = result.currentPage;
                const oldLinks = head.querySelectorAll('link[rel="prev"], link[rel="next"]');
                oldLinks.forEach((link) => link.remove());
                if (currentPage2 > 1) {
                  const prevLink = document.createElement("link");
                  prevLink.rel = "prev";
                  prevLink.href = `${window.location.origin}${window.location.pathname}${currentPage2 > 2 ? `?page=${currentPage2 - 1}` : ""}`;
                  head.appendChild(prevLink);
                }
                if (currentPage2 < result.totalPages) {
                  const nextParams = new URLSearchParams();
                  nextParams.set("page", (currentPage2 + 1).toString());
                  const nextLink = document.createElement("link");
                  nextLink.rel = "next";
                  nextLink.href = `${window.location.origin}${window.location.pathname}?${nextParams.toString()}`;
                  head.appendChild(nextLink);
                }
              }
              const searchParams = new URLSearchParams(window.location.search);
              if (!searchParams.get("page")) {
                searchParams.delete("page");
                if (result.totalProducts > productsPerPage2 && result.currentPage !== 1) {
                  searchParams.set("page", result.currentPage.toString());
                }
              }
              const newUrl = `${window.location.origin}${window.location.pathname}${((_a = searchParams == null ? void 0 : searchParams.toString()) == null ? void 0 : _a.length) ? `?${searchParams.toString()}` : ""}`;
              if (newUrl !== window.location.href) {
                const scrollPosition = window.scrollY;
                history.replaceState({ ...history.state, scrollPosition }, document.title, newUrl);
              }
              this.currentUrl = newUrl;
              this.urlParams = searchParams;
              store.loadedProductsCount = result.products.length;
              store.isFetchingProducts = false;
              this._isInitializing = false;
              store.isFetchingFilters = false;
              setTimeout(() => this._applyRingBuilderAutoFilters(), 100);
            } catch (error) {
              store.fastSimonFilters = [];
              store.isFetchingFilters = false;
              store.isFetchingProducts = false;
              this._isInitializing = false;
            }
          }
        }
      });
    } catch (error) {
      const emptyResult = {
        products: [],
        totalPages: 1,
        totalProducts: 0,
        currentPage: 1
      };
      store.fetchedProducts = emptyResult;
      store.loadedProductsCount = 0;
      store.isFetchingProducts = false;
      store.isFetchingFilters = false;
      store.fastSimonFilters = [];
      this._isInitializing = false;
    }
  },
  // Public API - delegates to store
  applyFilter(filterName, filterValue) {
    const store = Alpine.store("fastSimon");
    if (store.isFilterApplied(filterName, filterValue)) {
      store.removeFilter(filterName, filterValue);
    } else {
      store.addFilter(filterName, filterValue);
    }
  },
  applySort(sortValue) {
    const store = Alpine.store("fastSimon");
    store.currentSort = sortValue;
  },
  removeSort() {
    Alpine.store("fastSimon").setSort(null);
  },
  removeFilterByName(filterName, mode = "single") {
    var _a, _b;
    const store = Alpine.store("fastSimon");
    if (filterName === FILTER_PRICE_PARAM_NAME || filterName === FILTER_SIZE_PARAM_NAME || filterName === FILTER_DEPTH_PARAM_NAME) {
      if (filterName === FILTER_PRICE_PARAM_NAME) {
        const priceFilter = store.getPriceFilter();
        if (priceFilter) {
          if ((_a = priceFilter.min_value) == null ? void 0 : _a.param_name) {
            store.removeFilter(priceFilter.min_value.param_name, void 0, mode === "clear");
          }
          if ((_b = priceFilter.max_value) == null ? void 0 : _b.param_name) {
            store.removeFilter(priceFilter.max_value.param_name, void 0, mode === "clear");
          }
          document.dispatchEvent(
            new CustomEvent("reset-filters", {
              detail: { name: FILTER_PRICE }
            })
          );
        }
      } else if (filterName === FILTER_SIZE_PARAM_NAME) {
        store.removeFilter(FILTER_SIZE_MIN, void 0, mode === "clear");
        store.removeFilter(FILTER_SIZE_MAX, void 0, mode === "clear");
        store.saveFilterNamespace("filter.p.m.size", "");
        document.dispatchEvent(
          new CustomEvent("reset-filters", {
            detail: { name: "Size" }
          })
        );
      } else if (filterName === FILTER_DEPTH_PARAM_NAME) {
        store.removeFilter(FILTER_DEPTH_MIN, void 0, mode === "clear");
        store.removeFilter(FILTER_DEPTH_MAX, void 0, mode === "clear");
        store.saveFilterNamespace("filter.p.m.depth", "");
        document.dispatchEvent(
          new CustomEvent("reset-filters", {
            detail: { name: "Depth" }
          })
        );
      }
    } else {
      store.removeFilter(filterName, void 0, mode === "clear");
      if (filterName.startsWith("filter.p.m.")) {
        store.saveFilterNamespace(filterName, "");
      }
    }
  },
  removeFilterValue(filterName, filterValue, mode = "single") {
    Alpine.store("fastSimon").removeFilter(filterName, filterValue, mode === "clear");
  },
  resetAllFiltersAndSort() {
    const store = Alpine.store("fastSimon");
    store.resetState();
    store.clearFilterNamespaces();
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete("page");
    const newUrl = window.location.pathname;
    if (newUrl !== window.location.href) {
      history.replaceState(null, document.title, newUrl);
    }
    store.currentUrl = newUrl;
    store.urlParams = searchParams;
    document.dispatchEvent(
      new CustomEvent("reset-filters", {
        detail: { name: null }
      })
    );
    store.pendingFilters = {};
    setTimeout(() => {
      this._fetchProducts();
    }, 100);
  },
  // Query Methods - delegates to store
  isFilterApplied(filterName, filterValue) {
    return Alpine.store("fastSimon").isFilterApplied(filterName, filterValue);
  },
  isSortApplied(sortValue) {
    return Alpine.store("fastSimon").currentSort === sortValue;
  },
  getAppliedFilters() {
    return Alpine.store("fastSimon").getAppliedFilters();
  },
  getCurrentSort() {
    const store = Alpine.store("fastSimon");
    const sortOption = store.fastSimonSortOptions.find(
      (option) => option.value === store.currentSort
    );
    return sortOption ? sortOption.label : store.currentSort;
  },
  getFilterValues(filterName) {
    return Alpine.store("fastSimon").selectedFilters[filterName] || [];
  },
  getPriceFilter() {
    return Alpine.store("fastSimon").getPriceFilter();
  },
  getFormattedMinPrice() {
    return Alpine.store("fastSimon").getFormattedMinPrice();
  },
  getFormattedMaxPrice() {
    return Alpine.store("fastSimon").getFormattedMaxPrice();
  },
  getIsFilterSelected(param_name) {
    const store = Alpine.store("fastSimon");
    if (param_name === FILTER_SORT) {
      return store.currentSort !== "relevency";
    } else if (param_name === FILTER_PRICE_PARAM_NAME) {
      const priceFilter = store.getPriceFilter();
      if (!priceFilter) return false;
      const priceState = store.getPriceFilterState();
      return Boolean(priceState.min) || Boolean(priceState.max);
    } else {
      const values = store.selectedFilters[param_name] || [];
      return values.length > 0;
    }
  },
  // UI Methods
  showFilters(isTopLevel = true, currentName = "") {
    const store = Alpine.store("fastSimon");
    store.isTopLevel = isTopLevel;
    store.currentName = currentName;
    this.$store.popup.showPopup(POPUP_FILTERS, true);
  },
  hideFilters() {
    this.$store.popup.hidePopup(POPUP_FILTERS);
    this.$store.popup.hidePopup(POPUP_BOTTOM_FILTERS);
    const store = Alpine.store("fastSimon");
    store.isTopLevel = false;
    store.currentName = "";
    store.showTabletPopup = false;
  },
  showTabletFilters() {
    const store = Alpine.store("fastSimon");
    store.showTabletPopup = true;
  },
  hideTabletFilters() {
    const store = Alpine.store("fastSimon");
    store.showTabletPopup = false;
  }
});
const FIRST_BREAKPOINT = 3e3;
const SECOND_BREAKPOINT = 15e3;
const THIRD_BREAKPOINT = 5e4;
const FIRST_PERCENTAGE = 0.25;
const SECOND_PERCENTAGE = 0.5;
const THIRD_PERCENTAGE = 0.75;
function calculateSegmentPercentage(value, segmentStart, segmentEnd, minPercentage, maxPercentage) {
  const segmentRange = segmentEnd - segmentStart;
  const segmentPercentageRange = maxPercentage - minPercentage;
  const segmentValue = value - segmentStart;
  return minPercentage + segmentValue / segmentRange * segmentPercentageRange;
}
function calculateDynamicBreakpoints(maxPrice) {
  if (maxPrice < THIRD_BREAKPOINT) {
    const scaleFactor = maxPrice / THIRD_BREAKPOINT;
    return {
      first: Math.min(FIRST_BREAKPOINT * scaleFactor, maxPrice * 0.25),
      second: Math.min(SECOND_BREAKPOINT * scaleFactor, maxPrice * 0.5),
      third: Math.min(THIRD_BREAKPOINT * scaleFactor, maxPrice * 0.75)
    };
  }
  return {
    first: FIRST_BREAKPOINT,
    second: SECOND_BREAKPOINT,
    third: THIRD_BREAKPOINT
  };
}
const ANIMATION_DURATION = 300;
const RangeSlider = (min, max, minValue, maxValue, label) => ({
  isLeftThumbActive: false,
  isRightThumbActive: false,
  isResetting: false,
  isDragging: false,
  dragTarget: null,
  min: Number(min),
  max: Number(max),
  minValue: Number(minValue),
  maxValue: Number(maxValue),
  label,
  currentRangeLabel: "",
  showRangeLabel: false,
  // Helper method to clamp values within valid range
  clampValue(value) {
    const clampedValue = Math.max(this.min, Math.min(this.max, value));
    if (this.label !== "Price") {
      return Math.round(clampedValue * 10) / 10;
    }
    return Math.round(clampedValue);
  },
  // Get minimum gap based on current value range for better UX
  getMinGapForRange(value) {
    if (this.label !== "Price") {
      return 0.1;
    }
    if (!this.isNonLinearScale()) {
      return 1;
    }
    if (value <= FIRST_BREAKPOINT) {
      return 25;
    } else if (value <= SECOND_BREAKPOINT) {
      return 100;
    } else if (value <= THIRD_BREAKPOINT) {
      return 500;
    } else {
      return 1e3;
    }
  },
  // Helper method to validate and clamp both input values
  validateAndClampInputs() {
    this.minValue = this.clampValue(this.minValue);
    this.maxValue = this.clampValue(this.maxValue);
    if (this.minValue >= this.maxValue) {
      const avgValue = (this.minValue + this.maxValue) / 2;
      const minGap = this.getMinGapForRange(avgValue);
      this.minValue = Math.max(this.min, this.maxValue - minGap);
      if (this.label !== "Price") {
        this.minValue = Math.round(this.minValue * 10) / 10;
      }
    }
  },
  // Check if this slider should use non-linear scale
  isNonLinearScale() {
    return this.label === "Price" && this.min === 0 && this.max >= FIRST_BREAKPOINT * 2;
  },
  // Get dynamic step size based on current value for better UX
  getDynamicStepSize(value) {
    if (this.label !== "Price") {
      return 0.1;
    }
    if (!this.isNonLinearScale()) {
      const range = this.max - this.min;
      return Math.max(25, Math.floor(range / 100));
    }
    const breakpoints = calculateDynamicBreakpoints(this.max);
    const currentValue = value || (this.minValue + this.maxValue) / 2;
    if (currentValue <= breakpoints.first) {
      return Math.max(25, Math.floor(breakpoints.first / 40));
    } else if (currentValue <= breakpoints.second) {
      return Math.max(50, Math.floor((breakpoints.second - breakpoints.first) / 30));
    } else if (currentValue <= breakpoints.third) {
      return Math.max(100, Math.floor((breakpoints.third - breakpoints.second) / 20));
    } else {
      return Math.max(250, Math.floor((this.max - breakpoints.third) / 10));
    }
  },
  // Convert value to percentage position (0-1) with non-linear scale for price
  valueToPercentage(value) {
    if (!this.isNonLinearScale()) {
      return (value - this.min) / (this.max - this.min);
    }
    const breakpoints = calculateDynamicBreakpoints(this.max);
    const clampedValue = Math.max(this.min, Math.min(this.max, value));
    if (clampedValue <= breakpoints.first) {
      return clampedValue / breakpoints.first * FIRST_PERCENTAGE;
    } else if (clampedValue <= breakpoints.second) {
      return calculateSegmentPercentage(clampedValue, breakpoints.first, breakpoints.second, FIRST_PERCENTAGE, SECOND_PERCENTAGE);
    } else if (clampedValue <= breakpoints.third) {
      return calculateSegmentPercentage(clampedValue, breakpoints.second, breakpoints.third, SECOND_PERCENTAGE, THIRD_PERCENTAGE);
    } else {
      return calculateSegmentPercentage(clampedValue, breakpoints.third, this.max, THIRD_PERCENTAGE, 1);
    }
  },
  // Convert percentage position (0-1) to value with non-linear scale for price
  percentageToValue(percentage) {
    if (!this.isNonLinearScale()) {
      return this.min + percentage * (this.max - this.min);
    }
    const breakpoints = calculateDynamicBreakpoints(this.max);
    const clampedPercentage = Math.max(0, Math.min(1, percentage));
    if (clampedPercentage <= FIRST_PERCENTAGE) {
      return clampedPercentage / FIRST_PERCENTAGE * breakpoints.first;
    } else if (clampedPercentage <= SECOND_PERCENTAGE) {
      return calculateSegmentPercentage(clampedPercentage, FIRST_PERCENTAGE, SECOND_PERCENTAGE, breakpoints.first, breakpoints.second);
    } else if (clampedPercentage <= THIRD_PERCENTAGE) {
      return calculateSegmentPercentage(clampedPercentage, SECOND_PERCENTAGE, THIRD_PERCENTAGE, breakpoints.second, breakpoints.third);
    } else {
      return calculateSegmentPercentage(clampedPercentage, THIRD_PERCENTAGE, 1, breakpoints.third, this.max);
    }
  },
  // Get appropriate step size for keyboard navigation
  getKeyboardStepSize() {
    return this.getDynamicStepSize();
  },
  // Get current price segment label for visual feedback
  getCurrentPriceSegment(value) {
    if (this.label !== "Price") return "";
    const breakpoints = calculateDynamicBreakpoints(this.max);
    if (value <= breakpoints.first) {
      return `$0 - $${this.formatValue(breakpoints.first)}`;
    } else if (value <= breakpoints.second) {
      return `$${this.formatValue(breakpoints.first)} - $${this.formatValue(breakpoints.second)}`;
    } else if (value <= breakpoints.third) {
      return `$${this.formatValue(breakpoints.second)} - $${this.formatValue(breakpoints.third)}`;
    } else {
      return `$${this.formatValue(breakpoints.third)}+`;
    }
  },
  // Update segment label for visual feedback during interaction
  updateSegmentLabel(value) {
    if (this.label === "Price") {
      this.currentRangeLabel = this.getCurrentPriceSegment(value);
      this.showRangeLabel = true;
      clearTimeout(this.__labelTimeout);
      this.__labelTimeout = setTimeout(() => {
        this.showRangeLabel = false;
      }, 2e3);
    }
  },
  // Get thumb sensitivity factor to improve UX when thumbs are close together
  getThumbSensitivityFactor() {
    if (this.label !== "Price") return 1;
    const range = this.maxValue - this.minValue;
    const totalRange = this.max - this.min;
    const rangePercentage = range / totalRange;
    if (rangePercentage < 0.05) {
      return 1.5;
    } else if (rangePercentage < 0.1) {
      return 1.25;
    }
    return 1;
  },
  // Parse input value, handling space-separated format (e.g., "461 167" -> 461167)
  parseInputValue(inputValue) {
    if (!inputValue || typeof inputValue !== "string") {
      return NaN;
    }
    const cleanValue = inputValue.replace(/\s/g, "");
    const parsed = parseFloat(cleanValue);
    return parsed;
  },
  // Format number with space as thousand separator
  formatValue(value) {
    if (this.label === "Price") {
      return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    } else {
      const formatted = (Math.round(value * 10) / 10).toString();
      return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
  },
  getSymbol() {
    var _a, _b, _c, _d, _e;
    switch (this.label.toLowerCase()) {
      case "price":
        return ((_e = (_d = (_c = (_b = (_a = this.$store) == null ? void 0 : _a.fastSimon) == null ? void 0 : _b.fetchedProducts) == null ? void 0 : _c.products) == null ? void 0 : _d[0]) == null ? void 0 : _e.currency_symbol) || "$";
      case "depth":
      case "table":
        return "%";
      case "carat":
        return "ct";
      default:
        return "";
    }
  },
  init() {
    this.validateAndClampInputs();
    const boundMouseMove = (e) => this.onThumbMouseMove(e);
    const boundMouseUp = () => this.onThumbMouseUp();
    const boundTouchMove = (e) => this.onThumbTouchMove(e);
    const boundTouchEnd = () => this.onThumbTouchEnd();
    const boundTouchCancel = () => this.onThumbTouchCancel();
    document.addEventListener("mousemove", boundMouseMove);
    document.addEventListener("mouseup", boundMouseUp);
    document.addEventListener("touchmove", boundTouchMove, { passive: false });
    document.addEventListener("touchend", boundTouchEnd);
    document.addEventListener("touchcancel", boundTouchCancel);
    this.__boundMouseMove = boundMouseMove;
    this.__boundMouseUp = boundMouseUp;
    this.__boundTouchMove = boundTouchMove;
    this.__boundTouchEnd = boundTouchEnd;
    this.__boundTouchCancel = boundTouchCancel;
    this.__cleanup = () => {
      document.removeEventListener("mousemove", boundMouseMove);
      document.removeEventListener("mouseup", boundMouseUp);
      document.removeEventListener("touchmove", boundTouchMove);
      document.removeEventListener("touchend", boundTouchEnd);
      document.removeEventListener("touchcancel", boundTouchCancel);
      clearTimeout(this.__labelTimeout);
    };
    this.$nextTick(() => {
      var _a, _b, _c, _d, _e, _f;
      const store = (_a = this.$store) == null ? void 0 : _a.fastSimon;
      if (store && store.fastSimonFilters) {
        const priceFilter = (_b = store.fastSimonFilters) == null ? void 0 : _b.find((f) => f.label === this.label);
        if (priceFilter) {
          if (priceFilter.range_max && priceFilter.range_max > this.max) {
            this.max = priceFilter.range_max;
            this.maxValue = this.maxValue > priceFilter.range_max ? priceFilter.range_max : this.maxValue;
          }
          const minParam = (_c = priceFilter.min_value) == null ? void 0 : _c.param_name;
          const maxParam = (_d = priceFilter.max_value) == null ? void 0 : _d.param_name;
          if (minParam && ((_e = store.selectedFilters[minParam]) == null ? void 0 : _e.length) > 0) {
            this.minValue = parseFloat(store.selectedFilters[minParam][0]) || this.min;
          }
          if (maxParam && ((_f = store.selectedFilters[maxParam]) == null ? void 0 : _f.length) > 0) {
            this.maxValue = parseFloat(store.selectedFilters[maxParam][0]) || this.max;
          }
          this.validateAndClampInputs();
          this.$watch("$store.fastSimon.selectedFilters", () => {
            var _a2, _b2, _c2, _d2, _e2, _f2;
            const currentStore = (_a2 = this.$store) == null ? void 0 : _a2.fastSimon;
            if (!currentStore) return;
            const currentPriceFilter = (_b2 = currentStore.fastSimonFilters) == null ? void 0 : _b2.find((f) => f.label === this.label);
            if (!currentPriceFilter) return;
            const currentMinParam = (_c2 = currentPriceFilter.min_value) == null ? void 0 : _c2.param_name;
            const currentMaxParam = (_d2 = currentPriceFilter.max_value) == null ? void 0 : _d2.param_name;
            const hasMinFilter = currentMinParam && ((_e2 = currentStore.selectedFilters[currentMinParam]) == null ? void 0 : _e2.length) > 0;
            const hasMaxFilter = currentMaxParam && ((_f2 = currentStore.selectedFilters[currentMaxParam]) == null ? void 0 : _f2.length) > 0;
            if (!hasMinFilter && !hasMaxFilter) {
              this.minValue = this.min;
              this.maxValue = this.max;
            } else {
              if (hasMinFilter) {
                this.minValue = parseFloat(currentStore.selectedFilters[currentMinParam][0]) || this.min;
              } else {
                this.minValue = this.min;
              }
              if (hasMaxFilter) {
                this.maxValue = parseFloat(currentStore.selectedFilters[currentMaxParam][0]) || this.max;
              } else {
                this.maxValue = this.max;
              }
            }
            this.validateAndClampInputs();
          });
        }
      }
    });
  },
  onMinValueInput(event) {
    if (this.isDragging) return;
    const inputElement = event == null ? void 0 : event.target;
    let inputValue = (inputElement == null ? void 0 : inputElement.value) || String(this.minValue);
    let parsedValue = this.parseInputValue(inputValue);
    if (isNaN(parsedValue)) {
      parsedValue = this.minValue;
    }
    this.minValue = parsedValue;
    this.isLeftThumbActive = true;
    if (this.label === "Price") {
      const stepSize = this.getDynamicStepSize(this.minValue);
      this.minValue = Math.round(this.minValue / stepSize) * stepSize;
    } else {
      this.minValue = Math.round(this.minValue * 10) / 10;
    }
    if (this.label === "Price") {
      this.updateSegmentLabel(this.minValue);
    }
    this.validateAndClampInputs();
    if (inputElement) {
      inputElement.value = this.formatValue(this.minValue);
    }
    this.onValueChange();
  },
  onMaxValueInput(event) {
    if (this.isDragging) return;
    const inputElement = event == null ? void 0 : event.target;
    let inputValue = (inputElement == null ? void 0 : inputElement.value) || String(this.maxValue);
    let parsedValue = this.parseInputValue(inputValue);
    if (isNaN(parsedValue)) {
      parsedValue = this.maxValue;
    }
    this.maxValue = parsedValue;
    this.isRightThumbActive = true;
    if (this.label === "Price") {
      const stepSize = this.getDynamicStepSize(this.maxValue);
      this.maxValue = Math.round(this.maxValue / stepSize) * stepSize;
    } else {
      this.maxValue = Math.round(this.maxValue * 10) / 10;
    }
    if (this.label === "Price") {
      this.updateSegmentLabel(this.maxValue);
    }
    this.validateAndClampInputs();
    if (inputElement) {
      inputElement.value = this.formatValue(this.maxValue);
    }
    this.onValueChange();
  },
  // Handle text input field changes (for the visible input fields)
  onMinTextInput(event) {
    if (this.isDragging) return;
    const inputElement = event.target;
    if (!inputElement) return;
    const originalValue = this.minValue;
    let parsedValue = this.parseInputValue(inputElement.value);
    if (isNaN(parsedValue)) {
      parsedValue = this.minValue;
    }
    this.minValue = parsedValue;
    if (this.label !== "Price") {
      this.minValue = Math.round(this.minValue * 10) / 10;
    }
    if (this.label === "Price") {
      this.updateSegmentLabel(this.minValue);
    }
    this.validateAndClampInputs();
    if (this.minValue !== originalValue) {
      this.isLeftThumbActive = true;
      this.onValueChange();
    }
  },
  onMaxTextInput(event) {
    if (this.isDragging) return;
    const inputElement = event.target;
    if (!inputElement) return;
    const originalValue = this.maxValue;
    let parsedValue = this.parseInputValue(inputElement.value);
    if (isNaN(parsedValue)) {
      parsedValue = this.maxValue;
    }
    this.maxValue = parsedValue;
    if (this.label !== "Price") {
      this.maxValue = Math.round(this.maxValue * 10) / 10;
    }
    if (this.label === "Price") {
      this.updateSegmentLabel(this.maxValue);
    }
    this.validateAndClampInputs();
    if (this.maxValue !== originalValue) {
      this.isRightThumbActive = true;
      this.onValueChange();
    }
  },
  onThumbMouseDown(target, event) {
    event == null ? void 0 : event.preventDefault();
    event == null ? void 0 : event.stopPropagation();
    this.isDragging = true;
    this.dragTarget = target;
    if (target === "min") {
      this.isLeftThumbActive = true;
    } else {
      this.isRightThumbActive = true;
    }
  },
  onThumbMouseUp() {
    if (this.isDragging) {
      this.validateAndClampInputs();
      this.isDragging = false;
      this.dragTarget = null;
      setTimeout(() => {
        this.showRangeLabel = false;
      }, 1500);
      setTimeout(() => {
        this.onValueChange();
        this.isLeftThumbActive = false;
        this.isRightThumbActive = false;
      }, 50);
    }
  },
  onThumbMouseMove(event) {
    var _a;
    if (!this.isDragging || !this.dragTarget) {
      return;
    }
    event.preventDefault();
    const trackContainer = this.$el.querySelector('[class*="cursor-pointer"]') || ((_a = this.$el.querySelector(".range-slider-track")) == null ? void 0 : _a.parentElement);
    if (!trackContainer) {
      return;
    }
    const trackRect = trackContainer.getBoundingClientRect();
    const relativeX = event.clientX - trackRect.left;
    const percentage = Math.max(0, Math.min(1, relativeX / trackRect.width));
    let newValue = this.percentageToValue(percentage);
    const stepSize = this.getDynamicStepSize(newValue);
    if (this.label === "Price") {
      newValue = Math.round(newValue / stepSize) * stepSize;
    } else {
      newValue = Math.round(newValue * 10) / 10;
    }
    if (this.dragTarget === "min") {
      newValue = Math.min(newValue, this.maxValue - this.getMinGapForRange(newValue));
    } else {
      newValue = Math.max(newValue, this.minValue + this.getMinGapForRange(this.minValue));
    }
    newValue = Math.max(this.min, Math.min(this.max, newValue));
    if (this.label === "Price") {
      this.updateSegmentLabel(newValue);
    }
    if (this.dragTarget === "min") {
      this.minValue = newValue;
    } else {
      this.maxValue = newValue;
    }
  },
  onThumbTouchStart(target, event) {
    if (!(event == null ? void 0 : event.touches[0])) return;
    event.preventDefault();
    event.stopPropagation();
    const touch = event.touches[0];
    this.__initialTouchX = touch.clientX;
    this.__initialValue = target === "min" ? this.minValue : this.maxValue;
    const thumb = event.target;
    const sliderContainer = thumb.closest(".range-slider");
    if (!sliderContainer) {
      console.warn("Slider container not found");
      return;
    }
    this.__trackRect = sliderContainer.getBoundingClientRect();
    this.__containerLeft = this.__trackRect.left;
    this.__containerWidth = this.__trackRect.width;
    this.isDragging = true;
    this.dragTarget = target;
    if (target === "min") {
      this.isLeftThumbActive = true;
    } else {
      this.isRightThumbActive = true;
    }
  },
  onThumbTouchMove(event) {
    if (!this.isDragging || !this.dragTarget || !event.touches[0]) return;
    event.preventDefault();
    event.stopPropagation();
    const touch = event.touches[0];
    const relativeX = touch.clientX - this.__containerLeft;
    const percentage = Math.max(0, Math.min(1, relativeX / this.__containerWidth));
    let newValue = this.percentageToValue(percentage);
    const stepSize = this.getDynamicStepSize(newValue);
    if (this.label === "Price") {
      newValue = Math.round(newValue / stepSize) * stepSize;
    } else {
      newValue = Math.round(newValue * 10) / 10;
    }
    newValue = Math.max(this.min, Math.min(this.max, newValue));
    if (this.label === "Price") {
      this.updateSegmentLabel(newValue);
    }
    if (this.dragTarget === "min") {
      newValue = Math.min(newValue, this.maxValue);
      this.minValue = newValue;
    } else {
      newValue = Math.max(newValue, this.minValue);
      this.maxValue = newValue;
    }
  },
  onThumbTouchEnd() {
    if (!this.isDragging) return;
    delete this.__initialTouchX;
    delete this.__initialValue;
    delete this.__trackRect;
    delete this.__containerLeft;
    delete this.__containerWidth;
    this.isDragging = false;
    this.dragTarget = null;
    setTimeout(() => {
      this.showRangeLabel = false;
    }, 1500);
    this.validateAndClampInputs();
    setTimeout(() => {
      this.onValueChange();
      this.isLeftThumbActive = false;
      this.isRightThumbActive = false;
    }, 50);
  },
  // Handle touch cancel events (e.g., when touch is interrupted)
  onThumbTouchCancel() {
    if (this.isDragging) {
      this.validateAndClampInputs();
      this.isDragging = false;
      this.dragTarget = null;
      this.isLeftThumbActive = false;
      this.isRightThumbActive = false;
    }
  },
  onValueChange() {
    this.validateAndClampInputs();
    const wasLeftActive = this.isLeftThumbActive;
    const wasRightActive = this.isRightThumbActive;
    const { min_input_name, max_input_name } = this.getFilterLabel();
    const minInputEl = document.querySelector(`input[name="${min_input_name}"]`);
    const maxInputEl = document.querySelector(`input[name="${max_input_name}"]`);
    const minParamName = (minInputEl == null ? void 0 : minInputEl.getAttribute("name")) || min_input_name;
    const maxParamName = (maxInputEl == null ? void 0 : maxInputEl.getAttribute("name")) || max_input_name;
    if (minInputEl) {
      minInputEl.value = this.formatValue(this.minValue);
    }
    if (maxInputEl) {
      maxInputEl.value = this.formatValue(this.maxValue);
    }
    let shouldUpdate = false;
    if (wasLeftActive) {
      shouldUpdate = true;
    }
    if (wasRightActive) {
      shouldUpdate = true;
    }
    if (!wasLeftActive && !wasRightActive) {
      if (this.minValue !== this.min || this.maxValue !== this.max) {
        shouldUpdate = true;
      }
    }
    if (shouldUpdate) {
      this.updatePriceFilter(minParamName, maxParamName);
    }
    this.isLeftThumbActive = false;
    this.isRightThumbActive = false;
  },
  updatePriceFilter(minParamName, maxParamName) {
    var _a;
    const store = (_a = this.$store) == null ? void 0 : _a.fastSimon;
    if (!store) return;
    store.removeFilter(minParamName);
    store.removeFilter(maxParamName);
    if (this.minValue > this.min) {
      store.addFilter(minParamName, String(this.minValue));
    }
    if (this.maxValue < this.max) {
      store.addFilter(maxParamName, String(this.maxValue));
    }
  },
  onTrackClick(event) {
    if (this.isDragging) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    const trackPosition = event.target.getBoundingClientRect();
    const clickPosition = event.clientX - trackPosition.left;
    const percentage = Math.max(0, Math.min(1, clickPosition / trackPosition.width));
    let clickedValue = this.percentageToValue(percentage);
    const stepSize = this.getDynamicStepSize(clickedValue);
    if (this.label === "Price") {
      clickedValue = Math.round(clickedValue / stepSize) * stepSize;
    } else {
      clickedValue = Math.round(clickedValue * 10) / 10;
    }
    if (this.label === "Price") {
      this.updateSegmentLabel(clickedValue);
    }
    const distanceToMin = Math.abs(clickedValue - this.minValue);
    const distanceToMax = Math.abs(clickedValue - this.maxValue);
    this.isResetting = true;
    if (distanceToMin < distanceToMax) {
      this.isLeftThumbActive = true;
      this.minValue = this.clampValue(clickedValue);
    } else {
      this.isRightThumbActive = true;
      this.maxValue = this.clampValue(clickedValue);
    }
    this.validateAndClampInputs();
    setTimeout(() => {
      this.isResetting = false;
      this.onValueChange();
    }, ANIMATION_DURATION);
  },
  onTrackTouch(event) {
    if (this.isDragging) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    const trackPosition = event.target.getBoundingClientRect();
    const touchPosition = event.touches[0].clientX - trackPosition.left;
    const percentage = Math.max(0, Math.min(1, touchPosition / trackPosition.width));
    let touchedValue = this.percentageToValue(percentage);
    const stepSize = this.getDynamicStepSize(touchedValue);
    if (this.label === "Price") {
      touchedValue = Math.round(touchedValue / stepSize) * stepSize;
    } else {
      touchedValue = Math.round(touchedValue * 10) / 10;
    }
    if (this.label === "Price") {
      this.updateSegmentLabel(touchedValue);
    }
    const distanceToMin = Math.abs(touchedValue - this.minValue);
    const distanceToMax = Math.abs(touchedValue - this.maxValue);
    this.isResetting = true;
    if (distanceToMin < distanceToMax) {
      this.isLeftThumbActive = true;
      this.minValue = this.clampValue(touchedValue);
    } else {
      this.isRightThumbActive = true;
      this.maxValue = this.clampValue(touchedValue);
    }
    this.validateAndClampInputs();
    setTimeout(() => {
      this.isResetting = false;
      this.onValueChange();
    }, ANIMATION_DURATION);
  },
  resetValues(event) {
    var _a;
    const { min_input_name, max_input_name } = this.getFilterLabel();
    const minInputEl = document.querySelector(`input[name="${min_input_name}"]`);
    const maxInputEl = document.querySelector(`input[name="${max_input_name}"]`);
    const minParamName = (minInputEl == null ? void 0 : minInputEl.getAttribute("name")) || min_input_name;
    const maxParamName = (maxInputEl == null ? void 0 : maxInputEl.getAttribute("name")) || max_input_name;
    const eventDetail = (event == null ? void 0 : event.detail) || ((_a = this.$event) == null ? void 0 : _a.detail);
    const eventName = eventDetail == null ? void 0 : eventDetail.name;
    if (!eventName || // Reset all filters
    eventName === FILTER_PRICE || // Reset price filter
    eventName === minParamName || // Reset min price
    eventName === maxParamName) {
      this.isResetting = true;
      this.minValue = this.min;
      this.maxValue = this.max;
      if (minInputEl) {
        minInputEl.value = this.formatValue(this.min);
      }
      if (maxInputEl) {
        maxInputEl.value = this.formatValue(this.max);
      }
      setTimeout(() => {
        this.isResetting = false;
      }, ANIMATION_DURATION);
    }
  },
  getFilterLabel() {
    if (this.label === "Price") {
      return { min_input_name: "filter.v.price.gte", max_input_name: "filter.v.price.lte" };
    }
    return { min_input_name: "filter.p.m." + this.label.toLowerCase() + ".gte", max_input_name: "filter.p.m." + this.label.toLowerCase() + ".lte" };
  }
});
const Slider = () => ({
  isPrevBtnDisabled: true,
  isNextBtnDisabled: false,
  currentSlideIndex: 1,
  resizeObserver: null,
  slideWidth: null,
  config: {},
  autoplayInterval: null,
  thumbWidth: 100,
  thumbPosition: 0,
  totalSlides: 0,
  isDragging: false,
  dragOffsetX: 0,
  boundHandleDrag: null,
  boundEndDrag: null,
  isSliderNeeded: true,
  isNavigating: false,
  nextIndex: null,
  prevIndex: null,
  init() {
    const debouncedResizeHandler = Alpine.debounce(() => {
      this.updateCachedValues();
      this.handleManualScroll();
    }, 100);
    this.updateCachedValues();
    this.resizeObserver = new ResizeObserver(debouncedResizeHandler);
    this.resizeObserver.observe(this.$refs.slider);
    this.debouncedHandleManualScroll = Alpine.debounce(() => {
      this.handleManualScroll();
    }, 100);
    this.debouncedHandleManualScroll();
    this.totalSlides = this.$refs.slider.children.length;
    this.calculateThumbWidth();
    window.addEventListener("resize", this.calculateThumbWidth.bind(this));
  },
  startDrag(event) {
    event.preventDefault();
    const thumb = this.$refs.thumb;
    if (!thumb) return;
    this.$refs.slider.style.scrollSnapType = "none";
    thumb.style.transition = "none";
    const clientX = "touches" in event ? event.touches[0].clientX : event.clientX;
    const thumbRect = thumb.getBoundingClientRect();
    this.dragOffsetX = clientX - thumbRect.left;
    this.isDragging = true;
    this.boundHandleDrag = this.handleDrag.bind(this);
    this.boundEndDrag = this.endDrag.bind(this);
    document.addEventListener("mousemove", this.boundHandleDrag);
    document.addEventListener("mouseup", this.boundEndDrag);
    document.addEventListener("touchmove", this.boundHandleDrag);
    document.addEventListener("touchend", this.boundEndDrag);
  },
  handleDrag(event) {
    if (!this.config.isDragEnabled || !this.isDragging) return;
    const track = this.$refs.track;
    const thumb = this.$refs.thumb;
    if (!track || !thumb) return;
    this.$refs.slider.style.pointerEvents = "none";
    const clientX = "touches" in event ? event.touches[0].clientX : event.clientX;
    const trackRect = track.getBoundingClientRect();
    const thumbWidth = thumb.offsetWidth;
    const maxPosition = track.offsetWidth - thumbWidth;
    let newPosition = clientX - trackRect.left - this.dragOffsetX;
    newPosition = Math.max(0, Math.min(newPosition, maxPosition));
    this.thumbPosition = newPosition;
    const slider = this.$refs.slider;
    const scrollWidth = slider.scrollWidth - slider.clientWidth;
    const scrollLeft = newPosition / maxPosition * scrollWidth;
    slider.scrollTo({
      left: scrollLeft,
      behavior: "instant"
    });
    slider.scrollLeft = scrollLeft;
  },
  endDrag() {
    this.isDragging = false;
    this.$refs.slider.style.pointerEvents = "";
    if (this.boundHandleDrag) {
      document.removeEventListener("mousemove", this.boundHandleDrag);
      document.removeEventListener("touchmove", this.boundHandleDrag);
    }
    if (this.boundEndDrag) {
      document.removeEventListener("mouseup", this.boundEndDrag);
      document.removeEventListener("touchend", this.boundEndDrag);
    }
    const thumb = this.$refs.thumb;
    if (thumb) {
      thumb.style.transition = "";
    }
  },
  debouncedHandleManualScroll: () => {
  },
  configureAndStart(config) {
    if (config.isDragEnabled === void 0) {
      config.isDragEnabled = true;
    }
    this.config = config;
    this.slidesInView = this.getSlidesAmountInView();
    this.start();
    this.play();
    this.$nextTick(() => {
      this.updateProgressBar();
    });
  },
  play() {
    const { isAutoplay, autoplaySpeed = 5e3 } = this.config;
    if (!isAutoplay) {
      return;
    }
    if (this.autoplayInterval) {
      window.clearInterval(this.autoplayInterval);
    }
    this.autoplayInterval = window.setInterval(() => {
      if (this.currentSlideIndex < this.$refs.slider.childElementCount) {
        this.goToSlide(this.currentSlideIndex + 1);
      } else {
        this.goToSlide(1);
      }
    }, autoplaySpeed);
  },
  start() {
    const debouncedResizeHandler = Alpine.debounce(() => {
      this.updateCachedValues();
      this.handleManualScroll();
    }, 100);
    this.updateCachedValues();
    this.resizeObserver = new ResizeObserver(debouncedResizeHandler);
    this.resizeObserver.observe(this.$refs.slider);
    this.debouncedHandleManualScroll = Alpine.debounce(() => {
      this.handleManualScroll();
    }, 100);
    this.debouncedHandleManualScroll();
    const { gap } = this.config;
    const proxScrollTarget = (this.currentSlideIndex - 1) * ((this.slideWidth || 1) + gap);
    this.$refs.slider.scrollTo({
      left: proxScrollTarget,
      behavior: "smooth"
    });
  },
  destroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  updateCachedValues() {
    if (!this.$refs.slider) {
      return;
    }
    if (this.$refs.slider.childElementCount) {
      this.slideWidth = this.$refs.slider.children[0].offsetWidth;
    }
  },
  goToSlide(index, focus = false) {
    const { gap } = this.config;
    const maxIndex = this.$refs.slider.childElementCount;
    const validIndex = Math.max(1, Math.min(index, maxIndex));
    const proxScrollTarget = (validIndex - 1) * ((this.slideWidth || 1) + gap);
    this.$refs.slider.scrollTo({
      left: proxScrollTarget,
      behavior: Alpine.store("main").isReducedMotion ? "instant" : "smooth"
    });
    if (focus) {
      setTimeout(
        () => {
          const slide = this.$refs.slider.children[index - 1].querySelector(
            SELECTOR_LIST
          );
          slide.focus();
        },
        Alpine.store("main").isReducedMotion ? 0 : 500
      );
    }
    this.updateProgressBar();
    this.currentSlideIndex = validIndex;
  },
  showNextSlide() {
    if (this.isNavigating) return;
    this.isNavigating = true;
    const slidesInView = this.getSlidesAmountInView();
    const viewWidth = window.innerWidth;
    const adjustedSlidesInView = viewWidth < 640 ? Math.floor(slidesInView) : Math.ceil(slidesInView);
    this.nextIndex = Math.min(
      this.currentSlideIndex + adjustedSlidesInView,
      this.$refs.slider.childElementCount
    );
    this.updateProgressBar();
    this.goToSlide(this.nextIndex);
    this.play();
    setTimeout(() => {
      this.isNavigating = false;
    }, 100);
  },
  showPrevSlide() {
    if (this.isNavigating) return;
    this.isNavigating = true;
    const slidesInView = this.getSlidesAmountInView();
    this.prevIndex = Math.max(
      1,
      this.currentSlideIndex - Math.ceil(slidesInView)
    );
    this.updateProgressBar();
    this.goToSlide(this.prevIndex);
    this.play();
    setTimeout(() => {
      this.isNavigating = false;
    }, 100);
  },
  handleManualScroll() {
    if (!this.$refs.slider) return;
    const { gap } = this.config;
    const slideWidthWithGap = (this.slideWidth || 0) + gap;
    const containerScrollLeft = this.$refs.slider.scrollLeft;
    const maxScrollLeft = this.$refs.slider.scrollWidth - this.$refs.slider.clientWidth;
    const currentSlideIndex = Math.round(containerScrollLeft / slideWidthWithGap) + 1;
    this.currentSlideIndex = currentSlideIndex;
    this.isNextBtnDisabled = Math.abs(containerScrollLeft - maxScrollLeft) < 10;
    this.isPrevBtnDisabled = containerScrollLeft < 10;
    this.updateProgressBar();
  },
  getSlidesAmountInView() {
    const { slidesAmountInView } = this.config;
    const viewWidth = window.innerWidth;
    if (viewWidth >= 1536) return Math.floor(slidesAmountInView.xxl);
    if (viewWidth >= 1280) return Math.floor(slidesAmountInView.xl);
    if (viewWidth >= 1024) return Math.floor(slidesAmountInView.lg);
    if (viewWidth >= 768) return Math.floor(slidesAmountInView.md);
    if (viewWidth >= 640) return Math.floor(slidesAmountInView.sm);
    return Math.floor(slidesAmountInView.xs);
  },
  calculateThumbWidth() {
    const slider = this.$refs.slider;
    if (!slider) return;
    const scrollWidth = slider.scrollWidth;
    const clientWidth = slider.clientWidth;
    this.isSliderNeeded = scrollWidth > clientWidth;
    if (this.isSliderNeeded) {
      this.thumbWidth = clientWidth / scrollWidth * 100;
    } else {
      this.thumbWidth = 10;
    }
  },
  updateProgressBar() {
    const slider = this.$refs.slider;
    const track = this.$refs.track;
    const thumb = this.$refs.thumb;
    if (!slider || !track || !thumb) return;
    const scrollWidth = slider.scrollWidth - slider.clientWidth;
    const scrollLeft = slider.scrollLeft;
    const trackWidth = track.offsetWidth;
    const thumbWidth = thumb.offsetWidth;
    if (scrollWidth > 0) {
      this.thumbPosition = scrollLeft / scrollWidth * (trackWidth - thumbWidth);
    } else {
      this.thumbPosition = 0;
    }
  }
});
const TransitionImage = (props) => ({
  src: "",
  isImgLoaded: false,
  init() {
    if (!this.src) {
      this.isImgLoaded = true;
    }
    this.src = props.src;
    const { imageId: mainImageId } = props;
    const mainImage = document.getElementById(mainImageId);
    if (!mainImage) {
      return;
    }
    if (mainImage.complete) {
      this.isImgLoaded = true;
    } else {
      mainImage.addEventListener(
        "load",
        () => {
          this.isImgLoaded = true;
        },
        { once: true }
      );
    }
  }
});
const ZOOM_RATIO = 2;
const minScale = 1;
const maxScale = 3;
const getDistance = (touch1, touch2) => {
  const dx = touch1.clientX - touch2.clientX;
  const dy = touch1.clientY - touch2.clientY;
  return Math.sqrt(dx * dx + dy * dy);
};
const ImageZoom = () => ({
  previousTouches: null,
  scale: 1,
  translate: { x: 0, y: 0 },
  resetTimeoutRef: null,
  reset: false,
  init() {
    this.$watch("scale", () => {
      Alpine.store("main").opacityOnZoom = Math.max(2 - this.scale, 0);
    });
  },
  zoomImage(e) {
    if (Alpine.store("main").isMobile) {
      return;
    }
    const img = e.currentTarget.querySelector(
      "img:not(.transition-image)"
    );
    const overlayImage = document.createElement("img");
    overlayImage.setAttribute("src", img.src);
    const overlay = document.createElement("div");
    overlay.setAttribute("class", "zoomed-img");
    overlay.setAttribute("aria-hidden", "true");
    overlay.style.backgroundImage = `url('${img.src}')`;
    overlayImage.onload = () => {
      img.parentElement.insertBefore(overlay, img);
    };
    overlay.onclick = (event) => {
      event.stopPropagation();
      overlay.remove();
    };
    overlay.onmousemove = (event) => this.moveWithHover(img, event, overlay);
    overlay.onmouseleave = () => overlay.remove();
    this.moveWithHover(img, e, overlay);
  },
  moveWithHover(img, event, overlay) {
    const ratio = img.height / img.width;
    const container = event.currentTarget.getBoundingClientRect();
    const xPosition = event.clientX - container.left;
    const yPosition = event.clientY - container.top;
    const xPercent = `${xPosition / (img.clientWidth / 100)}%`;
    const yPercent = `${yPosition / (img.clientWidth * ratio / 100)}%`;
    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    overlay.style.backgroundSize = `${img.width * ZOOM_RATIO}px`;
  },
  onTouchStart(event) {
    if (event.touches.length === 2) {
      event.preventDefault();
      this.previousTouches = event.touches;
    }
  },
  onTouchMove(event) {
    if (event.touches.length === 2 && this.previousTouches) {
      event.preventDefault();
      const newDistance = getDistance(event.touches[0], event.touches[1]);
      const oldDistance = getDistance(
        this.previousTouches[0],
        this.previousTouches[1]
      );
      const scaleChange = newDistance / oldDistance;
      const newScale = Math.min(
        maxScale,
        Math.max(minScale, this.scale * scaleChange)
      );
      const midPoint = {
        x: (event.touches[0].clientX + event.touches[1].clientX) / 2,
        y: (event.touches[0].clientY + event.touches[1].clientY) / 2
      };
      const previousMidPoint = {
        x: (this.previousTouches[0].clientX + this.previousTouches[1].clientX) / 2,
        y: (this.previousTouches[0].clientY + this.previousTouches[1].clientY) / 2
      };
      const movementX = midPoint.x - previousMidPoint.x;
      const movementY = midPoint.y - previousMidPoint.y;
      if (event.currentTarget) {
        const rect = event.currentTarget.getBoundingClientRect();
        const xCenter = (rect.left + rect.right) / 2;
        const yCenter = (rect.top + rect.bottom) / 2;
        const xDiff = midPoint.x - xCenter;
        const yDiff = midPoint.y - yCenter;
        const scalingTranslateX = (this.translate.x - xDiff) * (newScale / this.scale) + xDiff;
        const scalingTranslateY = (this.translate.y - yDiff) * (newScale / this.scale) + yDiff;
        this.translate = {
          x: scalingTranslateX + movementX,
          y: scalingTranslateY + movementY
        };
      }
      this.scale = newScale;
      this.reset = false;
      this.previousTouches = event.touches;
    }
  },
  onTouchEnd() {
    this.previousTouches = null;
    this.resetAfterDelay();
  },
  onWheel(event) {
    if (!event.ctrlKey) {
      return;
    }
    event.preventDefault();
    const scaleChange = 1 - event.deltaY * 0.01;
    const newScale = Math.min(
      maxScale,
      Math.max(minScale, this.scale * scaleChange)
    );
    if (event.currentTarget) {
      const rect = event.currentTarget.getBoundingClientRect();
      const xCenter = (rect.left + rect.right) / 2;
      const yCenter = (rect.top + rect.bottom) / 2;
      const xDiff = event.clientX - xCenter;
      const yDiff = event.clientY - yCenter;
      const translateX = (this.translate.x - xDiff) * (newScale / this.scale) + xDiff;
      const translateY = (this.translate.y - yDiff) * (newScale / this.scale) + yDiff;
      this.translate = { x: translateX, y: translateY };
    }
    this.scale = newScale;
    this.reset = false;
    this.resetAfterDelay(true);
  },
  resetAfterDelay(wheel = false) {
    if (this.resetTimeoutRef !== null) {
      clearTimeout(this.resetTimeoutRef);
    }
    this.resetTimeoutRef = window.setTimeout(
      () => {
        this.scale = 1;
        this.translate = { x: 0, y: 0 };
        this.reset = true;
      },
      wheel ? 300 : 0
    );
  }
});
const AnnouncementBar = (announcements = [], autoRotateSeconds = 5) => ({
  announcements,
  currentIndex: 0,
  autoRotateInterval: null,
  autoRotateSeconds,
  direction: "next",
  init() {
    var _a;
    this.resetAutoRotate();
    if (this.$el.classList.contains("fixed")) {
      const height = this.$el.offsetHeight;
      document.documentElement.style.setProperty("--announcement-height", height + "px");
      (_a = document.getElementById("header")) == null ? void 0 : _a.style.setProperty("top", `${height}px`);
    }
  },
  nextAnnouncement() {
    if (this.currentIndex < this.announcements.length - 1) {
      this.direction = "next";
      setTimeout(() => {
        this.currentIndex++;
        this.resetAutoRotate();
      }, 50);
    }
  },
  prevAnnouncement() {
    if (this.currentIndex > 0) {
      this.direction = "prev";
      setTimeout(() => {
        this.currentIndex--;
        this.resetAutoRotate();
      }, 50);
    }
  },
  resetAutoRotate() {
    if (this.autoRotateInterval) clearInterval(this.autoRotateInterval);
    if (this.announcements.length > 1) {
      this.autoRotateInterval = setInterval(() => {
        this.direction = "next";
        this.currentIndex = this.currentIndex >= this.announcements.length - 1 ? 0 : this.currentIndex + 1;
      }, this.autoRotateSeconds * 1e3);
    }
  }
});
const Wishlist = () => ({
  toggleAddToCart(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const isInWishlist = button.getAttribute("data-in-wishlist") === "true";
    const productId = button.getAttribute("data-product-id");
    const variantId = button.getAttribute("data-variant-id");
    const productUrl = button.getAttribute("data-product-url");
    if (isInWishlist) {
      Alpine.store("wishlist").removeItem(button, productId, variantId);
      Alpine.store("wishlist").refreshContent(true);
    } else {
      if (window.SwymPageData) {
        if (window.SwymCallbacks) {
          window.SwymCallbacks.push(function(swat) {
            window.SwymPageData.et = 4;
            swat.addToWishList(window.SwymPageData, function() {
              swat.ui.showSuccessNotification({
                message: `<strong>${window.SwymPageData.dt}</strong> has been added to your wishlist!`
              });
              button.classList.add("in-wishlist");
              button.classList.remove("button--outline-secondary");
              button.classList.add("button--outline-danger");
              button.setAttribute("data-in-wishlist", "true");
              const outlineIcon = button.querySelector(".wishlist-icon-outline");
              const filledIcon = button.querySelector(".wishlist-icon-filled");
              if (outlineIcon && filledIcon) {
                outlineIcon.classList.add("hidden");
                filledIcon.classList.remove("hidden");
              }
              swat.fetch(function(products) {
                const count = products ? products.length : 0;
                Alpine.store("main").totalWishlistQty = count;
                wishListCounter.update(count);
                document.dispatchEvent(new CustomEvent("wishlist:updated", {
                  detail: { action: "add", product: window.SwymPageData }
                }));
                Alpine.store("wishlist").refreshContent(true);
              });
            });
          });
        }
      } else {
        const productData = {
          empi: productId,
          epi: variantId,
          du: productUrl,
          dt: button.getAttribute("data-product-title"),
          pr: button.getAttribute("data-product-price"),
          iu: button.getAttribute("data-product-image")
        };
        this.addToWishlist(productData);
      }
    }
  },
  checkWishlistStatus() {
    if (window.SwymCallbacks) {
      window.SwymCallbacks.push(function(swat) {
        swat.fetch(function(products) {
          const wishlistButtons = document.querySelectorAll(".add-to-wishlist-button");
          wishlistButtons.forEach(function(button) {
            const productId = button.getAttribute("data-product-id");
            const variantId = button.getAttribute("data-variant-id");
            const isInWishlist = products && products.some(function(p) {
              return p.empi == productId && p.epi == variantId;
            });
            if (isInWishlist) {
              button.classList.add("in-wishlist");
              button.classList.remove("button--outline-secondary");
              button.classList.add("button--outline-danger");
              button.setAttribute("data-in-wishlist", "true");
              const outlineIcon = button.querySelector(".wishlist-icon-outline");
              const filledIcon = button.querySelector(".wishlist-icon-filled");
              if (outlineIcon && filledIcon) {
                outlineIcon.classList.add("hidden");
                filledIcon.classList.remove("hidden");
              }
            }
          });
        });
      });
    }
  },
  addToWishlist(productData) {
    if (window.SwymCallbacks) {
      window.SwymCallbacks.push(function(swat) {
        const swymData = {
          empi: productData.empi,
          epi: productData.epi,
          du: productData.du,
          dt: productData.dt,
          pr: parseFloat(productData.pr) / 100,
          iu: productData.iu,
          qty: 1
        };
        swat.addToList(
          null,
          swymData,
          function() {
            swat.ui.showSuccessNotification({
              message: `<strong>${productData.dt}</strong> has been added to your wishlist!`
            });
            const button = document.querySelector(`.add-to-wishlist-button[data-product-id="${productData.empi}"][data-variant-id="${productData.epi}"]`);
            if (button) {
              button.classList.add("in-wishlist");
              button.classList.remove("button--outline-secondary");
              button.classList.add("button--outline-danger");
              button.setAttribute("data-in-wishlist", "true");
              const outlineIcon = button.querySelector(".wishlist-icon-outline");
              const filledIcon = button.querySelector(".wishlist-icon-filled");
              if (outlineIcon && filledIcon) {
                outlineIcon.classList.add("hidden");
                filledIcon.classList.remove("hidden");
              }
            }
            swat.fetch(function(products) {
              const count = products ? products.length : 0;
              Alpine.store("main").totalWishlistQty = count;
              wishListCounter.update(count);
              document.dispatchEvent(new CustomEvent("wishlist:updated", {
                detail: { action: "add", product: swymData }
              }));
              Alpine.store("wishlist").refreshContent(true);
            });
          },
          function(error) {
            console.error("Failed to add to wishlist:", error);
            let errorMessage = "Error adding to wishlist. ";
            if (error && typeof error === "object") {
              if (error.message) {
                errorMessage += error.message;
              } else if (error.error && error.error.fail_explanation) {
                errorMessage += error.error.fail_explanation;
              }
            }
            if (swat.ui && swat.ui.showErrorNotification) {
              swat.ui.showErrorNotification({
                message: errorMessage
              });
            }
          }
        );
      });
    }
  }
});
const Menu = (menuText = "Menu", backToText = "Back to", backToMenuText = "Back to Menu", previousText = "previous menu", expandedChildlinks = []) => ({
  history: ["main"],
  currentLevel: "main",
  expandedChildlinks,
  menuText,
  backToText,
  backToMenuText,
  previousText,
  goToLevel(level, parentTitle = "") {
    this.history.push({ id: level, parentTitle });
    this.currentLevel = level;
    this.expandedChildlinks = [];
  },
  goBack() {
    if (this.history.length > 1) {
      this.history.pop();
      const lastItem = this.history[this.history.length - 1];
      this.currentLevel = typeof lastItem === "object" ? lastItem.id : lastItem;
    }
  },
  resetMenu() {
    this.history = ["main"];
    this.currentLevel = "main";
    this.expandedChildlinks = [];
  },
  validateMenuState() {
    if (this.history.length === 0) {
      this.resetMenu();
      return;
    }
    const lastItem = this.history[this.history.length - 1];
    if (typeof lastItem === "object" && this.currentLevel !== lastItem.id) {
      this.currentLevel = lastItem.id;
    } else if (typeof lastItem === "string" && this.currentLevel !== lastItem) {
      this.currentLevel = lastItem;
    }
  },
  getHeaderTitle() {
    this.validateMenuState();
    if (this.history.length === 1) {
      return this.menuText;
    } else if (this.history.length === 2) {
      return this.backToMenuText;
    } else {
      const previousItem = this.history[this.history.length - 2];
      const parentTitle = typeof previousItem === "object" ? previousItem.parentTitle : this.previousText;
      return `${this.backToText} ${parentTitle}`;
    }
  },
  toggleChildlink(childlinkId) {
    if (this.expandedChildlinks.includes(childlinkId)) {
      this.expandedChildlinks = this.expandedChildlinks.filter((id) => id !== childlinkId);
    } else {
      this.expandedChildlinks.push(childlinkId);
    }
  },
  isChildlinkExpanded(childlinkId) {
    return this.expandedChildlinks.includes(childlinkId);
  }
});
const Form = (initialData = { formType: "login" }) => ({
  _formRef: null,
  _firstNameInput: null,
  _lastNameInput: null,
  _emailInput: null,
  _passwordInput: null,
  _submitButton: null,
  _firstNameError: null,
  _lastNameError: null,
  _emailError: null,
  _passwordError: null,
  _translatedErrors: initialData.translatedErrors || {},
  // Initialize reactive state properties
  isFormValid: false,
  isFirstNameValid: true,
  isLastNameValid: true,
  isEmailValid: true,
  isPasswordValid: true,
  firstNameError: "",
  lastNameError: "",
  emailError: "",
  passwordError: "",
  firstNameTouched: false,
  lastNameTouched: false,
  emailTouched: false,
  passwordTouched: false,
  init(refs = {}) {
    this._formRef = this.$el;
    this._firstNameInput = initialData.formType === "register" ? document.getElementById(
      "RegisterForm-FirstName"
    ) : null;
    this._lastNameInput = initialData.formType === "register" ? document.getElementById(
      "RegisterForm-LastName"
    ) : null;
    this._emailInput = document.getElementById(
      initialData.formType === "resetPassword" ? "RecoverEmail" : initialData.formType === "register" ? "RegisterForm-email" : "CustomerEmail"
    );
    this._passwordInput = initialData.formType === "resetPassword" ? null : document.getElementById(
      initialData.formType === "register" ? "RegisterForm-password" : "CustomerPassword"
    );
    this._submitButton = refs.submitButton;
    this._firstNameError = refs.firstNameError;
    this._lastNameError = refs.lastNameError;
    this._emailError = refs.emailError;
    this._passwordError = refs.passwordError;
    if (Object.keys(this._translatedErrors).length === 0) {
      this._loadTranslations();
    }
    if (this._firstNameInput && initialData.formType === "register") {
      this._firstNameInput.addEventListener("focus", () => {
        this.firstNameTouched = true;
      });
      this._firstNameInput.addEventListener("input", () => {
        if (this.firstNameTouched) {
          this._validateFirstName();
          this._updateFormValidity();
        }
      });
      this._firstNameInput.addEventListener("blur", () => {
        this.firstNameTouched = true;
        this._validateFirstName();
        this._updateFormValidity();
      });
    }
    if (this._lastNameInput && initialData.formType === "register") {
      this._lastNameInput.addEventListener("focus", () => {
        this.lastNameTouched = true;
      });
      this._lastNameInput.addEventListener("input", () => {
        if (this.lastNameTouched) {
          this._validateLastName();
          this._updateFormValidity();
        }
      });
      this._lastNameInput.addEventListener("blur", () => {
        this.lastNameTouched = true;
        this._validateLastName();
        this._updateFormValidity();
      });
    }
    if (this._emailInput) {
      this._emailInput.addEventListener("focus", () => {
        this.emailTouched = true;
      });
      this._emailInput.addEventListener("input", () => {
        if (this.emailTouched) {
          this._validateEmail();
          this._updateFormValidity();
        }
      });
      this._emailInput.addEventListener("blur", () => {
        this.emailTouched = true;
        this._validateEmail();
        this._updateFormValidity();
      });
    }
    if (this._passwordInput && initialData.formType !== "resetPassword") {
      this._passwordInput.addEventListener("focus", () => {
        this.passwordTouched = true;
      });
      this._passwordInput.addEventListener("input", () => {
        if (this.passwordTouched) {
          this._validatePassword();
          this._updateFormValidity();
        }
      });
      this._passwordInput.addEventListener("blur", () => {
        this.passwordTouched = true;
        this._validatePassword();
        this._updateFormValidity();
      });
    }
  },
  _loadTranslations() {
    const translationContainer = document.getElementById("translatedErrors");
    if (!translationContainer) {
      console.error("Translation container not found");
      return;
    }
    const translationElements = translationContainer.querySelectorAll("[data-error]");
    translationElements.forEach((el) => {
      const key = el.getAttribute("data-error");
      if (key) {
        this._translatedErrors[key] = el.textContent || "";
      }
    });
  },
  _validateFirstName() {
    if (!this._firstNameInput || initialData.formType !== "register")
      return true;
    const value = this._firstNameInput.value.trim();
    if (!value) {
      this.firstNameError = this._translatedErrors["firstName-required"];
      this.isFirstNameValid = false;
      return false;
    } else if (value.length < 2) {
      this.firstNameError = this._translatedErrors["firstName-tooShort"];
      this.isFirstNameValid = false;
      return false;
    }
    this.firstNameError = "";
    this.isFirstNameValid = true;
    return true;
  },
  _validateLastName() {
    if (!this._lastNameInput || initialData.formType !== "register")
      return true;
    const value = this._lastNameInput.value.trim();
    if (!value) {
      this.lastNameError = this._translatedErrors["lastName-required"];
      this.isLastNameValid = false;
      return false;
    } else if (value.length < 2) {
      this.lastNameError = this._translatedErrors["lastName-tooShort"];
      this.isLastNameValid = false;
      return false;
    }
    this.lastNameError = "";
    this.isLastNameValid = true;
    return true;
  },
  _validateEmail() {
    if (!this._emailInput) return false;
    const value = this._emailInput.value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      this.emailError = this._translatedErrors["email-required"];
      this.isEmailValid = false;
      return false;
    } else if (!emailRegex.test(value)) {
      this.emailError = this._translatedErrors["email-invalid"];
      this.isEmailValid = false;
      return false;
    }
    this.emailError = "";
    this.isEmailValid = true;
    return true;
  },
  _validatePassword() {
    if (!this._passwordInput || initialData.formType === "resetPassword")
      return true;
    const value = this._passwordInput.value;
    if (initialData.formType === "register") {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{8,}$/;
      if (!value) {
        this.passwordError = this._translatedErrors["password-required"];
        this.isPasswordValid = false;
        return false;
      } else if (!passwordRegex.test(value)) {
        this.passwordError = this._translatedErrors["password-invalid"];
        this.isPasswordValid = false;
        return false;
      }
    } else {
      if (!value) {
        this.passwordError = this._translatedErrors["password-required"];
        this.isPasswordValid = false;
        return false;
      }
    }
    this.passwordError = "";
    this.isPasswordValid = true;
    return true;
  },
  _updateFormValidity() {
    const validations = [];
    if (initialData.formType === "register") {
      validations.push(
        this.firstNameTouched ? this.isFirstNameValid : false,
        this.lastNameTouched ? this.isLastNameValid : false,
        this.emailTouched ? this.isEmailValid : false,
        this.passwordTouched ? this.isPasswordValid : false
      );
    } else if (initialData.formType === "login") {
      validations.push(
        this.emailTouched ? this.isEmailValid : false,
        this.passwordTouched ? this.isPasswordValid : false
      );
    } else if (initialData.formType === "resetPassword") {
      validations.push(this.emailTouched ? this.isEmailValid : false);
    }
    this.isFormValid = validations.every((valid) => valid);
  },
  _validateForm() {
    if (initialData.formType === "register") {
      this.firstNameTouched = true;
      this.lastNameTouched = true;
    }
    this.emailTouched = true;
    if (initialData.formType !== "resetPassword") {
      this.passwordTouched = true;
    }
    const isFirstNameValid = this._validateFirstName();
    const isLastNameValid = this._validateLastName();
    const isEmailValid = this._validateEmail();
    const isPasswordValid = this._validatePassword();
    this._updateFormValidity();
    if (initialData.formType === "register") {
      return isFirstNameValid && isLastNameValid && isEmailValid && isPasswordValid;
    } else if (initialData.formType === "login") {
      return isEmailValid && isPasswordValid;
    } else {
      return isEmailValid;
    }
  },
  async _handleSubmit(event) {
    if (!this._validateForm()) {
      event.preventDefault();
      return;
    }
    if (initialData.formType === "register" && this._formRef) {
      try {
        const formData = new FormData(this._formRef);
        const response = await fetch(this._formRef.action, {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json"
          }
        });
        if (response.ok) {
          const returnToInput = this._formRef.querySelector(
            'input[name="return_to"]'
          );
          const returnTo = (returnToInput == null ? void 0 : returnToInput.value) || "/account";
          window.location.href = returnTo;
        } else {
          const data = await response.json();
          if (data.errors) {
            if (data.errors["first_name"]) {
              this.firstNameError = data.errors["first_name"];
              this.isFirstNameValid = false;
            }
            if (data.errors["last_name"]) {
              this.lastNameError = data.errors["last_name"];
              this.isLastNameValid = false;
            }
            if (data.errors["email"]) {
              this.emailError = data.errors["email"];
              this.isEmailValid = false;
            }
            if (data.errors["password"]) {
              this.passwordError = data.errors["password"];
              this.isPasswordValid = false;
            }
            this._updateFormValidity();
          }
        }
      } catch (error) {
        console.error("Submission error:", error);
      }
    }
  }
});
const RegisterForm = (initialData = {}) => ({
  _formRef: null,
  _firstNameInput: null,
  _lastNameInput: null,
  _emailInput: null,
  _passwordInput: null,
  _submitButton: null,
  _firstNameError: null,
  _lastNameError: null,
  _emailError: null,
  _passwordError: null,
  _translatedErrors: initialData.translatedErrors || {},
  // Initialize reactive state properties
  isFormValid: false,
  isFirstNameValid: false,
  isLastNameValid: false,
  isEmailValid: false,
  isPasswordValid: false,
  firstNameError: "",
  lastNameError: "",
  emailError: "",
  passwordError: "",
  init() {
    this._formRef = this.$el;
    this._firstNameInput = document.getElementById(
      "RegisterForm-FirstName"
    );
    this._lastNameInput = document.getElementById(
      "RegisterForm-LastName"
    );
    this._emailInput = document.getElementById(
      "RegisterForm-email"
    );
    this._passwordInput = document.getElementById(
      "RegisterForm-password"
    );
    this._submitButton = this.$refs.submitButton;
    this._firstNameError = this.$refs.firstNameError;
    this._lastNameError = this.$refs.lastNameError;
    this._emailError = this.$refs.emailError;
    this._passwordError = this.$refs.passwordError;
    if (Object.keys(this._translatedErrors).length === 0) {
      this._loadTranslations();
    }
  },
  _loadTranslations() {
    const translationContainer = document.getElementById("translatedErrors");
    if (!translationContainer) {
      console.error("Translation container not found");
      return;
    }
    const translationElements = translationContainer.querySelectorAll("[data-error]");
    translationElements.forEach((el) => {
      const key = el.getAttribute("data-error");
      if (key) {
        this._translatedErrors[key] = el.textContent || "";
      }
    });
  },
  _validateFirstName() {
    if (!this._firstNameInput) return false;
    const value = this._firstNameInput.value.trim();
    if (!value) {
      this.firstNameError = this._translatedErrors["firstName-required"];
      this.isFirstNameValid = false;
      return false;
    } else if (value.length < 2) {
      this.firstNameError = this._translatedErrors["firstName-tooShort"];
      this.isFirstNameValid = false;
      return false;
    }
    this.firstNameError = "";
    this.isFirstNameValid = true;
    return true;
  },
  _validateLastName() {
    if (!this._lastNameInput) return false;
    const value = this._lastNameInput.value.trim();
    if (!value) {
      this.lastNameError = this._translatedErrors["lastName-required"];
      this.isLastNameValid = false;
      return false;
    } else if (value.length < 2) {
      this.lastNameError = this._translatedErrors["lastName-tooShort"];
      this.isLastNameValid = false;
      return false;
    }
    this.lastNameError = "";
    this.isLastNameValid = true;
    return true;
  },
  _validateEmail() {
    if (!this._emailInput) return false;
    const value = this._emailInput.value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      this.emailError = this._translatedErrors["email-required"];
      this.isEmailValid = false;
      return false;
    } else if (!emailRegex.test(value)) {
      this.emailError = this._translatedErrors["email-invalid"];
      this.isEmailValid = false;
      return false;
    }
    this.emailError = "";
    this.isEmailValid = true;
    return true;
  },
  _validatePassword() {
    if (!this._passwordInput) return false;
    const value = this._passwordInput.value;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{8,}$/;
    if (!value) {
      this.passwordError = this._translatedErrors["password-required"];
      this.isPasswordValid = false;
      return false;
    } else if (!passwordRegex.test(value)) {
      this.passwordError = this._translatedErrors["password-invalid"];
      this.isPasswordValid = false;
      return false;
    }
    this.passwordError = "";
    this.isPasswordValid = true;
    return true;
  },
  _updateFormValidity() {
    this.isFormValid = this.isFirstNameValid && this.isLastNameValid && this.isEmailValid && this.isPasswordValid;
  },
  _validateForm() {
    this._updateFormValidity();
    return this.isFormValid;
  },
  async _handleSubmit(event) {
    if (!this._formRef) return;
    if (!this._validateForm()) {
      event.preventDefault();
      return;
    }
    try {
      const formData = new FormData(this._formRef);
      const response = await fetch(this._formRef.action, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json"
        }
      });
      if (response.ok) {
        const returnToInput = this._formRef.querySelector(
          'input[name="return_to"]'
        );
        const returnTo = (returnToInput == null ? void 0 : returnToInput.value) || "/account";
        window.location.href = returnTo;
      } else {
        const data = await response.json();
        if (data.errors) {
          if (data.errors["first_name"]) {
            this.firstNameError = data.errors["first_name"];
            this.isFirstNameValid = false;
          }
          if (data.errors["last_name"]) {
            this.lastNameError = data.errors["last_name"];
            this.isLastNameValid = false;
          }
          if (data.errors["email"]) {
            this.emailError = data.errors["email"];
            this.isEmailValid = false;
          }
          if (data.errors["password"]) {
            this.passwordError = data.errors["password"];
            this.isPasswordValid = false;
          }
          this._updateFormValidity();
        }
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  }
});
const ProductCardWishlist = (product) => ({
  product,
  isInWishlist: false,
  isLoading: false,
  init() {
    if (this.product && this.product.id) {
      this.product.id = this.product.id.toString();
    }
    this.checkWishlistStatus();
    document.addEventListener("wishlist:item-added", () => {
      this.checkWishlistStatus();
    });
    document.addEventListener("wishlist:item-removed", () => {
      this.checkWishlistStatus();
    });
  },
  checkWishlistStatus() {
    var _a;
    if (!((_a = this.product) == null ? void 0 : _a.id)) return;
    const productId = this.getProductId();
    const variantId = this.getVariantId();
    if (!variantId) {
      return;
    }
    wishListUtils.withSwym((swat) => {
      swat.fetch((products) => {
        if (!products) return;
        const isInWishlist = products.some(
          (p) => p.empi == productId && p.epi == variantId
        );
        this.isInWishlist = isInWishlist;
      });
    });
  },
  getProductId() {
    var _a;
    const button = this.$el;
    const dataProductId = button == null ? void 0 : button.getAttribute("data-product-id");
    if (dataProductId) {
      return dataProductId;
    }
    const productId = (_a = this.product) == null ? void 0 : _a.id;
    return productId ? productId.toString() : "";
  },
  getVariantId() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    const button = this.$el;
    const dataVariantId = button == null ? void 0 : button.getAttribute("data-variant-id");
    if (dataVariantId) {
      return dataVariantId;
    }
    const variantId = ((_g = (_f = (_e = (_d = (_c = (_b = (_a = this.product.metafields) == null ? void 0 : _a.fastsimon) == null ? void 0 : _b.original_data) == null ? void 0 : _c.value) == null ? void 0 : _d.vra) == null ? void 0 : _e[0]) == null ? void 0 : _f[0]) == null ? void 0 : _g.toString()) || ((_i = (_h = this.product.selected_or_first_available_variant) == null ? void 0 : _h.id) == null ? void 0 : _i.toString()) || ((_l = (_k = (_j = this.product.variants) == null ? void 0 : _j[0]) == null ? void 0 : _k.id) == null ? void 0 : _l.toString()) || ((_n = (_m = this.product.first_available_variant) == null ? void 0 : _m.id) == null ? void 0 : _n.toString());
    return variantId;
  },
  toggleWishlist() {
    if (this.isLoading) return;
    const productId = this.getProductId();
    const variantId = this.getVariantId();
    const productUrl = `${window.location.origin}${this.product.url}`;
    if (!variantId) {
      this.isLoading = false;
      return;
    }
    if (!productId) {
      this.isLoading = false;
      return;
    }
    this.isLoading = true;
    wishListUtils.withSwym((swat) => {
      if (this.isInWishlist) {
        swat.fetch((products) => {
          const product2 = products == null ? void 0 : products.find(
            (p) => p.empi == productId && p.epi == variantId
          );
          if (product2) {
            swat.removeFromWishList(product2, () => {
              this.isInWishlist = false;
              this.isLoading = false;
              swat.ui.showSuccessNotification({
                message: `<strong>${product2.dt}</strong> has been removed from your wishlist!`
              });
              Alpine.store("wishlist").refreshContent(true);
            });
          } else {
            this.isLoading = false;
          }
        });
      } else {
        const swymData = {
          empi: productId,
          epi: variantId,
          du: productUrl,
          dt: this.product.title || "Product",
          pr: this.product.price || 0,
          iu: this.product.featured_image || "",
          qty: 1
        };
        if (window.SwymPageData) {
          window.SwymPageData.empi = productId;
          window.SwymPageData.epi = variantId;
          window.SwymPageData.du = productUrl;
          window.SwymPageData.dt = this.product.title || "Product";
          window.SwymPageData.pr = this.product.price || 0;
          window.SwymPageData.iu = this.product.featured_image || "";
          window.SwymPageData.qty = 1;
          window.SwymPageData.et = 4;
          swat.addToWishList(window.SwymPageData, () => {
            this.isInWishlist = true;
            this.isLoading = false;
            swat.ui.showSuccessNotification({
              message: `<strong>${this.product.title || "Product"}</strong> has been added to your wishlist!`
            });
            Alpine.store("wishlist").refreshContent(true);
          });
        } else {
          window.SwymPageData = {
            ...swymData,
            et: 4
            // Event type for add to wishlist
          };
          swat.addToWishList(window.SwymPageData, () => {
            this.isInWishlist = true;
            this.isLoading = false;
            Alpine.store("wishlist").refreshContent(true);
          });
        }
      }
    });
  }
});
const SocialAuthNotifications = () => ({
  // State
  showLoginNotification: false,
  showRegisterNotification: false,
  showPasswordResetNotification: false,
  // Configuration
  AUTH_PAGES: ["/account/login", "/account/register"],
  ACCOUNT_PAGE: "/account",
  SESSION_KEYS: {
    VISIT_HISTORY: "page_visit_history",
    LAST_AUTH_PAGE: "last_auth_page",
    NOTIFICATION_SHOWN: "social_login_notification_shown"
  },
  sessionTimeout: 12e4,
  // 2 minutes
  /**
   * Initialize the social auth notification system
   */
  init() {
    this.trackPageVisit();
    this.detectSocialAuth();
    this.setupEventListeners();
  },
  /**
   * Track the current page visit for auth context
   */
  trackPageVisit() {
    const currentPath = window.location.pathname;
    const timestamp = Date.now();
    const visitHistory = this.getVisitHistory();
    visitHistory.push({ path: currentPath, timestamp });
    if (visitHistory.length > 5) {
      visitHistory.shift();
    }
    sessionStorage.setItem(this.SESSION_KEYS.VISIT_HISTORY, JSON.stringify(visitHistory));
    if (this.isAuthPage(currentPath)) {
      sessionStorage.setItem(this.SESSION_KEYS.LAST_AUTH_PAGE, currentPath);
    }
  },
  /**
   * Detect social authentication and show appropriate notification
   */
  detectSocialAuth() {
    if (window.location.pathname !== this.ACCOUNT_PAGE) {
      return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("action")) {
      return;
    }
    if (this.hasShownNotification()) {
      return;
    }
    const authType = this.determineSocialAuthType();
    if (authType) {
      this.showNotification(authType);
    }
  },
  /**
   * Determine if this was a social registration or login
   */
  determineSocialAuthType() {
    const referrer = document.referrer;
    const recentVisits = this.getRecentVisits();
    const allVisits = this.getVisitHistory();
    const lastAuthPage = sessionStorage.getItem(this.SESSION_KEYS.LAST_AUTH_PAGE);
    if (referrer && this.containsAuthPage(referrer)) {
      const isRegistration = referrer.includes("/account/register");
      return isRegistration ? "register" : "login";
    }
    if (recentVisits.some((visit) => this.isAuthPage(visit.path))) {
      const isRegistration = lastAuthPage === "/account/register";
      return isRegistration ? "register" : "login";
    }
    const fiveMinutesAgo = Date.now() - 3e5;
    const recentAuthVisits = allVisits.filter(
      (visit) => this.isAuthPage(visit.path) && visit.timestamp > fiveMinutesAgo
    );
    if (recentAuthVisits.length > 0) {
      const lastAuthVisit = recentAuthVisits[recentAuthVisits.length - 1];
      const isRegistration = lastAuthVisit.path === "/account/register";
      return isRegistration ? "register" : "login";
    }
    if (recentVisits.length <= 1 && !referrer && lastAuthPage) {
      const isRegistration = lastAuthPage === "/account/register";
      return isRegistration ? "register" : "login";
    }
    if (referrer && !referrer.includes(window.location.hostname) && allVisits.length <= 2) {
      const hasRecentRegisterVisit = allVisits.some(
        (visit) => visit.path === "/account/register" && Date.now() - visit.timestamp < 6e5
        // 10 minutes
      );
      const authType = hasRecentRegisterVisit ? "register" : "login";
      return authType;
    }
    return null;
  },
  /**
   * Show notification for the given auth type
   */
  showNotification(authType) {
    if (authType === "register") {
      this.showRegisterNotification = true;
    } else {
      this.showLoginNotification = true;
    }
    this.markNotificationShown();
    setTimeout(() => {
      this.showLoginNotification = false;
      this.showRegisterNotification = false;
    }, 5e3);
  },
  /**
   * Setup additional event listeners
   */
  setupEventListeners() {
    window.addEventListener("focus", () => {
      this.detectSocialAuth();
    });
  },
  /**
   * Mark that notification has been shown
   */
  markNotificationShown() {
    sessionStorage.setItem(this.SESSION_KEYS.NOTIFICATION_SHOWN, "true");
    setTimeout(() => {
      sessionStorage.removeItem(this.SESSION_KEYS.NOTIFICATION_SHOWN);
    }, this.sessionTimeout);
  },
  /**
   * Check if notification has already been shown
   */
  hasShownNotification() {
    return sessionStorage.getItem(this.SESSION_KEYS.NOTIFICATION_SHOWN) === "true";
  },
  /**
   * Get visit history from session storage
   */
  getVisitHistory() {
    const history2 = sessionStorage.getItem(this.SESSION_KEYS.VISIT_HISTORY);
    return history2 ? JSON.parse(history2) : [];
  },
  /**
   * Get recent visits (within 30 seconds)
   */
  getRecentVisits() {
    const visitHistory = this.getVisitHistory();
    const now = Date.now();
    return visitHistory.filter((visit) => now - visit.timestamp < 3e4);
  },
  /**
   * Check if path is an authentication page
   */
  isAuthPage(path) {
    return this.AUTH_PAGES.includes(path);
  },
  /**
   * Check if URL contains authentication page
   */
  containsAuthPage(url) {
    return this.AUTH_PAGES.some((page) => url.includes(page));
  },
  /**
   * Clear all authentication tracking data (call on logout)
   */
  clearAuthData() {
    Object.values(this.SESSION_KEYS).forEach((key) => {
      sessionStorage.removeItem(key);
    });
    this.showLoginNotification = false;
    this.showRegisterNotification = false;
  },
  /**
   * Public method to manually trigger notification (for testing)
   */
  triggerNotification(authType) {
    this.showNotification(authType);
  }
});
const BreadcrumbStore = {
  breadcrumbs: [],
  addBreadcrumb(title, url) {
    this.breadcrumbs.push({ title, url });
    localStorage.setItem("lastVisitedCollection", JSON.stringify(this.breadcrumbs));
  },
  exec(collection, parents, filters) {
    this.clear();
    if (parents) {
      for (const parent of parents) {
        this.addBreadcrumb(parent.title, parent.url);
      }
    }
    this.addBreadcrumb(collection.title, collection.url + filters);
  },
  getBreadcrumbs() {
    return this.breadcrumbs;
  },
  clear() {
    this.breadcrumbs = [];
    localStorage.removeItem("lastVisitedCollection");
  },
  setProductBreadcrumbs(productColls, productSubcol) {
    if (this.cameFromCollection() && this.cameFromRelativeCollection()) {
      return;
    }
    this.clear();
    if (productColls && productColls.length > 0) {
      for (const coll of productColls) {
        if (!coll.url && coll.hasOwnProperty("sort_order")) {
          coll.url = `/collections/${coll.handle}`;
        }
        this.addBreadcrumb(coll.title, coll.url);
      }
    }
    if (productSubcol) {
      if (!productSubcol.url && productSubcol.hasOwnProperty("sort_order")) {
        productSubcol.url = `/collections/${productSubcol.handle}`;
      }
      this.addBreadcrumb(productSubcol.title, productSubcol.url);
    }
  },
  cameFromRelativeCollection() {
    var _a;
    if (!this.breadcrumbs.length) return false;
    const lastStoredColl = (_a = this.breadcrumbs[this.breadcrumbs.length - 1]) == null ? void 0 : _a.url;
    const currProdColl = window.currProdColl || [];
    const productColls = currProdColl.some(
      (colUrl) => colUrl === lastStoredColl
    );
    return productColls;
  },
  // Check if user came from a collection page
  cameFromCollection() {
    const referrer = document.referrer;
    if (!referrer) return false;
    try {
      const referrerUrl = new URL(referrer);
      const currentUrl = new URL(window.location.href);
      if (referrerUrl.hostname !== currentUrl.hostname) return false;
      return referrerUrl.pathname.includes("/collections/");
    } catch (e) {
      return false;
    }
  },
  init() {
    const saved = localStorage.getItem("lastVisitedCollection");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          this.breadcrumbs = parsed;
        }
      } catch (e) {
        localStorage.removeItem("lastVisitedCollection");
        this.breadcrumbs = [];
      }
    }
    if (this.breadcrumbs.length === 0) {
      this.breadcrumbs = [{
        title: "Products",
        url: "/collections/all"
      }];
    }
  }
};
const iOSFocusUtils = {
  /**
   * Attempts to focus an element with iOS-specific handling
   * @param selector - CSS selector for the element to focus
   * @param options - Configuration options
   */
  focusElement: (selector, options = {}) => {
    const {
      maxAttempts = 5,
      delays = [0, 50, 100, 200, 300],
      clickOnFocus = true,
      selectText = true
    } = options;
    const focusAttempts = delays.slice(0, maxAttempts);
    focusAttempts.forEach((delay) => {
      setTimeout(() => {
        const element = document.querySelector(selector);
        if (element && document.activeElement !== element) {
          element.focus();
          if (element instanceof HTMLInputElement) {
            if (clickOnFocus) {
              element.click();
            }
            if (selectText) {
              element.setSelectionRange(0, element.value.length);
            }
          }
          if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
            element.dispatchEvent(new Event("input", { bubbles: true }));
          }
        }
      }, delay);
    });
  },
  /**
   * Focuses a search input with iOS-specific optimizations
   * @param selector - CSS selector for the search input
   */
  focusSearchInput: (selector) => {
    if (iOSFocusUtils.isIOSSafari()) {
      iOSFocusUtils.focusElement(selector, {
        maxAttempts: 8,
        delays: [0, 25, 75, 150, 250, 350, 450, 550],
        clickOnFocus: true,
        selectText: true
      });
    } else {
      iOSFocusUtils.focusElement(selector, {
        maxAttempts: 3,
        delays: [0, 50, 150],
        clickOnFocus: true,
        selectText: true
      });
    }
  },
  /**
   * Checks if the current device is iOS
   */
  isIOS: () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  },
  /**
   * Checks if the current browser is Safari on iOS
   */
  isIOSSafari: () => {
    return iOSFocusUtils.isIOS() && /Safari/.test(navigator.userAgent) && !/CriOS|FxiOS|OPiOS|mercury/.test(navigator.userAgent);
  },
  /**
   * Focuses an element after a popup transition with iOS-specific timing
   * @param selector - CSS selector for the element to focus
   */
  focusAfterPopupTransition: (selector) => {
    setTimeout(() => {
      iOSFocusUtils.focusSearchInput(selector);
    }, 100);
  }
};
let Sunrise = {
  updateQuantity(line, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: qty, line })
    }).then((response) => response.json()).then((data) => {
      window.dispatchEvent(new Event("cart-updated"));
    }).catch((error) => {
      console.error("Error:", error);
    });
  }
};
window.Sunrise = Sunrise;
document.addEventListener("alpine:init", () => {
  Alpine.plugin(Portal);
  Alpine.plugin(StickyScroll);
  Alpine.plugin(module_default$1);
  Alpine.plugin(module_default);
  Alpine.plugin(TransitionPlugin);
  Alpine.plugin(ElementIntersection);
  Alpine.plugin(Pagination);
  Alpine.plugin(Accessibility);
  Alpine.store("popup", PopupStore);
  Alpine.store("main", Main);
  Alpine.store("resizable", ResizableStore);
  Alpine.store("productList", ProductListStore);
  Alpine.store("cart", CartStore);
  Alpine.store("wishlist", WishlistStore);
  Alpine.store("ringBuilder", RingBuilderStore);
  Alpine.store("fastSimon", FastSimonStore);
  Alpine.store("breadcrumbs", BreadcrumbStore);
  Alpine.store("iosFocus", iOSFocusUtils);
  Alpine.data("TransitionPreview", TransitionPreview);
  Alpine.data("BeforeAfter", BeforeAfter);
  Alpine.data("ProductList", ProductList);
  Alpine.data("DiamondSearch", DiamondSearch);
  Alpine.data("ProductPage", ProductPage);
  Alpine.data("Dropdown", Dropdown);
  Alpine.data("Search", Search);
  Alpine.data("Accordion", Accordion);
  Alpine.data("Address", Address);
  Alpine.data("RangeSlider", RangeSlider);
  Alpine.data("Slider", Slider);
  Alpine.data("TransitionImage", TransitionImage);
  Alpine.data("ImageZoom", ImageZoom);
  Alpine.data("AnnouncementBar", AnnouncementBar);
  Alpine.data("Wishlist", Wishlist);
  Alpine.data("Menu", Menu);
  Alpine.data("Form", Form);
  Alpine.data("RegisterForm", RegisterForm);
  Alpine.data("ProductCardWishlist", ProductCardWishlist);
  Alpine.data("FastSimon", FastSimon);
  Alpine.data("SocialAuthNotifications", SocialAuthNotifications);
});
document.addEventListener("DOMContentLoaded", () => {
  initTransitionView();
  const globalSocialAuth = SocialAuthNotifications();
  globalSocialAuth.trackPageVisit();
  window.socialAuthNotifications = globalSocialAuth;
});
